<template>
  <div style="background:#fff;" class="policeLato">
    <!--PARITE HEADER AVEC IMAGES AVEC PARALAX DE L'IMAGE-->
    <section v-if="isDesktop()">
      <div class="mt-5 pt-5 paralax-cover-image has-background-dim">
        <p class="paralax-cover-image-text">
        <div class="content_home" style="z-index: 1!important;">
          <h1 style="font-size: 70px" class="font-weight-bold"><span style="color: #fff">{{
            $t('espace_perso.header_title[0]') }}</span></h1>
          <h1 style="font-size: 70px;margin-top: -30px" class="font-weight-bold"><span style="color: #ffa409"
              class="ml-1">{{ $t('espace_perso.header_title[1]') }}</span></h1>
        </div>
        </p>
      </div>
    </section>

    <!--PARITE HEADER AVEC IMAGES AVEC PARALAX DE L'IMAGE-->
    <section class="mt-5" v-if="isMobile()">
      <div class="paralax-cover-image_mobile has-background-dim_mobile">
        <p class="paralax-cover-image-text_mobile">
        <div class="content_home" style="z-index: 1!important;margin-top: 10%">
          <h1 style="font-size: 40px" class="font-weight-bold"><span style="color: #fff">{{
            $t('espace_perso.header_title[0]') }}</span></h1>
          <h1 style="font-size: 40px;margin-top: -20px;color: #ffa409" class="font-weight-bold"><span>{{
            $t('espace_perso.header_title[1]') }}</span></h1>
        </div>
        </p>
      </div>
    </section>

    <div class="content" style="margin-top: 5%;margin-bottom: 5%;transition: margin-left 300ms;margin-left: 10%;margin-right: 10%;">
      <main>
        <div v-if="isDesktop()">
            <!-- Profile Section -->
          <div class="mobile-profile-section" style="background: #f8f9fa; border-radius: 15px; margin-bottom: 20px;">
            <div class="align-items-center mb-3" style="display: flex;">
              <div class="profile-avatar" style="width:60px;height: 60px; background: #6c757d; border-radius: 50%; display: flex; align-items: center; justify-content: center; margin-right: 15px;">
                <i class="fa fa-user" style="color: white; font-size: 24px;"></i>
              </div>
              <div>
                <h3 style="margin: 0; font-size: 18px; font-weight: 500;;">{{ $t('espace_perso.bonjour') }},</h3>
                <h3 style="margin: 0; font-size: 18px; font-weight: 500; color: #ffa409;">{{ username }}</h3>
              </div>
            </div>
            <!-- Code de parrainage -->
            <div v-if="userInfos.code_parrain" class="parrainage-code" style="background: white;width:200px;  border-radius: 10px; padding: 15px; margin-bottom: 15px;">
              <div class="justify-content-between align-items-center" style="display: flex;">
                <div>
                  <small style="color: #6c757d; font-size: 12px;">{{ $t('espace_perso.code_parrainage_label') }} :</small>
                  <div style="font-weight: 500; color: #ffa409; font-size: 16px;">{{ this.userInfos.code_parrain }}</div>
                </div>
                <button @click="copyToClipboard" class="btn btn-sm" style="background: #f8f9fa; border: 1px solid #dee2e6; border-radius: 8px; padding: 8px 12px;margin-top: 25px;">
                  <i class="fa fa-copy" style="margin-right: 5px;"></i>
                  {{ $t('espace_perso.copie_label') }}
                </button>
              </div>
            </div>
            </div>

            
          <!-- <div class="user-name">
            {{ $t('espace_perso.bonjour') }}, <span class="font-weight-bold" style="color: #ffa409">
              {{ username }}
            </span>
          </div>
          
          <div class="mb-5 user-name" v-if="this.userInfos.code_parrain">
            {{ $t('espace_perso.code_parrainage_label') }} : <span class="font-weight-bold" style="color: #ffa409">
              {{ this.userInfos.code_parrain }} <button @click="copyToClipboard" style="color: #000;font-weight: 500;"
                class="btn ml-3"><i class="material-icons" aria-hidden="true" data-nosnippet>&#xe14d;</i> {{ $t('espace_perso.copie_label')
                }}</button>
            </span>


            <div class="user-name" v-if="coupon_parrainage">
                <span v-if="coupon_parrainage.type = 'pourcentage'"
                  style="font-weight: 500;font-size: 15px;float: right;">{{
                    $t('espace_perso.parrainage.parrainage_bonus_text[0]') }} {{ coupon_parrainage.reduction }} {{
                    $t('espace_perso.parrainage.parrainage_bonus_text[1]') }}</span>
                <span v-else style="font-weight: 500;font-size: 15px;float: right;">{{
                  $t('espace_perso.parrainage.parrainage_bonus_text[0]') }} {{ coupon_parrainage.reduction }} {{
                    $t('espace_perso.parrainage.parrainage_bonus_text[2]') }}</span>
            </div>
          </div> -->


                    <div class="tabs">
  <!-- :disabled="userInfos.sexe !='entreprise'" -->
  <input type="radio" id="tab1" name="tab-control" @click="checkEspaceAccess()" checked>
  <input type="radio" id="tab2" name="tab-control" @click="checkOrganisationAccess()">
  <ul>
      <li title="Features">
          <label for="tab1" role="button">
            <svg viewBox="0 0 24 24"><path d="M12,4A4,4 0 0,1 16,8A4,4 0 0,1 12,12A4,4 0 0,1 8,8A4,4 0 0,1 12,4M12,14C16.42,14 20,15.79 20,18V20H4V18C4,15.79 7.58,14 12,14Z" /></svg><br>
            <span>{{ $t('espace_perso.mon_organisation.mon_espace_perso_label') }}</span>
          </label>
      </li>
      <li title="Mon organisation">
          <label for="tab2" role="button">
            <svg viewBox="0 0 24 24"><path d="M12,7V3H2v18h20V7H12z M6,19H4v-2h2V19z M6,15H4v-2h2V15z M6,11H4V9h2V11z M6,7H4V5h2V7z M10,19H8v-2h2V19z M10,15H8v-2h2 V15z M10,11H8V9h2V11z M10,7H8V5h2V7z M20,19h-8v-2h2v-2h-2v-2h2v-2h-2V9h8V19z M18,11h-2v2h2V11z M18,15h-2v2h2V15z"/></svg><br>
            <span>{{ $t('espace_perso.mon_organisation.mon_organisation_label') }}</span>
          </label>
      </li>
      <li></li>
      <li></li>
  </ul>
  
  <div class="slider"><div class="indicator"></div></div>
  <div class="content">
    <section>
        <!-- ===================    DEBUT DE LA PARTIE UNIQUEMENT POUR LE DESKTOP      =============== -->
        <!-- =                      SACHANT QUE LE CODE EST ASSEZ LONG, IL CONVIENT                  = -->
        <!-- =                      DE BIEN INDENTER LE CODE POUR UNE BONNE LISIBILITE               = -->
        <!-- ========================================================================================= -->
        <div v-responsive.lg.xl class="cards" v-if="isDesktop()">
          <!-- ========= Cards parrainage ========= -->
          <div class="card-single img-icone" @click="view_my_parrainages()">
            <div>
              <h2>{{ nb_parrainer }}</h2>
              <small>{{ $t('espace_perso.card_parrainage_label') }}</small>
            </div>
            <div>
              <span>
                <img style="margin-top: -25px;" src="../../assets/img/inheritance.png" alt="inheritance" width="45">
              </span>
              <!-- <span class="fa fa-file-text"></span> -->
            </div>
          </div>
          <!-- ========= Cards contrats ========= -->
          <div class="card-single" @click="view_MyContract()">
            <div>
              <span class="tool"
                data-tip="Alerte : Vous avez des contrats qui arrivent bientôt à terme, veuillez vérifier !"
                tabindex="1" style="margin-top: -20px;position: absolute;">
                <img v-if="this.alert" class="alert_img" src="../../assets/img/devis/alert.png" width="30" alt="alert-icon">
                <span class="font-weight-bold" style="font-size: 15px;color: red!important" v-if="this.alert">{{ nombre
                }}</span>
              </span>
              <h2>{{ userContrat.length }}</h2>
              <small>{{ $t('espace_perso.contrat') }}</small>
            </div>
            <div>
              <span class="fa fa-file-text"></span>
            </div>
          </div>
          <!-- ========= Cards devis ========= -->
          <div class="card-single" @click="view_MyDevis_item_list()">
            <div>
              <h2>{{ nbDevis }}</h2>
              <small>{{ $t('espace_perso.devis') }}</small>
            </div>
            <div>
              <span class="fa fa-files-o"></span>
            </div>
          </div>
          <!-- ========= Cards assistance ========= -->
          <div class="card-single-assistance" @click="assistanceDialogManip()">
            <div style="margin-top: 37px;">
              <small>{{ $t('espace_perso.assistance') }}</small>
            </div>
            <div>
              <span class="fa fa-phone"></span>
            </div>
          </div>


            <!-- ========= Demande de remise ========= -->
          <!-- <div v-show="userInfos.sexe =='entreprise'" class="card-single" @click="view_MyDiscountRequest()">
            <div>
              <h2>{{ discountData.length }}</h2>
              <small>{{
                $t('espace_perso.demande_remise.demande_remise_label') }}</small>
            </div>
            <div>
              <span class="fa fa-percent"></span>
            </div>
          </div> -->

          
          <div class="card-single">
            <div>
              <h2 v-if="UserPoints > 0">{{UserPoints}}</h2>
              <h2 v-else>0</h2>
              <small>{{ $t('espace_perso.assur_club') }}</small>
            </div>
            <div>
              <span class="fa fa-star"></span>
            </div>
          </div>
          <!-- ============================================ -->

          <!-- ========= Cards profile ========= -->
          <div class="card-single" @click="ViewMyProfil()">
            <div class="no-value">
              <small>{{ $t('espace_perso.profil') }}</small>
            </div>
            <div>
              <span class="fa fa-user"></span>
            </div>
          </div>


          <!-- ========= Cards Portefeuille ========= -->
          <div class="card-single" @click="goToPortefeuille()">
            <div class="no-value">
              <small>{{ $t('espace_perso.portefeuille') }}</small>
            </div>
            <div>
              <span class="fa fa-briefcase"></span>
            </div>
          </div>

          <!-- ========= Cards assur'club ========= -->
          <!-- <div class="card-single-grey">
            <div class="no-value">
              <small>{{ $t('espace_perso.assur_club') }}</small>
            </div>
            <div>
              <span class="fa fa-heart"></span>
            </div>
          </div> -->

            <!-- <div v-show="userInfos.sexe =='homme' || userInfos.sexe =='femme'" class="card-single" @click="dialogMesPoints = true">
            <div>
              <h2 v-if="UserPoints > 1">{{ UserPoints }}</h2>
              <h2 v-if="UserPoints == 1">{{ UserPoints }}</h2>
              <small>{{ $t('espace_perso.assur_club') }}</small>
            </div>
            <div>
              <span class="fa fa-star"></span>
            </div>
          </div> -->

          <!-- ========= Cards sinistre ========= -->
          <div class="card-single-assistance" @click="goToSinistre()">
            <div>
              <h4 v-if="userSinistre.length > 0" style="color:#fff">{{ userSinistre.length }}</h4>
               <h4 v-else style="color:#fff">0</h4>
              <small>{{ $t('espace_perso.sinistre') }}</small>
            </div>
            <div>
              <span class="fa fa-exclamation-triangle"></span>
            </div>
          </div>

          <!-- ========= Cards points ========= -->
          <!-- <div  v-show="userInfos.sexe =='entreprise'" class="card-single" @click="dialogMesPoints = true">
            <div>
              <h2 v-if="UserPoints > 1">{{ UserPoints }}</h2>
              <h2 v-if="UserPoints == 1">{{ UserPoints }}</h2>
              <small>{{ $t('espace_perso.assur_club') }}</small>
            </div>
            <div>
              <span class="fa fa-star"></span>
            </div>
          </div> -->
          <!-- <div class="card-single-assistance" @click="view_MyDiscountRequest()">
            <div style="margin-top: 37px;">
              <small>Demande de remise</small>
            </div>
            <div>
              <span class="fa fa-percent"></span>
            </div>
          </div> -->
        </div>
    </section>
    <section>
       <!-- ===================    DEBUT DE LA PARTIE UNIQUEMENT POUR LE DESKTOP      =============== -->
        <!-- =                      SACHANT QUE LE CODE EST ASSEZ LONG, IL CONVIENT                  = -->
        <!-- =                      DE BIEN INDENTER LE CODE POUR UNE BONNE LISIBILITE               = -->
        <!-- ========================================================================================= -->
        <div v-responsive.lg.xl class="cards" v-if="isDesktop()">
            <!-- ========= Demande de remise ========= -->
             <div v-show="userInfos.sexe =='entreprise'" class="card-single" @click="view_MyDiscountRequest()">
              <div>
                <h2 v-if="discountData.length > 0">{{ discountData.length }}</h2>
                <h2 v-else>0</h2>
                <small>{{
                  $t('espace_perso.demande_remise.demande_remise_label') }}</small>
              </div>
              <div>
                <span class="fa fa-percent"></span>
              </div>
            </div>

             <!-- ========= Flotte automobile ========= -->
              <div v-show="userInfos.sexe =='entreprise'" class="card-single">
              <div>
                <h2>0</h2>
                <small>
                  {{
                  $t('espace_perso.demande_remise.Flotte_automobile_label') }}</small>
              </div>
              <div>
                <span class="fa fa-car"></span>
              </div>
            </div>


             <!-- ========= Bénéficiaire ========= -->
              <div v-show="userInfos.sexe =='entreprise'" class="card-single">
              <div>
                <h2>0</h2>
                <small>{{$t('espace_perso.demande_remise.beneficiary_label') }} : <span style="font-size:12px">{{$t('espace_perso.demande_remise.beneficiary_label_plus') }}</span></small>
              </div>
              <div>
                <span class="fa fa-users"></span>
              </div>
            </div>
        </div>
        <div v-if="isDesktop() && userInfos.sexe != 'entreprise'">
          <p class="text-center">{{$t('espace_perso.mon_organisation.mon_organisation_content[0]') }}.<br>{{$t('espace_perso.mon_organisation.mon_organisation_content[1]') }}</p>
        </div>
         
    </section>
  </div>
</div>
          


        </div>

        <!-- <div class="ml-3 mt-3 mb-5 user-name" style="font-size: 25px" v-if="isMobile()">
          {{ $t('espace_perso.bonjour') }}, <br>
          <span class="font-weight-bold" style="color: #ffa409">{{ username }}</span>
          <div class="mb-5 user-name" v-if="this.userInfos.code_parrain">
            {{ $t('espace_perso.code_parrainage_label') }}: <span class="font-weight-bold" style="color: #ffa409">
              {{ this.userInfos.code_parrain }} <button @click="copyToClipboard" style="color: #000;font-weight: 500;"
                class="btn ml-3"><i class="material-icons" aria-hidden="true" data-nosnippet>&#xe14d;</i> {{ $t('espace_perso.copie_label')
                }}</button>
            </span>
          </div>
        
          <div class="mb-5 user-name" v-if="coupon_parrainage">
            <span v-if="coupon_parrainage.type = 'pourcentage'"
              style="font-weight: 500;font-size: 15px;float: right;">{{
                $t('espace_perso.parrainage.parrainage_bonus_text[0]') }} {{ coupon_parrainage.reduction }} {{
                $t('espace_perso.parrainage.parrainage_bonus_text[1]') }}</span>
            <span v-else style="font-weight: 500;font-size: 15px;float: right;">{{
              $t('espace_perso.parrainage.parrainage_bonus_text[0]') }} {{ coupon_parrainage.reduction }} {{
                $t('espace_perso.parrainage.parrainage_bonus_text[2]') }}</span>

          </div>
        </div> -->

       

        <!-- ===================    DEBUT DE LA PARTIE UNIQUEMENT POUR LE MOBILE     ================= -->
        <!-- =                      SACHANT QUE LE CODE EST ASSEZ LONG, IL CONVIENT                  = -->
        <!-- =                      DE BIEN INDENTER LE CODE POUR UNE BONNE LISIBILITE               = -->
        <!-- ========================================================================================= -->
        <div v-responsive.sm.xs class="ml-3 mr-3 cards" v-if="isMobile()">
           <!-- Profile Section -->
          <div class="mobile-profile-section" style="background: #f8f9fa; border-radius: 15px; margin-bottom: 20px;">
            <div class="align-items-center mb-3" style="display: flex;">
              <div class="profile-avatar" style="width:50px;height: 50px; background: #6c757d; border-radius: 50%; display: flex; align-items: center; justify-content: center; margin-right: 15px;">
                <i class="fa fa-user" style="color: white; font-size: 24px;"></i>
              </div>
              <div>
                <h3 style="margin: 0; font-size: 18px; font-weight: 500;">{{ $t('espace_perso.bonjour') }},</h3>
                <h3 style="margin: 0; font-size: 18px; font-weight: 500; color: #ffa409;">{{ username }}</h3>
              </div>
            </div>
            <!-- Code de parrainage -->
            <div v-if="this.userInfos.code_parrain" class="parrainage-code" style="background: white; border-radius: 10px; padding: 15px; margin-bottom: 15px;">
              <div class="justify-content-between align-items-center" style="display: flex;">
                <div>
                  <small style="color: #6c757d; font-size: 12px;">{{ $t('espace_perso.code_parrainage_label') }} :</small>
                  <div style="font-weight: 500; color: #ffa409; font-size: 16px;">{{ this.userInfos.code_parrain }}</div>
                </div>
                <button @click="copyToClipboard" class="btn btn-sm" style="background: #f8f9fa; border: 1px solid #dee2e6; border-radius: 8px; padding: 8px 12px;margin-top: 25px;">
                  <i class="fa fa-copy" style="margin-right: 5px;"></i>
                  {{ $t('espace_perso.copie_label') }}
                </button>
              </div>
            </div>


            <div class="tabs">
  <!-- :disabled="userInfos.sexe !='entreprise'" -->
  <input type="radio" id="tab1" name="tab-control" @click="checkEspaceAccess()" checked>
  <input type="radio" id="tab2" name="tab-control" @click="checkOrganisationAccess()">
  <ul>
      <li title="Features">
          <label for="tab1" role="button">
            <svg viewBox="0 0 24 24"><path d="M12,4A4,4 0 0,1 16,8A4,4 0 0,1 12,12A4,4 0 0,1 8,8A4,4 0 0,1 12,4M12,14C16.42,14 20,15.79 20,18V20H4V18C4,15.79 7.58,14 12,14Z" /></svg><br>
            <span>{{ $t('espace_perso.mon_organisation.mon_espace_perso_label') }}</span>
          </label>
      </li>
      <li title="Mon organisation">
          <label for="tab2" role="button">
            <svg viewBox="0 0 24 24"><path d="M12,7V3H2v18h20V7H12z M6,19H4v-2h2V19z M6,15H4v-2h2V15z M6,11H4V9h2V11z M6,7H4V5h2V7z M10,19H8v-2h2V19z M10,15H8v-2h2 V15z M10,11H8V9h2V11z M10,7H8V5h2V7z M20,19h-8v-2h2v-2h-2v-2h2v-2h-2V9h8V19z M18,11h-2v2h2V11z M18,15h-2v2h2V15z"/></svg><br>
            <span>{{ $t('espace_perso.mon_organisation.mon_organisation_label') }}</span>
          </label>
      </li>
      
  </ul>
  <div class="slider"><div class="indicator"></div></div>
  <div class="content">
    <section>
      <p class="font-weight-bold">{{ $t('espace_perso.mon_organisation.mon_espace_perso_label') }}</p>
        <!-- Stats Cards Grid -->
              <div class="mobile-stats-grid">
                <!-- Row 1 -->
                <div class="d-flex justify-content-between mb-3">
                  <!-- Parrainage Card -->
                  <div class="mobile-stat-card" @click="view_my_parrainages()" style="width: 48%; background: white; border-radius: 15px; padding: 20px; text-align: center; box-shadow: 0 2px 10px rgba(0,0,0,0.1);">
                    <div class="stat-number" style="font-size: 32px; font-weight: bold; color: #333">{{ nb_parrainer }}</div>
                    <div class="stat-label" style="font-size: 15px; color: #6c757d;">{{ $t('espace_perso.card_parrainage_label') }}</div>
                    <div class="stat-icon" style="margin-top: 10px;">
                        <img src="../../assets/img/inheritance.png" alt="parrainage" width="30" style="opacity: 0.8; position: relative; float: right">
                    </div>
                  </div>

                  <!-- Mes Contrats Card -->
                  <div class="ml-3 mobile-stat-card" @click="view_MyContract()" style="width: 48%; background: white; border-radius: 15px; padding: 20px; text-align: center; box-shadow: 0 2px 10px rgba(0,0,0,0.1); position: relative;">
                    <div v-if="this.alert" class="alert-badge" style="position: absolute; top: 10px; right: 10px; background: #dc3545; color: white; border-radius: 50%; width: 20px; height: 20px; display: flex; align-items: center; justify-content: center; font-size: 10px; font-weight: bold;">{{ nombre }}</div>
                    <div class="stat-number" style="font-size: 32px; font-weight: bold; color: #333; margin-bottom: 5px;">{{ userContrat.length }}</div>
                    <div class="stat-label" style="font-size: 15px; color: #6c757d;">{{ $t('espace_perso.contrat') }}</div>
                    <div class="stat-icon" style="margin-top: 10px;">
                      <i class="fa fa-file-text" style="font-size: 24px; color: #ffa409;opacity: 0.8; position: relative; float: right"></i>
                    </div>
                  </div>
                </div>

                <!-- Row 2 -->
                <div class="d-flex justify-content-between mb-3">
                  <!-- Devis Card -->
                  <div class="mobile-stat-card" @click="view_MyDevis_item_list()" style="width: 48%; background: white; border-radius: 15px; padding: 20px; text-align: center; box-shadow: 0 2px 10px rgba(0,0,0,0.1);">
                    <div class="stat-number" style="font-size: 32px; font-weight: bold; color: #333; margin-bottom: 5px;">{{ nbDevis }}</div>
                    <div class="stat-label" style="font-size: 15px; color: #6c757d;">{{ $t('espace_perso.devis') }}</div>
                    <div class="stat-icon" style="margin-top: 10px;">
                      <i class="fa fa-files-o" style="font-size: 24px; color: #ffa409;opacity: 0.8; position: relative; float: right""></i>
                    </div>
                  </div>

                  <!-- Assistance Card -->
                  <div class="ml-3 mobile-stat-card" style="width: 48%; background: white; border-radius: 15px; padding: 20px; text-align: center; box-shadow: 0 2px 10px rgba(0,0,0,0.1);">
                    <div v-if="UserPoints > 0" class="stat-number" style="font-size: 32px; font-weight: bold; color: #333; margin-bottom: 5px;">{{UserPoints}}</div>
                    <div v-else class="stat-number" style="font-size: 32px; font-weight: bold; color: #333; margin-bottom: 5px;">0</div>
                    <div class="stat-label" style="font-size: 15px; color: #6c757d;">{{ $t('espace_perso.assur_club') }}</div>
                    <div class="stat-icon" style="margin-bottom: 10px;">
                      <i class="fa fa-star" style="font-size: 24px; color: #ffa409;opacity: 0.8; position: relative; float: right"></i>
                    </div>
                  </div>
                </div>

                <!-- Additional Cards Row -->
                <div class="d-flex justify-content-between mb-3"> 
                    <!-- Profil Card -->
                  <div class="mobile-stat-card" @click="ViewMyProfil()" style="width: 48%; background: white; border-radius: 15px; padding: 20px; text-align: center; box-shadow: 0 2px 10px rgba(0,0,0,0.1);">
                    <div class="stat-number" style="font-size: 32px; font-weight: bold; color: #333; margin-bottom: 5px;"></div>
                    <div class="stat-label" style="font-size: 15px; color: #6c757d;"><br>{{ $t('espace_perso.profil') }}</div>
                    <div class="stat-icon" style="margin-top: 10px;">
                      <i class="fa fa-user" style="font-size: 24px; color: #ffa409;opacity: 0.8; position: relative; float: right"></i>
                    </div>
                  </div>
                  <!-- Portefeuille Card -->
                  <div class="ml-3 mobile-stat-card" @click="goToPortefeuille()" style="width: 48%; background: white; border-radius: 15px; padding: 20px; text-align: center; box-shadow: 0 2px 10px rgba(0,0,0,0.1);">
                    <div class="stat-label" style="font-size: 15px; color: #6c757d; margin-top: 25px;">{{ $t('espace_perso.portefeuille') }}</div>
                    <div class="stat-icon" style="margin-bottom: 10px;">
                      <i class="fa fa-briefcase" style="font-size: 24px; color: #ffa409;opacity: 0.8; position: relative; float: right"></i>
                    </div>
                  </div>
                </div>

                <!-- Additional Cards Row -->
                <div class="d-flex justify-content-between mb-3"> 
                  <!-- Sinistre Card -->
                  <div class="mobile-stat-card" @click="goToSinistre" style="width: 48%; background: white; border-radius: 15px; padding: 20px; text-align: center; box-shadow: 0 2px 10px rgba(0,0,0,0.1);">
                    <div v-if="userSinistre.length > 0" class="stat-number" style="font-size: 32px; font-weight: bold; color: #333; margin-bottom: 5px;">{{ userSinistre.length }}</div>
                    <div v-else class="stat-number" style="font-size: 32px; font-weight: bold; color: #333; margin-bottom: 5px;">0</div>
                    <div class="stat-label" style="font-size: 15px; color: #6c757d; margin-top: -20px;"><br>{{ $t('espace_perso.sinistre') }}</div>
                    <div class="stat-icon" style="margin-bottom: 10px;">
                      <i class="fa fa-exclamation-triangle" style="font-size: 24px; color: red;opacity: 0.8; position: relative; float: right"></i>
                    </div>
                  </div>

                  <!-- Assistance Card -->
                  <div class="ml-3 mobile-stat-card" @click="assistanceDialogManip()" style="width: 48%; background: white; border-radius: 15px; padding: 20px; text-align: center; box-shadow: 0 2px 10px rgba(0,0,0,0.1);">
                    <div class="stat-label" style="font-size: 15px; color: #6c757d;margin-top: 25px;"><br>{{ $t('espace_perso.assistance') }}</div>
                    <div class="stat-icon" style="margin-bottom: 10px;">
                      <i class="fa fa-question-circle" style="font-size: 24px; color: #ffa409;opacity: 0.8; position: relative; float: right"></i>
                    </div>
                  </div>
                </div>
              </div>
    </section>
    <section>
      <p class="font-weight-bold">{{ $t('espace_perso.mon_organisation.mon_organisation_label') }}</p>
      <div v-if="userInfos.sexe != 'entreprise'">
          <p class="text-center">{{ $t('espace_perso.mon_organisation.mon_organisation_content[0]') }}<br>{{ $t('espace_perso.mon_organisation.mon_organisation_content[1]') }}</p>
      </div>
      

       <div class="mobile-stats-grid">
                <!-- Row 1 -->
                <div class="d-flex justify-content-between mb-3">
                  <!-- Devis Card -->
                                     <div v-show="userInfos.sexe =='entreprise'" class="mobile-stat-card" @click="view_MyDiscountRequest()" style="width: 48%; background: white; border-radius: 15px; padding: 20px; text-align: center; box-shadow: 0 2px 10px rgba(0,0,0,0.1);">

                    <div class="stat-number" style="font-size: 32px; font-weight: bold; color: #333; margin-bottom: 5px;">{{ discountData.length }}</div>
                    <div class="stat-label" style="font-size: 15px; color: #6c757d;">{{$t('espace_perso.demande_remise.demande_remise_label') }}</div>
                    <div class="stat-icon" style="margin-top: 10px;">
                      <i class="fa fa-percent" style="font-size: 24px; color: #ffa409;opacity: 0.8; position: relative; float: right""></i>
                    </div>
                  </div>
                </div>

                 <!-- Row 2 -->
                <div  class="d-flex justify-content-between mb-3">
                  <!-- Parrainage Card -->
                                     <div v-if="userInfos.sexe == 'entreprise'" class="mobile-stat-card" style="width: 48%; background: white; border-radius: 15px; padding: 20px; text-align: center; box-shadow: 0 2px 10px rgba(0,0,0,0.1);">

                    <div class="stat-number" style="font-size: 32px; font-weight: bold; color: #333">0</div>
                    <div class="stat-label" style="font-size: 15px; color: #6c757d;">{{$t('espace_perso.demande_remise.Flotte_automobile_label') }}</div>
                    <div class="stat-icon" style="margin-top: 10px;">
                      <i class="fa fa-car" style="font-size: 24px; color: #ffa409;opacity: 0.8; position: relative; float: right"></i>
                    </div>
                  </div>

                  <!-- Mes Contrats Card -->
                  <div v-if="userInfos.sexe == 'entreprise'" class="ml-3 mobile-stat-card" style="width: 48%; background: white; border-radius: 15px; padding: 20px; text-align: center; box-shadow: 0 2px 10px rgba(0,0,0,0.1); position: relative;">
                    <div class="stat-number" style="font-size: 32px; font-weight: bold; color: #333; margin-bottom: 5px;">0</div>
                    <div class="stat-label" style="font-size: 15px; color: #6c757d;"><br>{{$t('espace_perso.demande_remise.beneficiary_label') }} <br><span style="color:#ffa409; font-size:10px">{{$t('espace_perso.demande_remise.beneficiary_label_plus') }}</span></div>
                    <div class="stat-icon" style="margin-top: 10px;">
                      <i class="fa fa-file-text" style="font-size: 24px; color: #ffa409;opacity: 0.8; position: relative; float: right"></i>
                    </div>
                  </div>
                </div>
              </div>

               <!-- <small>Bénéficiaires : <span style="font-size:12px">Employés & Ayants droit</span></small> -->
    </section>
  </div>
  </div>
          
          </div>

            
         
          <div class="justify-content-center row">
            <!-- ========= Cards Parrainnage ========= -->
            <!-- <div style="width: 160px!important;padding-left: 2rem!important;padding-right: 2rem!important;"
              class="card-single img-icone" @click="view_my_parrainages()">
              <div>
                <h2>{{ nb_parrainer }}</h2>
                <small>{{ $t('espace_perso.card_parrainage_label') }}</small>
              </div>
              <div>
                <img src="../../assets/img/inheritance.png" alt="inheritance" width="45">
              </div>
            </div> -->
            <!-- ========= Cards contrats ========= -->
            <!-- <div style="width: 160px!important;padding-left: 2rem!important;padding-right: 2rem!important;"
              class="ml-3 card-single" @click="view_MyContract()">
              <div>
                <span style="margin-top: -20px;position: absolute;">
                  <img v-if="this.alert" class="alert_img" src="../../assets/img/devis/alert.png" width="30" alt="alert-icon">
                  <span class="font-weight-bold" style="font-size: 15px;color: red!important;" v-if="this.alert">{{
                    nombre }}</span>
                </span>
                <h2>{{ userContrat.length }}</h2>
                <small>{{ $t('espace_perso.contrat') }}</small>
              </div>
              <div>
                <span class="fa fa-file-text"></span>
              </div>
            </div> -->
          </div>

          <div class="mt-4 justify-content-center row">
            <!-- ========= Cards devis ========= -->
            <!-- <div style="width: 160px!important;padding-left: 2rem!important;padding-right: 2rem!important;"
              class="card-single" @click="view_MyDevis_item_list()">
              <div>
                <h2>{{ nbDevis }}</h2>
                <small>{{ $t('espace_perso.devis') }}</small>
              </div>
              <div>
                <span class="fa fa-files-o"></span>
              </div>
            </div> -->
            <!-- ========= Cards profile ========= -->
            <!-- <div style="width: 160px!important;padding-left: 2rem!important;padding-right: 2rem!important;"
              class="ml-3 card-single" @click="ViewMyProfil()">
              <div class="no-value">
                <small>{{ $t('espace_perso.profil') }}</small>
              </div>
              <div>
                <span class="fa fa-user"></span>
              </div>
            </div> -->
          </div>

          <div class="mt-4 justify-content-center row">
              <!-- ========= Demande de Remise ========= -->
            <!-- <div v-show="userInfos.sexe =='entreprise' || userInfos.sexe =='femme'" style="width: 160px!important;padding-left: 2rem!important;padding-right: 2rem!important;"
              class="card-single" @click="view_MyDiscountRequest()">
              <div>
                <h2>{{ discountData.length }}</h2>
                <small>{{$t('espace_perso.demande_remise.demande_remise_label') }}</small>
              </div>
              <div>
                <span class="fa fa-percent"></span>
              </div>
            </div> -->

            <!-- ========= Cards points ========= -->
            <!-- <div v-show="userInfos.sexe =='homme' || userInfos.sexe =='femme'" style="width: 160px!important;padding-left: 2rem!important;padding-right: 2rem!important;"
              class="ml-3 card-single" @click="dialogMesPoints = true">
              <div>
                <h2 v-if="UserPoints > 1">{{ UserPoints }}</h2>
                <h2 v-if="UserPoints == 1">{{ UserPoints }}</h2>
                <small>{{ $t('espace_perso.assur_club') }}</small>
              </div>
              <div>
                <span class="fa fa-star"></span>
              </div>
            </div> -->
            <!-- ========= Cards document ========= -->
            <!-- <div style="width: 160px!important;padding-left: 2rem!important;padding-right: 2rem!important;"
              class="ml-3 card-single" @click="ModalMesDocumentsAdd = true">
              <div class="no-value">
                <small>{{ $t('espace_perso.document') }}</small>
              </div>
              <div>
                <span class="fa fa-file"></span>
              </div>
            </div> -->
           
            <!-- ========= Cards assur'club ========= -->
            <!-- <div style="width: 160px!important;padding-left: 2rem!important;padding-right: 2rem!important;"
              class="ml-3 card-single">
              <div class="no-value">
                <small>{{ $t('espace_perso.assur_club') }}</small>
              </div>
              <div>
                <span class="fa fa-heart"></span>
              </div>
            </div> -->
          </div>

          <div class="mt-4 justify-content-center row">
 <!-- ========= Cards points ========= -->
            <!-- <div v-show="userInfos.sexe =='entreprise'" style="width: 160px!important;padding-left: 2rem!important;padding-right: 2rem!important;"
              class="ml-3 card-single" @click="dialogMesPoints = true">
              <div>
                <h2 v-if="UserPoints > 1">{{ UserPoints }}</h2>
                <h2 v-if="UserPoints == 1">{{ UserPoints }}</h2>
                <small>{{ $t('espace_perso.assur_club') }}</small>
              </div>
              <div>
                <span class="fa fa-star"></span>
              </div>
            </div> -->

            <!-- <div v-show="userInfos.sexe =='homme' || userInfos.sexe =='femme'" style="width: 160px!important;padding-left: 2rem!important;padding-right: 2rem!important;"
              class="ml-3 card-single-assistance" @click="goToSinistre()">
              <div style="margin-top: 37px;">
                <small>{{ $t('espace_perso.sinistre') }}</small>
              </div>
              <div>
                <span class="fa fa-exclamation-triangle"></span>
              </div>
            </div> -->
            <!-- ========= Cards assistance ========= -->
            <!-- <div style="width: 160px!important;padding-left: 2rem!important;padding-right: 2rem!important;"
              class="ml-3 card-single-assistance" @click="assistanceDialogManip()">
              <div style="margin-top: 37px;">
                <small>{{ $t('espace_perso.assistance') }}</small>
              </div>
              <div>
                <span class="fa fa-phone"></span>
              </div>
            </div> -->
          </div>
          <div class="mt-4 justify-content-center row ml-1 mr-1">
             <!-- ========= Cards sinistre ========= -->
            <!-- <div style="width: 100%!important;padding-left: 2rem!important;padding-right: 2rem!important;"
              class="ml-3 card-single-assistance" @click="goToSinistre()">
              <div style="margin-top: 37px;">
                <small>{{ $t('espace_perso.sinistre') }}</small>
              </div>
              <div>
                <span class="fa fa-exclamation-triangle"></span>
              </div>
            </div> -->
          </div>
        </div>
      </main>
    </div>

    <!--Modal box stater -->
    <div>
      <v-layout row justify-center v-if="isDesktop()">
        <!-- ======================================Modal dialog for display user profil================================== -->
        <v-dialog v-model="dialog" max-width="1000" persistent>
          <v-card elevation="24" class="border-radius">
            <v-card-text style="background:#FAFAFA">
              <div class="wizard-tab-content">
                <div role="tabpanel" id="monProfilDesktop" aria-hidden="true" aria-labelledby="step-monProfilDesktop"
                  class="wizard-tab-container">
                  <div>
                    <div class="loan-group loan-group-0">
                      <div class="fields">
                        <div class="field-title font-weight-bold">{{ $t('espace_perso.profil_form.profil_title') }}
                        </div>
                        <div class="row">
                          <v-container class="border-radius">
                            <v-layout wrap>
                              <div class="col-sm-3">
                                <img :src="this.$store.state.user.photo" alt="user-photo" width="200" v-if="userInfos.photo"
                                  class="imagechange">
                                <img :src="image" alt="user-icon" width="200" v-else-if="image" class="imagechange">
                                <img src="../../assets/img/user_icon.png" class="imagechange" alt="user-icon" width="200" v-else>
                                <div class="offset-1 mt-3">
                                  <label for="file" class="label-file"> <i
                                      class="material-icons" aria-hidden="true" data-nosnippet>&#xe439;</i></label>
                                  <input id="file" class="input-file" type="file" ref="file"
                                    @change="UpdateUserPicture">
                                </div>
                              </div>

                              <div class="col-sm-9">
                                <div class="row">
                                  <div class="col-sm-4">
                                    <div class="field-group field-default mb-4 mb-sm-0">
                                      <label for="StepperNom" class="field-label">{{
                                        $t('espace_perso.profil_form.nom_label') }}</label>
                                      <input readonly v-model="userInfos.nom"
                                        :placeholder="$t('espace_perso.profil_form.nom_placeholder')" id="StepperNom"
                                        name="Step8" class="field-input">
                                    </div>
                                  </div>
                                  <div class="col-sm-4">
                                    <div class="field-group field-default mb-4 mb-sm-0">
                                      <label for="StepperPrenom" class="field-label">{{
                                        $t('espace_perso.profil_form.prenom_label') }}</label>
                                      <input readonly v-model="userInfos.prenom"
                                        :placeholder="$t('espace_perso.profil_form.prenom_placeholder')"
                                        id="StepperPrenom" name="Step8" class="field-input">
                                    </div>
                                  </div>
                                  <div class="col-sm-4">
                                    <div class="field-group field-default mb-4 mb-sm-0">
                                      <label for="StepperNaissance" class="field-label">{{
                                        $t('espace_perso.profil_form.date_naissance_label') }}</label>
                                      <input readonly v-model="userInfos.datenaissance"
                                        :placeholder="$t('espace_perso.profil_form.date_naissance_placeholder')"
                                        id="StepperNaissance" name="Step8" class="field-input">
                                    </div>
                                  </div>
                                </div>
                                <div class="mt-3 row">
                                  <div class="col-sm-4">
                                    <div class="field-group field-default mb-4 mb-sm-0">
                                      <label for="StepperAdresse" class="field-label">{{
                                        $t('espace_perso.profil_form.adresse_label') }}</label>
                                      <input readonly v-model="userInfos.adresse"
                                        :placeholder="$t('espace_perso.profil_form.adresse_placeholder')"
                                        id="StepperAdresse" name="Step8" class="field-input">
                                    </div>
                                  </div>
                                  <div class="col-sm-4">
                                    <div class="field-group field-default mb-4 mb-sm-0">
                                      <label for="StepperTypePiece" class="field-label">{{
                                        $t('espace_perso.profil_form.type_piece_label') }}</label>
                                      <input readonly v-model="userInfos.piece_identite"
                                        :placeholder="$t('espace_perso.profil_form.type_piece_placeholder')"
                                        id="StepperTypePiece" name="Step8" class="field-input">
                                    </div>
                                  </div>
                                  <div class="col-sm-4">
                                    <div class="field-group field-default mb-4 mb-sm-0">
                                      <label for="StepperNumeroPiece" class="field-label">{{
                                        $t('espace_perso.profil_form.numero_piece_label') }}</label>
                                      <input readonly v-model="userInfos.numero_piece"
                                        :placeholder="$t('espace_perso.profil_form.numero_piece_placeholder')"
                                        id="StepperNumeroPiece" name="Step8" class="field-input">
                                    </div>
                                  </div>
                                </div>
                                <div class="mt-3 row">
                                  <div class="col-sm-6">
                                    <div class="field-group field-default mb-4 mb-sm-0">
                                      <label for="StepperEmail" class="field-label">{{
                                        $t('espace_perso.profil_form.email_label') }}</label>
                                      <input readonly v-model="userInfos.email"
                                        :placeholder="$t('espace_perso.profil_form.email_placeholder')"
                                        id="StepperEmail" name="Step8" class="field-input">
                                    </div>
                                  </div>
                                  <div class="col-sm-6">
                                    <div class="field-group field-default mb-4 mb-sm-0">
                                      <label for="StepperTel" class="field-label">{{
                                        $t('espace_perso.profil_form.numero_label') }}</label>
                                      <input readonly v-model="userInfos.telephone_port"
                                        :placeholder="$t('espace_perso.profil_form.numero_placeholder')" id="StepperTel"
                                        name="Step8" class="field-input">
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </v-layout>
                          </v-container>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="wizard-card-footer clearfix">
                <div class="wizard-footer-left">
                  <!-- ne pas supprimer cette div -->
                     <button @click="dialog = false" type="button" class="wizard-btn">
                    <span class="fas fa-arrow-left"></span>
                    {{ $t('espace_perso.profil_form.bouton_fermer') }}
                  </button>
                </div>
                <div class="wizard-footer-right">
                  <button @click="Intent_update_profil()" type="button" class="mr-3 wizard-btn">
                    {{ $t('espace_perso.profil_form.bouton_modif_infos') }}
                  </button>
                  <!-- <button @click="resetPasswordModal = true, dialog = false" type="button" class="ml-3 wizard-btn">
                    {{ $t('espace_perso.profil_form.bouton_modif_password') }}
                  </button> -->
                </div>
              </div>

              <div class="wizard-card-footer clearfix">
                <div class="wizard-footer-left">
                  <!-- <button @click="dialog = false" type="button" class="wizard-btn">
                    <span class="fas fa-arrow-left"></span>
                    {{ $t('espace_perso.profil_form.bouton_fermer') }}
                  </button> -->
                </div>
                <div class="wizard-footer-right" v-if="allowCard()">
                  <button @click="loadPopUpForPhoneUpdate(), dialog = false" type="button" class="ml-3 wizard-btn">
                    {{ $t('espace_perso.profil_form.bouton_modif_numero') }}
                  </button>

                </div>
              </div>
            </v-card-text>
          </v-card>
        </v-dialog>

        <!--============================= Modal modification de profil======================================== -->
        <v-dialog v-model="dialogEditProfil" max-width="1000" persistent>
          <v-card elevation="24" class="border-radius">
            <v-card-text style="background:#FAFAFA">
              <div class="wizard-tab-content">
                <div role="tabpanel" id="modifProfilDesktop" aria-hidden="true"
                  aria-labelledby="step-modifProfilDesktop" class="wizard-tab-container">
                  <div>
                    <div class="loan-group loan-group-0">
                      <div class="fields">
                        <div class="field-title font-weight-bold">{{ $t('espace_perso.profil_info_form.info_title') }}
                        </div>
                        <div class="row">
                          <v-container class="border-radius">
                            <v-layout wrap>
                              <div class="col-sm-12">
                                <div class="row">
                                  <div class="col-sm-4">
                                    <div class="field-group field-default mb-4 mb-sm-0">
                                      <label for="StepperModifNomDesktop" class="field-label">{{
                                        $t('espace_perso.profil_info_form.nom_label') }}</label>
                                      <input v-model="userInfos.nom"
                                        :placeholder="$t('espace_perso.profil_info_form.nom_placeholder')"
                                        id="StepperModifNomDesktop" name="Step8" class="field-input">
                                    </div>
                                  </div>
                                  <div class="col-sm-4">
                                    <div class="field-group field-default mb-4 mb-sm-0">
                                      <label for="StepperModifPrenomDesktop" class="field-label">{{
                                        $t('espace_perso.profil_info_form.prenom_label') }}</label>
                                      <input v-model="userInfos.prenom"
                                        :placeholder="$t('espace_perso.profil_info_form.prenom_placeholder')"
                                        id="StepperModifPrenomDesktop" name="Step8" class="field-input">
                                    </div>
                                  </div>
                                  <div class="col-sm-4">
                                    <div class="field-group field-default mb-4 mb-sm-0">
                                      <label for="StepperModifTypeDesktop" class="field-label">{{
                                        $t('espace_perso.profil_info_form.type_piece_label') }}</label>
                                      <select v-model="userInfos.piece_identite" id="StepperModifTypeDesktop"
                                        name="Step8" class="field-select">
                                        <option v-for="item in itemsType" :key="item" :value="item">{{ item }}</option>
                                      </select>
                                    </div>
                                  </div>
                                </div>
                                <div class="mt-3 row">
                                  <div class="col-sm-4">
                                    <div class="field-group field-default mb-4 mb-sm-0">
                                      <label for="StepperModifNumeroDesktop" class="field-label">{{
                                        $t('espace_perso.profil_info_form.numero_piece_label') }}</label>
                                      <input v-model="userInfos.numero_piece"
                                        :placeholder="$t('espace_perso.profil_info_form.numero_piece_placeholder')"
                                        id="StepperModifNumeroDesktop" name="Step8" class="field-input">
                                    </div>
                                  </div>
                                  <div class="col-sm-4">
                                    <div class="field-group field-default mb-4 mb-sm-0">
                                      <label for="StepperModifStatutDesktop" class="field-label">{{
                                        $t('espace_perso.profil_info_form.statut_marital_label') }}</label>
                                      <select v-model="userInfos.statut_marital" id="StepperModifStatutDesktop"
                                        name="Step8" class="field-select">
                                        <option v-for="item in itemsStatutMarital" :key="item" :value="item">{{ item }}
                                        </option>
                                      </select>
                                    </div>
                                  </div>
                                  <div class="col-sm-4">
                                    <div class="field-group field-default mb-4 mb-sm-0">
                                      <label for="StepperModifProfessionDesktop" class="field-label">{{
                                        $t('espace_perso.profil_info_form.profession_label') }}</label>
                                      <input v-model="userInfos.profession"
                                        :placeholder="$t('espace_perso.profil_info_form.profession_placeholder')"
                                        id="StepperModifProfessionDesktop" name="Step8" class="field-input">
                                    </div>
                                  </div>
                                </div>
                                <div class="mt-3 row">
                                  <div class="col-sm-4">
                                    <div class="field-group field-default mb-4 mb-sm-0">
                                      <label for="StepperModifMailDesktop" class="field-label">{{
                                        $t('espace_perso.profil_info_form.email_label') }}</label>
                                      <input v-model="userInfos.email"
                                        :placeholder="$t('espace_perso.profil_info_form.email_placeholder')"
                                        id="StepperModifMailDesktop" name="Step8" class="field-input">
                                    </div>
                                  </div>
                                  <div class="col-sm-4">
                                    <div class="field-group field-default mb-4 mb-sm-0">
                                      <label for="StepperModifSexeDesktop" class="field-label">{{
                                        $t('espace_perso.profil_info_form.sexe_label') }}</label>
                                      <select v-model="userInfos.sexe" id="StepperModifSexeDesktop" name="Step8"
                                        class="field-select">
                                        <option v-for="item in itemsSexe" :key="item" :value="item">{{ item }}</option>
                                      </select>
                                    </div>
                                  </div>
                                  <div class="col-sm-4">
                                    <div class="field-group field-default mb-4 mb-sm-0">
                                      <label for="StepperModifTelDesktop" class="field-label">{{
                                        $t('espace_perso.profil_info_form.telephone_port_label') }}</label>
                                      <input v-model="userInfos.telephone_port"
                                        :placeholder="$t('espace_perso.profil_info_form.telephone_port_placeholder')"
                                        id="StepperModifTelDesktop" name="Step8" class="field-input">
                                    </div>
                                  </div>
                                </div>
                                <div class="mt-3 row">
                                  <div class="col-sm-4">
                                    <div class="field-group field-default mb-4 mb-sm-0">
                                      <label for="StepperModifTelBureauDesktop" class="field-label">{{
                                        $t('espace_perso.profil_info_form.telephone_bur_label') }}</label>
                                      <input v-model="userInfos.telephone_bur"
                                        :placeholder="$t('espace_perso.profil_info_form.telephone_bur_placeholder')"
                                        id="StepperModifTelBureauDesktop" name="Step8" class="field-input">
                                    </div>
                                  </div>
                                  <div class="col-sm-4" v-if="userInfos.datenaissance">
                                    <div class="field-group field-default" style="margin-top:-2px">
                                      <label for="StepperModifDateDesktop" class="field-label">
                                        {{ $t('espace_perso.profil_info_form.date_naissance_label') }}
                                        <!---->
                                      </label>
                                      <div class="input-group value-loan">
                                        <date-picker :disabled-date="disabledBeforeToday"
                                          class="field-input ml-2 mb-1 mt-1"
                                          :placeholder="$t('espace_perso.profil_info_form.date_naissance_placeholder')"
                                          id="StepperModifDateDesktop" @change="userInfos.datenaissance = date"
                                          v-model="date" valueType="format" format="YYYY-MM-DD"
                                          lang="fr-fr"></date-picker>
                                      </div>
                                    </div>
                                  </div>
                                  <div class="col-sm-4" v-else>
                                    <div class="field-group field-default" style="margin-top:-2px">
                                      <label for="StepperModifDateNaissDesktop" class="field-label">
                                        {{ $t('espace_perso.profil_info_form.date_naissance_label') }}
                                        <!---->
                                      </label>
                                      <div class="input-group value-loan">
                                        <date-picker :disabled-date="disabledBeforeToday"
                                          class="field-input ml-2 mb-1 mt-1"
                                          :placeholder="$t('espace_perso.profil_info_form.date_naissance_placeholder')"
                                          id="StepperModifDateNaissDesktop" @change="userInfos.datenaissance = date"
                                          v-model="date" valueType="format" format="YYYY-MM-DD"
                                          lang="fr-fr"></date-picker>
                                      </div>
                                    </div>
                                  </div>
                                  <div class="col-sm-4">
                                    <div class="field-group field-default mb-4 mb-sm-0">
                                      <label for="StepperModifAdresseDesktop" class="field-label">{{
                                        $t('espace_perso.profil_info_form.adresse_label') }}</label>
                                      <input v-model="userInfos.adresse"
                                        :placeholder="$t('espace_perso.profil_info_form.adresse_placeholder')"
                                        id="StepperModifAdresseDesktop" name="Step8" class="field-input">
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </v-layout>
                          </v-container>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="wizard-card-footer clearfix">
                <div class="wizard-footer-left">
                  <button @click="dialogEditProfil = false" type="button" class="wizard-btn">
                    <span class="fas fa-arrow-left"></span>
                    {{ $t('espace_perso.profil_info_form.bouton_fermer_label') }}
                  </button>
                </div>
                <div class="wizard-footer-right">
                  <button @click="userUpdate()" type="button" class="wizard-btn">
                    {{ $t('espace_perso.profil_info_form.bouton_save_label') }}
                  </button>
                </div>
              </div>
            </v-card-text>
          </v-card>
        </v-dialog>
        <!-- ===========Fin modif profil====== -->

        <!--======================= Modal modification de mot de passe======================= -->
        <v-dialog v-model="resetPasswordModal" max-width="500" persistent>
          <v-card elevation="24" class="border-radius">
            <v-card-text style="background:#FAFAFA">
              <div class="wizard-tab-content">
                <div role="tabpanel" id="passWordModifDesktop" aria-hidden="true"
                  aria-labelledby="step-passWordModifDesktop" class="wizard-tab-container">
                  <div>
                    <div class="loan-group loan-group-0">
                      <div class="fields">
                        <div class="field-title font-weight-bold">
                          {{ $t('espace_perso.modif_password_form.modif_password_title') }}</div>
                        <div class="row">
                          <div class="col-sm-12">
                            <div class="field-group field-default mb-4 mb-sm-0">
                              <label for="StepperMailDesktop" class="field-label">{{
                                $t('espace_perso.modif_password_form.email_label') }}</label>
                              <input v-model="password_new"
                                :placeholder="$t('espace_perso.modif_password_form.email_placeholder')"
                                id="StepperMailDesktop" name="Step8" class="field-input">
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="wizard-card-footer clearfix">
                <div class="wizard-footer-left">
                  <button @click="resetPasswordModal = false" type="button" class="wizard-btn">
                    <span class="fas fa-arrow-left"></span>
                    {{ $t('espace_perso.modif_password_form.bouton_fermer_label') }}
                  </button>
                </div>
                <div class="wizard-footer-right">
                  <button @click="userUpdatePassword()" type="button" class="wizard-btn">
                    {{ $t('espace_perso.modif_password_form.bouton_valider_label') }}
                  </button>
                </div>
              </div>
            </v-card-text>
          </v-card>
        </v-dialog>
        <!--======================= Fin modif mot de passe ============================== -->

        <!--Modal dialog for statistics new -->
        <v-dialog v-model="ModalDashboard" max-width="800">
          <v-card tile>
            <v-toolbar card dark style="background: #ffa409">
              <v-toolbar-title>Dashboard</v-toolbar-title>
              <v-spacer></v-spacer>
              <v-btn icon dark flat @click="ModalDashboard = false" class="float-lg-right">
                <v-icon>&#xe5cd;</v-icon>
              </v-btn>
            </v-toolbar>

            <v-card-text>
              <v-container grid-list-md>
                <v-layout wrap>
                  <v-flex xs12 sm6 md6 class="text-lg-center">
                    <span class="font-weight-bold">
                      <i class="material-icons" aria-hidden="true" data-nosnippet style="color: #ffa409;">&#xe873;</i>
                      <p>Mes contrats ({{ userContrat.count }})</p>
                    </span>
                  </v-flex>

                  <v-flex xs12 sm6 md6 class="text-lg-center">
                    <span class="font-weight-bold">
                      <i class="material-icons" aria-hidden="true" data-nosnippet style="color: #ffa409;">&#xe873;</i>
                      <p>Mes Devis ({{ userContrat.count - 3 }})</p>
                    </span>
                  </v-flex>

                  <v-flex xs12 sm6 md6 class="text-lg-center">
                    <span class="font-weight-bold">
                      <i class="material-icons" aria-hidden="true" data-nosnippet style="color: #ffa409;">&#xe2c8;</i>
                      <p>Mes Documents ({{ userContrat.count + 10 }})</p>
                    </span>
                  </v-flex>

                  <v-flex xs12 sm6 md6 class="text-lg-center">
                    <span class="font-weight-bold">
                      <i class="material-icons" aria-hidden="true" data-nosnippet style="color: #ffa409;">&#xe838;</i>
                      <i class="material-icons" aria-hidden="true" data-nosnippet style="color: #ffa409;">&#xe838;</i>
                      <p>Mes points Assuraf ({{ userContrat.count }})</p>
                    </span>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card-text>
          </v-card>
        </v-dialog>

        <!-- ===========================Modal dialog for assistance ========================= -->
        <v-dialog v-model="assistanceDialog" max-width="1000" persistent>
          <v-card elevation="24" class="border-radius">
            <v-card-text style="background:#FAFAFA">
              <div class="wizard-tab-content">
                <div role="tabpanel" id="assistanceDesktop" aria-hidden="true" aria-labelledby="step-assistanceDesktop"
                  class="wizard-tab-container">
                  <div>
                    <div class="loan-group loan-group-0">
                      <div class="fields">
                        <div class="field-title font-weight-bold">{{ $t('espace_perso.assistance_form.assistance_title')
                        }}</div>
                        <div class="row">
                          <div class="col-sm-4">
                            <div class="field-group field-default mb-4 mb-sm-0">
                              <label for="horaireAppelDesktop" class="field-label">{{
                                $t('espace_perso.assistance_form.horaire_rappel_label') }}*</label>
                              <select v-model="horaire" id="horaireAppelDesktop" name="Step8" class="field-select">
                                <option v-for="itm in itema" :key="itm" :value="itm">{{ itm }}</option>
                              </select>
                            </div>
                          </div>
                          <div class="col-sm-4">
                            <div class="field-group field-default mb-4 mb-sm-0">
                              <label for="canalAppelDesktop" class="field-label">{{
                                $t('espace_perso.assistance_form.canal_rappel_label') }}*</label>
                              <select v-model="canal" id="canalAppelDesktop" name="Step8" class="field-select">
                                <option v-for="itm in rappel" :key="itm" :value="itm">{{ itm }}</option>
                              </select>
                            </div>
                          </div>
                          <div class="col-sm-4">
                            <div class="field-group field-default mb-4 mb-sm-0">
                              <label for="nomAssisDesktop" class="field-label">{{
                                $t('espace_perso.assistance_form.nom_label') }}</label>
                              <input v-model="name" :placeholder="$t('espace_perso.assistance_form.nom_placeholder')"
                                id="nomAssisDesktop" name="infosAssis" class="field-input" />
                            </div>
                          </div>
                        </div>

                        <div class="row">
                          <div class="col-sm-4">
                            <div class="field-group field-default">
                              <label for="numAssisDesktop" class="field-label">
                                {{ $t('espace_perso.assistance_form.telephone_label') }}
                                <!---->
                              </label>
                              <div class="input-group value-loan">
                                <input :placeholder="$t('espace_perso.assistance_form.telephone_placeholder')"
                                  @keypress="onlyNumber" v-model="tel" id="numAssisDesktop" name="infosAssis"
                                  class="field-input" />
                              </div>
                            </div>
                          </div>
                          <div class="col-sm-4">
                            <div class="field-group field-default">
                              <label for="ObjectAssisDesktop" class="field-label">
                                {{ $t('espace_perso.assistance_form.objet_label') }}
                                <!---->
                              </label>
                              <div class="input-group value-loan">
                                <input :placeholder="$t('espace_perso.assistance_form.objet_placeholder')"
                                  v-model="objetRappel" id="ObjectAssisDesktop" name="infosAssis" class="field-input" />
                              </div>
                            </div>
                          </div>
                          <div class="col-sm-4">
                            <div class="field-group field-default">
                              <label for="RemarqueAssisDesktop" class="field-label">
                                {{ $t('espace_perso.assistance_form.remarque_label') }}
                                <!---->
                              </label>
                              <div class="input-group value-loan">
                                <textarea rows="4" cols="50"
                                  :placeholder="$t('espace_perso.assistance_form.remarque_placeholder')"
                                  v-model="remarques" id="RemarqueAssisDesktop" name="infosAssis"
                                  class="field-input"></textarea>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="wizard-card-footer clearfix">
                <div class="wizard-footer-left">
                  <button @click="assistanceDialog = false" type="button" class="wizard-btn">
                    <span class="fas fa-arrow-left"></span>
                    {{ $t('espace_perso.assistance_form.bouton_fermer_label') }}
                  </button>
                </div>
                <div class="wizard-footer-right">
                  <button @click="AddAssistance()" type="button" class="wizard-btn">
                    {{ $t('espace_perso.assistance_form.bouton_valider_label') }}
                  </button>
                </div>
              </div>
            </v-card-text>
          </v-card>
        </v-dialog>

        <!-- =============Formulaire d'ajout d'un nouveau document par le user ======================== -->
        <v-dialog v-model="AddDocForm" max-width="600" persistent>
          <v-card elevation="24" class="border-radius">
            <v-card-text style="background:#FAFAFA">
              <div class="wizard-tab-content">
                <div role="tabpanel" id="ajoutDocumentDesktop" aria-hidden="true"
                  aria-labelledby="step-ajoutDocumentDesktop" class="wizard-tab-container">
                  <div>
                    <div class="loan-group loan-group-0">
                      <div class="fields">
                        <div class="field-title font-weight-bold">
                          {{ $t('espace_perso.document_form.add_document_label') }}</div>
                        <div class="row">
                          <div class="col-sm-12">
                            <div class="field-group field-default mb-4 mb-sm-0">
                              <label for="typePieceDesktop" class="field-label">{{
                                $t('espace_perso.document_form.type_piece_label') }}</label>
                              <select v-model="type_de_document" id="typePieceDesktop" name="Step8"
                                class="field-select">
                                <option v-for="itm in itemsTypeDocument" :key="itm" :value="itm.value">{{ itm.value }}
                                </option>
                              </select>
                            </div>
                          </div>
                        </div>
                        <div class="mt-3 row">
                          <span style="color: red">(*) {{ $t('espace_perso.document_form.alert_text_document') }}</span>
                        </div>
                        <div class="mt-3 row">
                          <p v-if="selectedFiles !== null" class="col-sm-11 border" style="border-radius:10px;">
                            {{ $t('espace_perso.document_form.nom_fichier') }} : {{ selectedFiles }}
                          </p>

                          <label for="fileDesktop" class="toBordered">
                            <i class="fas fa-plus newFileIcon p-2"></i>
                          </label>
                          <input id="fileDesktop" class="input-file" @change="ShowSelectedFile" type="file"
                            ref="document">
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="wizard-card-footer clearfix">
                <div class="wizard-footer-left">
                  <button @click="AddDocForm = false" type="button" class="wizard-btn">
                    <span class="fas fa-arrow-left"></span>
                    {{ $t('espace_perso.document_form.bouton_fermer_label') }}
                  </button>
                </div>
                <div class="wizard-footer-right">
                  <button @click="AddDocument()" type="button" class="wizard-btn">
                    {{ $t('espace_perso.document_form.bouton_valider_label') }}
                  </button>
                </div>
              </div>
            </v-card-text>
          </v-card>
        </v-dialog>

        <!------------------------------------ Modal dialog for documents list ------------------------------------------------------>
        <v-dialog v-model="ModalMesDocumentsAdd" max-width="800" persistent>
          <v-card elevation="24" class="border-radius">
            <v-card-text style="background:#FAFAFA">
              <div class="wizard-card-footer clearfix">
                <div class="wizard-footer-left">
                </div>
                <div class="wizard-footer-right">
                  <button @click="AddDocForm = true, ModalMesDocumentsAdd = false" type="button" class="wizard-btn">
                    {{ $t('espace_perso.document_form.bouton_add_document') }}
                  </button>
                </div>
              </div>
              <div class="wizard-tab-content">
                <div role="tabpanel" id="addDocumentDesktop" aria-hidden="true"
                  aria-labelledby="step-addDocumentDesktop" class="wizard-tab-container">
                  <div>
                    <div class="loan-group loan-group-0">
                      <div class="fields">
                        <div class="field-title font-weight-bold">{{ $t('espace_perso.document_form.document_title') }}
                        </div>
                        <div class="row">
                          <div class="col-sm-12">
                            <div class="col-sm-12 mt-2">
                              <v-data-table :headers="$t('espace_perso.document_form.headerMesDoc')"
                                :items="userDocument" class="table table-reponsive small"
                                style="box-shadow: 9px 12px 18px rgb(0 0 0 / 10%);z-index:10000">
                                <template slot="items" slot-scope="props">
                                  <td class="text-xs-left">{{ props.item.type_document }}</td>
                                  <td class="text-xs-left">
                                    <a :href="props.item.lien_document" target="_blank">{{
                                      $t('espace_perso.document_form.download_file_label') }}</a>
                                  </td>
                                  <td class="text-xs-left">{{ DateFormater(props.item.date_upload) }}
                                  </td>
                                </template>
                              </v-data-table>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="wizard-card-footer clearfix">
                <div class="wizard-footer-left">
                  <button @click="ModalMesDocumentsAdd = false" type="button" class="wizard-btn">
                    <span class="fas fa-arrow-left"></span>
                    {{ $t('espace_perso.document_form.bouton_fermer_label') }}
                  </button>
                </div>
                <div class="wizard-footer-right">
                </div>
              </div>
            </v-card-text>
          </v-card>
        </v-dialog>
        <!-- -------------------fin Modal dialog for contenu document---------------------------------------------------------->

        <!--    ==========================Modal for contrat============================================ -->
        <v-dialog v-model="ModalListeContrat" persistent v-if="isDesktop()">
          <v-card elevation="24" class="border-radius">
            <v-card-text style="background:#FAFAFA">
              <div class="wizard-tab-content">
                <div role="tabpanel" id="choixListeContratDesktop" aria-hidden="true"
                  aria-labelledby="step-choixListeContratDesktop" class="wizard-tab-container">
                  <div>
                    <div class="loan-group loan-group-0">
                      <div class="fields">
                        <div class="field-title font-weight-bold">{{ $t('espace_perso.contrat_list.contrat_title') }}
                        </div>
                        <div class="row">
                          <div class="col-sm-6">
                            <!-- A ne pas supprimer-->
                          </div>
                          <div class="col-sm-6">
                            <div class="field-group field-default mb-4 mb-sm-0">
                              <label for="searchContratDesktop" class="field-label">{{
                                $t('espace_perso.contrat_list.recherche_label') }}</label>
                              <input v-model="searchContratDesktop"
                                :placeholder="$t('espace_perso.contrat_list.recherche_placeholder')"
                                id="searchContratDesktop" name="Step8" class="field-input">
                            </div>
                          </div>
                        </div>
                        <div class="row" style="z-index:10000">
                          <v-data-table class="mt-3 fb-table-elem ml-3"
                            :headers="$t('espace_perso.contrat_list.headerContrat')" :items="userContrat"
                            :search="searchContratDesktop" expand
                            style="box-shadow: 9px 12px 18px rgb(0 0 0 / 10%);width: 100%">
                            <template slot="items" slot-scope="props">
                              <tr @click="props.expanded = !props.expanded"
                                :style="{ backgroundColor: (ShowBtnPaymentContrat(props.item) ? '#eccccc' : '') }">
                                <td class="text-xs-left">
                                  <div class="datatable-cell-wrapper">{{ DateFormater(props.item.dateSouscription) }}
                                  </div>
                                </td>
                                <td class="text-xs-left">
                                  <div class="datatable-cell-wrapper">{{ props.item.numero_police }}</div>
                                </td>
                                <td class="text-xs-left">
                                  <div class="datatable-cell-wrapper">{{ props.item.brancheid.branche }}</div>
                                </td>
                                <td class="text-xs-left">
                                  <div class="datatable-cell-wrapper">{{ props.item.partenaireid.societe }}</div>
                                </td>
                                <td class="text-xs-left">
                                  <div class="datatable-cell-wrapper">{{ DateFormater(props.item.dateEffet) }}</div>
                                </td>
                                <td class="text-xs-left">
                                  <div class="datatable-cell-wrapper">{{ DateFormater(props.item.dateEcheance) }}</div>
                                </td>
                                <td class="text-xs-left">
                                  <div class="datatable-cell-wrapper">{{ props.item.prime_ttc.toLocaleString() }}</div>
                                </td>
                                <td class="text-xs-left justify-content-start row">
                                  <div class="datatable-cell-wrapper">
                                    <span class="tool_button" data-tip="Voir détails contrat !" tabindex="1">
                                      <v-btn icon @click="DetailsContratVue(props.item)">
                                        <v-icon color="#ffa409">&#xe8f4;</v-icon>
                                      </v-btn>
                                    </span>

                                    <span class="tool_button" data-tip="Envoyer par mail !" tabindex="1">
                                      <v-btn icon @click="SendContratByEmail(props.item)">
                                        <v-icon color="#ffa409">&#xe0be;</v-icon>
                                      </v-btn>
                                    </span>

                                    <span class="tool_button" data-tip="Télécharger contrat !" tabindex="1">
                                      <v-btn
                                        v-if="props.item.brancheid.branche == 'Voyage' && props.item.lien_contrat != null && props.item.police_assureur != null"
                                        icon @click="downloadVoyageFileContrat(props.item.lien_contrat)">
                                        <v-icon color="#ffa409">&#xe2c4;</v-icon>
                                      </v-btn>
                                      <v-btn v-else icon @click="DownloadAttestationV2(props.item)">
                                        <v-icon color="#ffa409">&#xe2c4;</v-icon>
                                      </v-btn>
                                    </span>

                                    <span class="tool_button" data-tip="Renouveller contrat !" tabindex="1">
                                      <v-btn v-if="ShowBtnPaymentContrat(props.item)" icon
                                        @click="modalPaymentContrat(props.item)">
                                        <img src="../../assets/img/devis/renew.png" width="30" alt="renew-icon">
                                      </v-btn>
                                    </span>

                                    <span class="tool_button" data-tip="Paiement reccurent !" tabindex="1">
                                      <v-btn v-if="ShowBtnOneContrat(props.item)" icon
                                        @click="payInsuranceCurrent(props.item)">
                                        <v-icon color="#ffa409">&#xe89f;</v-icon>
                                      </v-btn>
                                    </span>
                                  </div>
                                </td>
                              </tr>
                            </template>
                            <template v-slot:no-results>
                              <v-alert class="text-center" :value="true" color="error" icon="warning">{{
                                $t('espace_perso.contrat_list.found_or_not_label[0]') }}
                                "{{ searchContratDesktop + '=' }}"
                                {{ $t('espace_perso.contrat_list.found_or_not_label[1]') }}
                              </v-alert>
                            </template>
                          </v-data-table>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="wizard-card-footer clearfix">
                <div class="wizard-footer-left">
                  <button @click="ModalListeContrat = false" type="button" class="wizard-btn">
                    <span class="fas fa-arrow-left"></span>
                    {{ $t('espace_perso.contrat_list.bouton_fermer_label') }}
                  </button>
                </div>
                <div class="wizard-footer-right">
                </div>
              </div>
            </v-card-text>
          </v-card>
        </v-dialog>

        <!-- ======================== modal payment new contrat ======================================== -->
        <v-dialog v-model="dialogPaymentContrat" persistent max-width="800px" v-if="paymentContrat">
          <v-card elevation="24" class="border-radius">
            <v-card-text style="background:#FAFAFA">
              <div class="wizard-tab-content">
                <div role="tabpanel" id="renewContratDesktop" aria-hidden="true"
                  aria-labelledby="step-renewContratDesktop" class="wizard-tab-container">
                  <div>
                    <div class="loan-group loan-group-0">
                      <div class="fields">
                        <div class="field-title font-weight-bold">Renouveler mon contrat</div>
                        <div class="row">
                          <div class="col-sm-4">
                            <div class="field-group field-default mb-4 mb-sm-0">
                              <label for="renewDureeDesktop" class="field-label">Durée</label>
                              <input @keypress="onlyNumber" v-model="duree" placeholder="Durée de la garantie"
                                id="renewDureeDesktop" name="Step8" class="field-input" @keyup="dateDiffForRenew"
                                @change="numberMonth()">
                            </div>
                          </div>
                          <div class="col-sm-4">
                            <div class="field-group field-default mb-4 mb-sm-0">
                              <label for="renewDateEffetDesktop" class="field-label">Date d'effet</label>
                              <input v-model="dateEffet" placeholder="Date d'échéance" id="renewDateEffetDesktop"
                                name="Step8" class="field-input" readonly>
                            </div>
                          </div>
                          <div class="col-sm-4">
                            <div class="field-group field-default mb-4 mb-sm-0">
                              <label for="renewDateEcheanceDesktop" class="field-label">Date d'échéance</label>
                              <input v-model="dateEcheance" placeholder="Date d'échéance" id="renewDateEcheanceDesktop"
                                name="Step8" class="field-input" readonly>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="fields" v-if="categorie !== '2_roues'">
                        <div class="field-title mb-0">
                          Liste des packs&nbsp;:
                        </div>
                        <p class="field-sub-title mb-5">Sélectionnez bien vos packs</p>
                        <div class="field-group row field-bank">
                          <div class="btn-choice col-sm-6">
                            <input type="radio" v-model="garanties" :value='packStandart.garanties'
                              id="pack_standard_desktop" name="Step09_mobile" class="field-input"
                              @change="showGaranties()">
                            <label for="pack_standard_desktop" class="field-label">
                              <h3 class="mt-3 text-center">Pack Standard</h3>
                            </label>
                          </div>
                          <div class="btn-choice col-sm-6">
                            <input type="radio" v-model="garanties" :value='packIntermediaire.garanties'
                              id="pack_inter_desktop" name="Step09_mobile" class="field-input"
                              @change="showGaranties()">
                            <label for="pack_inter_desktop" class="field-label">
                              <h3 class="mt-3 text-center">Pack Intermédiaire</h3>
                            </label>
                          </div>
                          <div class="btn-choice col-sm-6">
                            <input type="radio" v-model="garanties" :value='packAvance.garanties'
                              id="pack_avance_desktop" name="Step09_mobile" class="field-input"
                              @change="showGaranties()">
                            <label for="pack_avance_desktop" class="field-label">
                              <h3 class="mt-3 text-center">Pack Avancé</h3>
                            </label>
                          </div>
                          <div class="btn-choice col-sm-6" v-if="annee <= 5">
                            <input type="radio" v-model="garanties" :value="packFull" id="pack_full_desktop"
                              name="Step09_mobile" class="field-input" @change="showGaranties()">
                            <label for="pack_full_desktop" class="field-label">
                              <h3 class="mt-3 text-center">Pack Full</h3>
                            </label>
                          </div>
                        </div>
                      </div>
                      <div class="fields">
                        <div class="row">
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="wizard-tab-content" v-show="text_packStandart" v-if="categorie !== '2_roues'">
                <div role="tabpanel" id="text_pack_Standart_desktop" aria-hidden="true"
                  aria-labelledby="step-text_pack_Standart_desktop" class="wizard-tab-container">
                  <div>
                    <div class="fields">
                      <div class="field-title mb-0">
                        Pack Standard
                      </div>
                      <p class="field-sub-title mb-5">Ce pack comprend les garanties suivantes :
                        <br> <span class="font-weight-bold">RESPONSABILITE CIVILE, PERSONNES TRANSPORTÉES, DÉFENSE ET
                          RECOURS</span> <br>
                        <span>Option Personnes Transportées : <span class="font-weight-bold"
                            style="color:#ffa409">Option
                            1</span></span>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div class="wizard-tab-content" v-show="text_packInter" v-if="categorie !== '2_roues'">
                <div role="tabpanel" id="text_pack_Inter_desktop" aria-hidden="true"
                  aria-labelledby="step-text_pack_Inter_desktop" class="wizard-tab-container">
                  <div>
                    <div class="fields">
                      <div class="field-title mb-0">
                        Pack Intermédiaire
                      </div>
                      <p class="field-sub-title mb-5">Ce pack comprend les garanties suivantes :
                        <br> <span class="font-weight-bold">RESPONSABILITE CIVILE, PERSONNES TRANSPORTÉES, DÉFENSE ET
                          RECOURS,
                          BRIS DE GLACES</span> <br>
                        <span>Option Personnes Transportées : <span class="font-weight-bold"
                            style="color:#ffa409">Option
                            1</span></span>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div class="wizard-tab-content" v-show="text_packAvance" v-if="categorie !== '2_roues'">
                <div role="tabpanel" id="text_pack_Avance_desktop" aria-hidden="true"
                  aria-labelledby="step-text_pack_Avance_desktop" class="wizard-tab-container">
                  <div>
                    <div class="fields">
                      <div class="field-title mb-0">
                        Pack Avancé
                      </div>
                      <p class="field-sub-title mb-5">Ce pack comprend les garanties suivantes :
                        <br> <span class="font-weight-bold">RESPONSABILITE CIVILE, PERSONNES TRANSPORTÉES, DÉFENSE ET
                          RECOURS,
                          BRIS DE GLACES, VOL, INCENDIE, AVANCE SUR RECOURS</span> <br>
                        <span>Option Personnes Transportées : <span class="font-weight-bold"
                            style="color:#ffa409">Option
                            1</span></span> <br>
                        <span>Choix Capital Avance sur Recours : <span class="font-weight-bold"
                            style="color:#ffa409">500
                            000
                            FCFA</span></span>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div class="wizard-tab-content" v-show="offre_full">
                <div role="tabpanel" id="pack_full_liste_desktop" aria-hidden="true"
                  aria-labelledby="step-pack_full_liste_desktop" class="wizard-tab-container">
                  <div>
                    <div class="fields">
                      <div class="field-title font-weight-bold mb-0">
                        Choix des packs Full&nbsp;:
                      </div>
                      <p class="field-sub-title mb-5">Sélectionnez bien vos packs</p>
                      <div class="field-group row field-bank">
                        <div class="btn-choice col-sm-6">
                          <input type="radio" v-model="garanties" :value="packFull.packFullToutRisques.garanties"
                            id="pack_full_choix_1_desktop" name="pack_full" class="field-input"
                            @change="showGarantiesPackFull">
                          <label for="pack_full_choix_1_desktop" class="field-label">
                            <h3 class="mt-3 text-center">
                              <span class="tool"
                                data-tip="Ce pack : RESPONSABILITE CIVILE, PERSONNES TRANSPORTÉES, DÉFENSE ET RECOURS, VOL, INCENDIE, AVANCE SUR RECOURS, TIERCE COMPLÈTE"
                                tabindex="1">Pack Full - Tous risques</span>
                            </h3>
                          </label>
                        </div>
                        <div class="btn-choice col-sm-6">
                          <input type="radio" v-model="garanties" :value="packFull.packFullCollision.garanties"
                            id="pack_full_choix_2_desktop" name="pack_full" class="field-input"
                            @change="showGarantiesPackFull">
                          <label for="pack_full_choix_2_desktop" class="field-label">
                            <h3 class="mt-3 text-center">
                              <span class="tool"
                                data-tip="Ce pack : RESPONSABILITE CIVILE, PERSONNES TRANSPORTÉES, DÉFENSE ET RECOURS, VOL, INCENDIE, AVANCE SUR RECOURS, TIERCE COLLISION"
                                tabindex="1">Pack Full - Collision</span>
                            </h3>
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="wizard-tab-content" v-show="text_packFull_1">
                <div role="tabpanel" id="text_pack_full_1_desktop" aria-hidden="true"
                  aria-labelledby="step-text_pack_full_1_desktop" class="wizard-tab-container">
                  <div>
                    <div class="fields">
                      <div class="field-title mb-0">
                        Pack Full - Tous risques
                      </div>
                      <p class="field-sub-title mb-5">Ce pack comprend les garanties suivantes :
                        <br> <span class="font-weight-bold">RESPONSABILITE CIVILE, PERSONNES TRANSPORTÉES, DÉFENSE ET
                          RECOURS,
                          VOL, INCENDIE, AVANCE SUR RECOURS, TIERCE COMPLÈTE</span> <br>
                        <span>Option Personnes Transportées : <span class="font-weight-bold"
                            style="color:#ffa409">Option
                            1</span></span> <br>
                        <span>Choix Capital Avance sur Recours : <span class="font-weight-bold"
                            style="color:#ffa409">500
                            000
                            FCFA</span></span>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div class="wizard-tab-content" v-show="text_packFull_2">
                <div role="tabpanel" id="text_pack_full_2_desktop" aria-hidden="true"
                  aria-labelledby="step-text_pack_full_2_desktop" class="wizard-tab-container">
                  <div>
                    <div class="fields">
                      <div class="field-title mb-0">
                        Pack Full - Collision
                      </div>
                      <p class="field-sub-title mb-5">Ce pack comprend les garanties suivantes :
                        <br> <span class="font-weight-bold">RESPONSABILITE CIVILE, PERSONNES TRANSPORTÉES, DÉFENSE ET
                          RECOURS,
                          VOL, INCENDIE, AVANCE SUR RECOURS, TIERCE COLLISION</span> <br>
                        <span>Option Personnes Transportées : <span class="font-weight-bold"
                            style="color:#ffa409">Option
                            1</span></span> <br>
                        <span>Choix Capital Avance sur Recours : <span class="font-weight-bold"
                            style="color:#ffa409">500
                            000
                            FCFA</span></span>
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              <div class="wizard-card-footer clearfix mb-5">
                <div class="wizard-footer-left">
                  <button @click="dialogPaymentContrat = false" type="button" class="wizard-btn">
                    <span class="fas fa-arrow-left"></span>
                    Retour
                  </button>
                </div>
                <div class="wizard-footer-right">
                  <button @click="reNewContrat()" type="button" class="wizard-btn">
                    Renouveler
                  </button>
                </div>
              </div>
            </v-card-text>
          </v-card>

        </v-dialog>
      </v-layout>

      <!-- ========= DIALOG VALEUR A NEUF ============ -->
      <!-- ========= DIALOG VALEUR A NEUF ============ -->
      <v-dialog v-model="VNeuf" persistent max-width="600px">
        <v-card elevation="24" class="border-radius">
          <v-card-text style="background:#FAFAFA">
            <div class="wizard-tab-content">
              <div role="tabpanel" id="valeurNeufDesktop" aria-hidden="true" aria-labelledby="step-valeurNeufDesktop"
                class="wizard-tab-container">
                <div>
                  <div class="loan-group loan-group-0">
                    <div class="fields">
                      <div class="field-title font-weight-bold">Valeur à neuf&nbsp;:</div>
                      <div class="row">
                        <div class="col-sm-12">
                          <div class="field-group field-default">
                            <label for="valeur_venale_desktop" class="field-label">
                              Valeur à neuf
                              <!---->
                            </label>
                            <div class="input-group value-loan">
                              <input type="number" v-model="valeur" placeholder="Valeur à neuf"
                                id="valeur_venale_desktop" name="valeurNeuf" class="field-input">
                              <div class="input-group-append">
                                <div class="input-group-text">FCFA</div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="wizard-card-footer clearfix">
              <div class="wizard-footer-left">
                <button @click="CloseModalVNeuf()" type="button" class="wizard-btn">
                  <span class="fas fa-arrow-left"></span>
                  Retour
                </button>
              </div>
              <div class="wizard-footer-right">
                <button @click="CheckValeurNeuf()" type="button" class="wizard-btn">
                  Valider
                </button>
              </div>
              <!---->
            </div>
          </v-card-text>
        </v-card>
      </v-dialog>

      <!--    ==========================Modal for devis============================================ -->
      <v-dialog v-model="ModalListeDevis" persistent v-if="isDesktop()">
        <v-card elevation="24" class="border-radius">
          <v-card-text style="background:#FAFAFA">
            <div class="wizard-tab-content">
              <div role="tabpanel" id="choixListeDevisDesktop" aria-hidden="true"
                aria-labelledby="step-choixListeDevisDesktop" class="wizard-tab-container">
                <div>
                  <div class="loan-group loan-group-0">
                    <div class="fields">
                      <div class="field-title font-weight-bold">{{ $t('espace_perso.devis_list.devis_title') }}</div>
                      <div class="row">
                        <div class="col-sm-6">

                        </div>
                        <div class="col-sm-6">
                          <div class="field-group field-default mb-4 mb-sm-0">
                            <label for="searchDevisDesktop" class="field-label">{{
                              $t('espace_perso.devis_list.recherche_label') }}</label>
                            <input v-model="search" :placeholder="$t('espace_perso.devis_list.recherche_placeholder')"
                              id="searchDevisDesktop" name="Step8" class="field-input">
                          </div>
                        </div>
                      </div>
                      <div class="row" style="z-index:10000">
                        <v-data-table class="mt-3 fb-table-elem ml-3" :headers="$t('espace_perso.devis_list.headers')"
                          :items="userDevis" :search="search" expand
                          style="box-shadow: 9px 12px 18px rgb(0 0 0 / 10%);width: 100%">
                          <template slot="items" slot-scope="props">
                            <tr @click="props.expanded = !props.expanded">
                              <td class="text-xs-left">
                                <div class="datatable-cell-wrapper">{{ DateFormater(props.item.dateSouscription) }}
                                </div>
                              </td>
                              <td class="text-xs-left">
                                <div class="datatable-cell-wrapper">{{ props.item.numeroDevis }}</div>
                              </td>
                              <td class="text-xs-left">
                                <div class="datatable-cell-wrapper">{{ props.item.brancheid.branche }}</div>
                              </td>
                              <td class="text-xs-left">
                                <div class="datatable-cell-wrapper">{{ props.item.partenaireid.societe }}</div>
                              </td>
                              <!-- <td class="text-xs-left"><div class="datatable-cell-wrapper">{{ props.item.reference || ''}}</div></td> -->
                              <td class="text-xs-left">
                                <div class="datatable-cell-wrapper">{{ DateFormater(props.item.dateEffet) }}</div>
                              </td>
                              <td class="text-xs-left">
                                <div class="datatable-cell-wrapper">{{ DateFormater(props.item.dateEcheance) }}</div>
                              </td>
                              <td class="text-xs-left">
                                <div class="datatable-cell-wrapper">{{ props.item.prime_ttc.toLocaleString() }}</div>
                              </td>
                              <td class="text-xs-left">
                                <div class="datatable-cell-wrapper">
                                  <span class="tool_button" data-tip="Voir détails devis !" tabindex="1">
                                    <v-btn icon @click="DetailsDevisVue(props.item)">
                                      <v-icon color="#ffa409">&#xe8f4;</v-icon>
                                    </v-btn>
                                  </span>

                                  <span class="tool_button" data-tip="Envoyer par mail !" tabindex="1">
                                    <v-btn icon @click="SendDevisByMail(props.item)">
                                      <v-icon color="#ffa409">&#xe0be;</v-icon>
                                    </v-btn>
                                  </span>

                                  <span class="tool_button" data-tip="Télécharger devis !" tabindex="1">
                                    <v-btn icon @click="DownloadDevis(props.item)">
                                      <v-icon color="#ffa409">&#xe2c4;</v-icon>
                                    </v-btn>
                                  </span>

                                  <span class="tool_button" data-tip="finaliser devis !" tabindex="1"
                                    v-if="ShowBtnOneDevis(props.item) && props.item.is_devis_flotte != true">
                                    <v-btn class="text-white" flat small round @click="payInsurance(props.item)"
                                      style="background:#ffa409;">
                                      {{ $t('espace_perso.devis_list.payer_label') }}
                                    </v-btn>
                                  </span>
                                </div>
                              </td>
                            </tr>
                          </template>
                          <template v-slot:no-results>
                            <v-alert class="text-center" :value="true" color="error" icon="warning">{{
                              $t('espace_perso.devis_list.found_or_not_label[0]') }}
                              "{{ search }}" {{ $t('espace_perso.devis_list.found_or_not_label[1]') }}
                            </v-alert>
                          </template>
                        </v-data-table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="wizard-card-footer clearfix">
              <div class="wizard-footer-left">
                <button @click="ModalListeDevis = false" type="button" class="wizard-btn">
                  <span class="fas fa-arrow-left"></span>
                  {{ $t('espace_perso.devis_list.bouton_fermer_label') }}
                </button>
              </div>
              <div class="wizard-footer-right">
              </div>
            </div>
          </v-card-text>
        </v-card>
      </v-dialog>

      <!--======================= Modal dialog for Details de Devis ==============================-->
      <v-fab-transition>
        <v-dialog v-model="DetailsDevis" persistent v-if="DetailsDevis == true">
          <v-card elevation="24" class="border-radius">
            <v-card-text style="background:#FAFAFA">
              <div class="wizard-tab-content">
                <div role="tabpanel" id="detailDevisDesktop" aria-hidden="true"
                  aria-labelledby="step-detailDevisDesktop" class="wizard-tab-container">
                  <div>
                    <div class="loan-group loan-group-0">
                      <div class="fields">
                        <div class="field-title font-weight-bold">{{ $t('espace_perso.detail_devis.detail_devis_title')
                          }}
                        </div>
                        <div class="row">
                          <v-container class="border-radius">
                            <v-layout wrap>
                              <div class="col-sm-12">
                                <div class="row border pt-3 pb-3" style="background:#fff;border-radius: 10px;">
                                  <div class="col-sm-4 font-weight-bold">
                                    {{ $t('espace_perso.detail_devis.numero_devis_label') }} :
                                    <span class="font-weight-light">{{ DevisForDetails.numeroDevis.toLocaleString()
                                      }}</span>
                                  </div>
                                  <div class="col-sm-4 font-weight-bold">
                                    {{ $t('espace_perso.detail_devis.accessoire_label') }}
                                    :
                                    <span class="font-weight-light">{{ DevisForDetails.accessoires.toLocaleString() }}
                                      FCFA</span>
                                  </div>
                                  <div class="col-sm-4 font-weight-bold">
                                    {{ $t('espace_perso.detail_devis.prime_ttc_label') }}:
                                    <span class="font-weight-light">{{ DevisForDetails.prime_ttc.toLocaleString() }}
                                      FCFA</span>
                                  </div>
                                </div>

                                <div class="row border mt-2 pt-3 pb-3" style="background:#fff;border-radius: 10px;">
                                  <div class="col-sm-3 font-weight-bold">
                                    {{ $t('espace_perso.detail_devis.assureur_label') }} :
                                    <img :src="DevisForDetails.partenaireid.logo" width="80" alt="partenaire-logo">
                                  </div>
                                  <div class="col-sm-3 font-weight-bold">
                                    {{ $t('espace_perso.detail_devis.date_creation_label') }} :
                                    <span class="font-weight-light">{{ DateFormater(DevisForDetails.dateSouscription)
                                      }}</span>
                                  </div>
                                  <div class="col-sm-3 font-weight-bold">
                                    {{ $t('espace_perso.detail_devis.date_effet_label') }}
                                    :
                                    <span class="font-weight-light">{{ DateFormater(DevisForDetails.dateEffet) }}</span>
                                  </div>
                                  <div class="col-sm-3 font-weight-bold">
                                    {{ $t('espace_perso.detail_devis.date_echeance_label') }} :
                                    <span class="font-weight-light">{{ DateFormater(DevisForDetails.dateEcheance)
                                      }}</span>
                                  </div>
                                </div>

                                <div class="row border mt-2 pt-3 pb-3" style="background:#fff;border-radius: 10px;">
                                  <div class="col-sm-3 font-weight-bold">
                                    {{ $t('espace_perso.detail_devis.branche_label') }} :
                                    <span class="font-weight-light">{{ DevisForDetails.brancheid.branche.toUpperCase()
                                      }}</span>
                                  </div>
                                  <div class="col-sm-3 font-weight-bold"> {{ $t('espace_perso.detail_devis.nom_label')
                                    }}
                                    :
                                    <span class="font-weight-light">{{ DevisForDetails.userid.nom.toUpperCase()
                                      }}</span>
                                  </div>
                                  <div class="col-sm-3 font-weight-bold">
                                    {{ $t('espace_perso.detail_devis.prenom_label') }} :
                                    <span class="font-weight-light">{{ DevisForDetails.userid.prenom.toUpperCase()
                                      }}</span>
                                  </div>
                                  <div class="col-sm-3 font-weight-bold">
                                    {{ $t('espace_perso.detail_devis.telephone_label') }} :
                                    <span class="font-weight-light">{{ DevisForDetails.userid.telephone_port }}</span>
                                  </div>
                                  <div class="col-sm-3 font-weight-bold" v-if="DevisForDetails.courtier">
                                    {{ $t('espace_perso.detail_devis.adresse_label') }} :
                                    <span class="font-weight-light">{{ DevisForDetails.courtier.societe }}</span>
                                  </div>
                                </div>

                                <!-- Facture (CFW-16). Disponible que le devis soit
                                     transforme ou non : le numero est attribue par
                                     l'API a la premiere edition, d'ou le libelle
                                     « Non editee » tant qu'elle n'a pas ete demandee. -->
                                <div class="row border mt-2 pt-3 pb-3" style="background:#fff;border-radius: 10px;">
                                  <div class="col-sm-6 font-weight-bold">
                                    {{ $t('espace_perso.detail_devis.numero_facture_label') }} :
                                    <span class="font-weight-light">{{ DevisForDetails.numeroFacture ||
                                      $t('espace_perso.detail_devis.facture_non_editee_label') }}</span>
                                  </div>
                                  <div class="col-sm-6 text-right">
                                    <v-btn small round class="text-white" style="background:#ffa409;"
                                      :loading="factureEnCours" :disabled="factureEnCours"
                                      @click="DownloadFactureDevis(DevisForDetails)">
                                      {{ factureEnCours ? $t('espace_perso.detail_devis.facture_en_cours_label')
                                        : $t('espace_perso.detail_devis.telecharger_facture_label') }}
                                    </v-btn>
                                  </div>
                                </div>
                              </div>
                            </v-layout>
                          </v-container>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="wizard-card-footer clearfix">
                <div class="wizard-footer-left">
                  <button @click="DetailsDevis = false" type="button" class="wizard-btn">
                    <span class="fas fa-arrow-left"></span>
                    {{ $t('espace_perso.detail_devis.bouton_fermer_label') }}
                  </button>
                </div>
                <div class="wizard-footer-right">
                </div>
              </div>
            </v-card-text>
          </v-card>
        </v-dialog>
      </v-fab-transition>

      <!--======================= Modal dialog for Details de Contrats ==============================-->
      <v-fab-transition>
        <v-dialog v-model="DetailsContrat" persistent v-if="DetailsContrat == true">
          <v-card elevation="24" class="border-radius">
            <v-card-text style="background:#FAFAFA">
              <div class="wizard-tab-content">
                <div role="tabpanel" id="detailContratDesktop" aria-hidden="true"
                  aria-labelledby="step-detailContratDesktop" class="wizard-tab-container">
                  <div>
                    <div class="loan-group loan-group-0">
                      <div class="fields">
                        <div class="field-title font-weight-bold">{{
                          $t('espace_perso.detail_contrat.detail_devis_title') }}
                        </div>
                        <div class="row">
                          <v-container class="border-radius">
                            <v-layout wrap>
                              <div class="col-sm-12">
                                <div class="row border pt-3 pb-3" style="background:#fff;border-radius: 10px;">
                                  <div class="col-sm-3 font-weight-bold"> {{
                                    $t('espace_perso.detail_contrat.numero_devis_label') }} :
                                    <span class="font-weight-light">{{ ContratForDetails.numero_police.toLocaleString()
                                      }}</span>
                                  </div>
                                  <div class="col-sm-3 font-weight-bold"> {{
                                    $t('espace_perso.detail_contrat.accessoire_label') }} :
                                    <span class="font-weight-light">{{ ContratForDetails.accessoires.toLocaleString() }}
                                      FCFA</span>
                                  </div>
                                  <div class="col-sm-3 font-weight-bold"> {{
                                    $t('espace_perso.detail_contrat.prime_nette_label') }} :
                                    <span class="font-weight-light">{{ ContratForDetails.prime_nette.toLocaleString() }}
                                      FCFA</span>
                                  </div>
                                  <div class="col-sm-3 font-weight-bold"> {{
                                    $t('espace_perso.detail_contrat.prime_ttc_label')
                                  }} :
                                    <span class="font-weight-light">{{ ContratForDetails.prime_ttc.toLocaleString() }}
                                      FCFA</span>
                                  </div>
                                </div>

                                <div class="row border mt-2 pt-3 pb-3" style="background:#fff;border-radius: 10px;">
                                  <div class="col-sm-3 font-weight-bold">{{
                                    $t('espace_perso.detail_contrat.assureur_label')
                                  }} :
                                    <img :src="ContratForDetails.partenaireid.logo" width="80" alt="partenaire-logo">
                                  </div>
                                  <div class="col-sm-3 font-weight-bold"> {{
                                    $t('espace_perso.detail_contrat.date_creation_label') }} :
                                    <span class="font-weight-light">{{ DateFormater(ContratForDetails.dateSouscription)
                                      }}</span>
                                  </div>
                                  <div class="col-sm-3 font-weight-bold"> {{
                                    $t('espace_perso.detail_contrat.date_effet_label') }} :
                                    <span class="font-weight-light">{{ DateFormater(ContratForDetails.dateEffet)
                                      }}</span>
                                  </div>
                                  <div class="col-sm-3 font-weight-bold"> {{
                                    $t('espace_perso.detail_contrat.date_echeance_label') }} :
                                    <span class="font-weight-light">{{ DateFormater(ContratForDetails.dateEcheance)
                                      }}</span>
                                  </div>
                                </div>

                                <div class="row border mt-2 pt-3 pb-3" style="background:#fff;border-radius: 10px;">
                                  <div class="col-sm-3 font-weight-bold"> {{
                                    $t('espace_perso.detail_contrat.branche_label')
                                  }} :
                                    <span class="font-weight-light">{{ ContratForDetails.brancheid.branche.toUpperCase()
                                      }}</span>
                                  </div>
                                  <div class="col-sm-3 font-weight-bold"> {{ $t('espace_perso.detail_contrat.nom_label')
                                  }} :
                                    <span class="font-weight-light">{{ ContratForDetails.userid.nom.toUpperCase()
                                      }}</span>
                                  </div>
                                  <div class="col-sm-3 font-weight-bold"> {{
                                    $t('espace_perso.detail_contrat.prenom_label') }}
                                    :
                                    <span class="font-weight-light">{{ ContratForDetails.userid.prenom.toUpperCase()
                                      }}</span>
                                  </div>
                                  <div class="col-sm-3 font-weight-bold">{{
                                    $t('espace_perso.detail_contrat.telephone_label')
                                  }}:
                                    <span class="font-weight-light">{{ ContratForDetails.userid.telephone_port }}</span>
                                  </div>
                                  <div class="col-sm-3 font-weight-bold" v-if="ContratForDetails.courtier">{{
                                    $t('espace_perso.detail_contrat.adresse_label') }} :
                                    <span class="font-weight-light">{{ ContratForDetails.courtier.societe }}</span>
                                  </div>
                                </div>
                              </div>

                              <div class="col-sm-12">
                                <div class="row border pt-3 pb-3" v-if="recurent_pay_history.length > 0"
                                  style="background:#fff;border-radius: 10px;">
                                  <span class="mt-4 ml-3 title highlight">
                                    {{ $t('espace_perso.detail_contrat.histoire_paiement_label') }}
                                    <span class="ml-2" style="color:red">
                                      {{ ContratForDetails.numero_police.toLocaleString() }}
                                    </span>
                                  </span>
                                  <v-data-table :headers="$t('espace_perso.detail_contrat.paymentHistoryHeader')"
                                    :items="recurent_pay_history" class="border-radius elevation-24 mt-2">
                                    <template slot="items" slot-scope="props">
                                      <td> {{ DateFormater(props.item.createdAt) }}</td>
                                      <td> {{ props.item.numero }}</td>
                                      <td> {{ props.item.contratid.prime_nette.toLocaleString() }} Fcfa </td>
                                      <td> {{ props.item.contratid.details[0].duree }}</td>
                                      <td> {{ props.item.contratid.details[0].capital.toLocaleString() }} Fcfa </td>
                                      <td> {{ props.item.contratid.details[0].Rente.toLocaleString() }} Fcfa </td>
                                    </template>
                                  </v-data-table>
                                </div>
                              </div>

                              <div class="col-sm-12">
                                <div class="row pt-3 pb-3" v-if="get_type(ContratForDetails.details[0]) != 'undefined'">
                                  <div
                                    v-if="get_type(ContratForDetails.details[0].questionnaire_medical) != 'undefined'">
                                    <v-flex xs12 class="justify-content-center row"
                                      v-for="(c, index) in ContratForDetails.details" :key="index">
                                      <v-expansion-panels class="col-sm-12">
                                        <v-expansion-panel class="focusablee">
                                          <v-expansion-panel-content class="pl-3">
                                            <v-expansion-panel-header slot="header" class="policeLato">
                                              Questionnaire médical pour {{ c.nom.toUpperCase() }} -
                                              {{ c.prenom.toUpperCase() }}
                                            </v-expansion-panel-header>
                                            <v-flex class="row  policeLato ma-2 border pb-3"
                                              v-for="(q, index) in c.questionnaire_medical" :key="index">
                                              <v-flex xs12 style="color:red" pl-1 class="h5">
                                                Question numéro
                                                <span class="font-weight-bold">
                                                  {{ q.numero }}
                                                </span>
                                              </v-flex>
                                              <v-flex xs12 v-for="(ch, index) in q.champs" :key="index"
                                                class="pt-3  pl-3">
                                                <v-flex class="row">
                                                  <v-flex xs6 pl-2>
                                                    <span class="font-weight-bold">
                                                      {{ ch.question }}
                                                    </span>
                                                  </v-flex>

                                                  <v-flex xs6 mt-1 v-if="ch.type_reponse == 'string' && q.numero != 1">
                                                    <textarea v-model="ch.reponse" class="border" cols="70"
                                                      rows="4"></textarea>
                                                  </v-flex>

                                                  <v-flex xs6 mt-1 v-if="ch.type_reponse == 'string' && q.numero == 1">
                                                    <div class="font-weight-bold ml-2">
                                                      {{ c.nom.toUpperCase() }} - {{ c.prenom.toUpperCase() }}
                                                    </div>
                                                  </v-flex>

                                                  <v-flex xs6 mt-1 v-if="ch.type_reponse == 'radio'">
                                                    <v-radio-group full-width v-model="ch.reponse" class="ml-1">
                                                      <v-radio color="#ffa409" label="Oui" value="oui"></v-radio>
                                                      <v-radio color="#ffa409" label="Non" value="non"></v-radio>
                                                    </v-radio-group>
                                                  </v-flex>

                                                  <v-flex xs6 mt-1 v-if="ch.type_reponse == 'number'">
                                                    <input v-model="ch.reponse" type="number"
                                                      placeholder="Votre réponse ici" class="border pa-2 col-sm-12">
                                                  </v-flex>

                                                  <v-flex xs6 mt-1 v-if="ch.type_reponse == 'date'">
                                                    <input v-model="ch.reponse" type="date"
                                                      placeholder="Votre réponse ici" class="border pa-2 col-sm-12">
                                                  </v-flex>

                                                </v-flex>
                                              </v-flex>
                                            </v-flex>
                                          </v-expansion-panel-content>
                                        </v-expansion-panel>
                                      </v-expansion-panels>
                                    </v-flex>

                                    <v-btn class="info" small flat @click="SaveMedicalQuestion(ContratForDetails)">
                                      Enregistrer le questionnaire
                                      <span style="color:black;font-weight:bold">(1)</span>
                                    </v-btn>

                                    <v-btn class="success" small flat @click="submitMedicalQuestion(ContratForDetails)">
                                      Soumettre le questionnaire
                                      <span style="color:black;font-weight:bold">(2)</span>
                                    </v-btn>

                                    <div class="row">
                                      <div class="col-12">
                                        <small style="color:red;"> <i>1 : Sauvegarder l'état d'avancement du
                                            questionnaire</i></small>
                                      </div>
                                      <div class="col-12">
                                        <small style="color:red;"> <i>2 : Une fois le remplissage terminé, soumettre
                                          </i>
                                        </small>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>

                              <div class="col-sm-12">
                                <div v-if="get_type(ContratForDetails.details[0]) != 'undefined'"
                                  class="col-sm-12 mt-2 pt-2" style="border-radius: 10px;">
                                  <div
                                    v-if="get_type(ContratForDetails.details[0].contractor) != 'undefined' && get_type(ContratForDetails.details[0].contractor.Questionnaire) != 'undefined'">
                                    <v-flex xs12>
                                      <v-expansion-panels>
                                        <v-expansion-panel>
                                          <v-expansion-panel-content>
                                            <v-expansion-panel-header slot="header" class="policeLato">
                                              Questionnaire médical
                                            </v-expansion-panel-header>
                                            <v-flex class="row policeLato ma-2 border rounded pb-3"
                                              v-for="(q, index) in ContratForDetails.details[0].contractor.Questionnaire"
                                              :key="index">

                                              <v-flex class="font-weight-bold" xs10 offset-1
                                                style="color:red;font-size:14px;" pl-1>
                                                {{ q.block_title }}
                                              </v-flex>

                                              <v-flex xs12 pl-2>
                                                <span class="font-weight-bold"> {{ q.configurations.numero }} </span>
                                              </v-flex>

                                              <v-flex xs10 offset-1 v-for="(ch, index) in q.configurations" :key="index"
                                                class="pt-3 pl-3">

                                                <v-flex class="row" v-for="(c, index) in ch.champs" :key="index">
                                                  <v-flex xs10 mt-1 v-if="c.type_reponse == 'text'">
                                                    <span for="" class="font-weight-bold" style="font-size:11px;">
                                                      {{ c.question }}
                                                    </span>
                                                    <input v-model="c.reponse" type="text"
                                                      placeholder="Votre réponse ici" class="border pa-2 col-sm-12">
                                                  </v-flex>

                                                  <v-flex xs10 mt-1 v-if="c.type_reponse == 'radio'">
                                                    {{ c.question }}
                                                    <v-radio-group full-width v-model="c.reponse" class="ml-1">
                                                      <v-radio color="#ffa409" label="Oui" value="oui"></v-radio>
                                                      <v-radio color="#ffa409" label="Non" value="non"></v-radio>
                                                    </v-radio-group>
                                                  </v-flex>

                                                  <v-flex xs10 mt-1 v-if="c.type_reponse == 'number'">
                                                    {{ c.question }}
                                                    <input v-model="c.reponse" type="number"
                                                      placeholder="Votre réponse ici" class="border pa-2 col-sm-12">
                                                  </v-flex>

                                                  <v-flex xs10 mt-1 v-if="c.type_reponse == 'date'">
                                                    {{ c.question }}
                                                    <input v-model="c.reponse" type="date"
                                                      placeholder="Votre réponse ici" class="border pa-2 col-sm-12">
                                                  </v-flex>

                                                  <v-flex xs10 mt-1 v-if="c.type_reponse == ''"
                                                    class="font-weight-black">
                                                    {{ c.question }}
                                                  </v-flex>

                                                </v-flex>
                                              </v-flex>

                                            </v-flex>
                                          </v-expansion-panel-content>
                                        </v-expansion-panel>
                                      </v-expansion-panels>
                                    </v-flex>


                                    <v-btn small flat class="info" @click="SaveIndividuelAccidentQM(ContratForDetails)">
                                      Enregistrer le questionnaire
                                      <span style="color:black;font-weight:bold">(1)</span>
                                    </v-btn>

                                    <v-btn small flat class="success"
                                      @click="GenerateIndividuelAccidentQM(ContratForDetails)">
                                      Soumettre le questionnaire
                                      <span style="color:black;font-weight:bold">(2)</span>
                                    </v-btn>

                                    <div class="row">
                                      <div class="col-12">
                                        <small style="color:red;"> <i>1 : Sauvegarder l'état d'avancement du
                                            questionnaire</i></small>
                                      </div>
                                      <div class="col-12">
                                        <small style="color:red;"> <i>2 : Une fois le remplissage terminé, soumettre
                                          </i>
                                        </small>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div class="d-flex align-end">
                              <div class="">
                             <!-- Contrat provisoire -->
                                  <v-btn
                                    v-bind="attrs"
                                    v-on="on"
                                    :color="'#ffa409'"
                                    dark
                                    large
                                    rounded
                                    class="modern-btn"
                                    elevation="2"
                                    @click="downloadContratProvisoire(ContratForDetails)"
                                  >
                                    <v-icon left>&#xe2c4;</v-icon>
                                    {{ $t('espace_perso.detail_contrat.telecharger_attestation_provisoire_label') || 'Télécharger contrat provisoire' }}
                                  </v-btn>
                              <!-- Attestation définitive -->
                                  <v-btn
                                    v-bind="attrs"
                                    v-on="on"
                                    :color="(getAttestationLink(ContratForDetails)) ? '#ffa409' : '#c8c8c8ff'"
                                    dark
                                    large
                                    rounded
                                    class="modern-btn"
                                    elevation="2"
                                    @click="downloadTalon(getAttestationLink(ContratForDetails))"
                                  >
                                    <v-icon left>&#xe2c4;</v-icon>
                                    {{ $t('espace_perso.detail_contrat.telecharger_attestation_definitive_label') || 'Télécharger talon' }}
                                  </v-btn>
                            </div>
                            </div>
                            </v-layout>
                          </v-container>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="wizard-card-footer clearfix">
                <div class="wizard-footer-left">
                  <button @click="DetailsContrat = false; recurent_pay_history = []" type="button" class="wizard-btn">
                    <span class="fas fa-arrow-left"></span>
                    {{ $t('espace_perso.detail_contrat.bouton_fermer_label') }}
                  </button>
                </div>
                <div class="wizard-footer-right">
                </div>
              </div>
            </v-card-text>
          </v-card>
        </v-dialog>
      </v-fab-transition>
      <!--Fin Modal dialog pour Details contrat-->

      <!--Modal dialog for Mes point-->
      <v-fab-transition>
        <v-dialog v-model="dialogMesPoints" max-width="400px" persistent>
          <v-card elevation="24" class="border-radius">
            <v-card-text style="background:#FAFAFA">
              <div class="wizard-tab-content">
                <div role="tabpanel" id="detailsPointDesktop" aria-hidden="true"
                  aria-labelledby="step-detailsPointDesktop" class="wizard-tab-container">
                  <div>
                    <div class="loan-group loan-group-0">
                      <div class="fields">
                        <div class="field-title font-weight-bold">{{ $t('espace_perso.point_assuraf.vos_points[0]') }}
                          <span style="color: #ffa409">{{ $t('espace_perso.point_assuraf.vos_points[1]') }}</span>
                        </div>
                        <div class="row">
                          <div class="col-sm-12">
                            <p class="h2 font-weight-bold" v-if="UserPoints > 1"> {{ UserPoints }} pts</p>
                            <p class="h2 font-weight-bold" v-if="UserPoints == 1"> {{ UserPoints }} pt</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="wizard-card-footer clearfix">
                <div class="wizard-footer-left">
                  <button @click="dialogMesPoints = false" type="button" class="wizard-btn">
                    <span class="fas fa-arrow-left"></span>
                    {{ $t('espace_perso.point_assuraf.bouton_fermer_label') }}
                  </button>
                </div>
                <div class="wizard-footer-right">
                </div>
              </div>
            </v-card-text>
          </v-card>
        </v-dialog>
      </v-fab-transition>
      <!--Modal dialog for Mes points-->
    </div>

    <div>
      <v-layout row justify-center v-if="isMobile()">
        <!-- Modal dialog for display user profil -->
        <v-dialog v-model="dialog" max-width="1000" persistent>
          <v-card elevation="24" class="border-radius">
            <v-card-text style="background:#FAFAFA">
              <div class="wizard-tab-content">
                <div role="tabpanel" id="monProfilMobile" aria-hidden="true" aria-labelledby="step-monProfilMobile"
                  class="wizard-tab-container">
                  <div>
                    <div class="loan-group loan-group-0">
                      <div class="fields">
                        <div class="field-title font-weight-bold">{{ $t('espace_perso.profil_form.profil_title') }}
                        </div>
                        <div class="justify-content-center row">
                          <img :src="this.$store.state.user.photo" alt="user-photo" width="200" v-if="userInfos.photo"
                            class="imagechange">
                          <img :src="image" alt="user-icon" width="200" v-else-if="image" class="imagechange">
                          <img src="../../assets/img/user_icon.png" class="imagechange" alt="user-icon" width="200" v-else>
                          <div class="offset-1 mt-3">
                            <label for="fileMobile" class="label-file"> <i
                                class="material-icons" aria-hidden="true" data-nosnippet>&#xe439;</i></label>
                            <input id="fileMobile" class="input-file" type="file" ref="file"
                              @change="UpdateUserPicture">
                          </div>
                        </div>
                        <div class="mt-2 row">
                          <div class="col-sm-4">
                            <div class="field-group field-default mb-4 mb-sm-0">
                              <label for="StepperNomMobile" class="field-label">{{
                                $t('espace_perso.profil_form.nom_label')
                                }}</label>
                              <input readonly v-model="userInfos.nom"
                                :placeholder="$t('espace_perso.profil_form.nom_placeholder')" id="StepperNomMobile"
                                name="Step8" class="field-input">
                            </div>
                          </div>
                          <div class="col-sm-4">
                            <div class="field-group field-default mb-4 mb-sm-0">
                              <label for="StepperPrenomMobile" class="field-label">{{
                                $t('espace_perso.profil_form.prenom_label') }}</label>
                              <input readonly v-model="userInfos.prenom"
                                :placeholder="$t('espace_perso.profil_form.prenom_placeholder')"
                                id="StepperPrenomMobile" name="Step8" class="field-input">
                            </div>
                          </div>
                          <div class="col-sm-4">
                            <div class="field-group field-default mb-4 mb-sm-0">
                              <label for="StepperNaissanceMobile" class="field-label">{{
                                $t('espace_perso.profil_form.date_naissance_label') }}</label>
                              <input readonly v-model="userInfos.datenaissance"
                                :placeholder="$t('espace_perso.profil_form.date_naissance_placeholder')"
                                id="StepperNaissanceMobile" name="Step8" class="field-input">
                            </div>
                          </div>
                          <div class="col-sm-4">
                            <div class="field-group field-default mb-4 mb-sm-0">
                              <label for="StepperAdresseMobile" class="field-label">{{
                                $t('espace_perso.profil_form.adresse_label') }}</label>
                              <input readonly v-model="userInfos.adresse"
                                :placeholder="$t('espace_perso.profil_form.adresse_placeholder')"
                                id="StepperAdresseMobile" name="Step8" class="field-input">
                            </div>
                          </div>
                          <div class="col-sm-4">
                            <div class="field-group field-default mb-4 mb-sm-0">
                              <label for="StepperTypePieceMobile" class="field-label">{{
                                $t('espace_perso.profil_form.type_piece_label') }}</label>
                              <input readonly v-model="userInfos.piece_identite"
                                :placeholder="$t('espace_perso.profil_form.type_piece_placeholder')"
                                id="StepperTypePieceMobile" name="Step8" class="field-input">
                            </div>
                          </div>
                          <div class="col-sm-4">
                            <div class="field-group field-default mb-4 mb-sm-0">
                              <label for="StepperNumeroPieceMobile" class="field-label">{{
                                $t('espace_perso.profil_form.numero_piece_label') }}</label>
                              <input readonly v-model="userInfos.numero_piece"
                                :placeholder="$t('espace_perso.profil_form.numero_piece_placeholder')"
                                id="StepperNumeroPieceMobile" name="Step8" class="field-input">
                            </div>
                          </div>
                          <div class="col-sm-4">
                            <div class="field-group field-default mb-4 mb-sm-0">
                              <label for="StepperEmailMobile" class="field-label">{{
                                $t('espace_perso.profil_form.email_label') }}</label>
                              <input readonly v-model="userInfos.email"
                                :placeholder="$t('espace_perso.profil_form.email_placeholder')" id="StepperEmailMobile"
                                name="Step8" class="field-input">
                            </div>
                          </div>
                          <div class="col-sm-4">
                            <div class="field-group field-default mb-4 mb-sm-0">
                              <label for="StepperTelMobile" class="field-label">{{
                                $t('espace_perso.profil_form.numero_label') }}</label>
                              <input readonly v-model="userInfos.telephone_port"
                                :placeholder="$t('espace_perso.profil_form.numero_placeholder')" id="StepperTelMobile"
                                name="Step8" class="field-input">
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="wizard-card-footer clearfix">
                <div class="wizard-footer-left">
                </div>
                <div class="wizard-footer-right">
                  <button @click="Intent_update_profil()" type="button" class="wizard-btn">
                    {{ $t('espace_perso.profil_form.bouton_modif_infos') }}
                  </button>

                  <!-- <button @click="resetPasswordModal = true, dialog = false" type="button" class="mt-3 ml-3 wizard-btn">
                    {{ $t('espace_perso.profil_form.bouton_modif_password') }}
                  </button> -->

                  <button v-if="allowCard()" @click="loadPopUpForPhoneUpdate(), dialog = false" type="button" class="mt-3 ml-3 wizard-btn">
                    {{ $t('espace_perso.profil_form.bouton_modif_numero') }}
                  </button>
                </div>
              </div>

              <div class="wizard-card-footer clearfix">
                <div class="wizard-footer-left">
                  <button @click="dialog = false" type="button" class="wizard-btn">
                    <span class="fas fa-arrow-left"></span>
                    {{ $t('espace_perso.profil_form.bouton_fermer') }}
                  </button>
                </div>
                <div class="wizard-footer-right">

                </div>
              </div>
            </v-card-text>
          </v-card>
        </v-dialog>

        <!--============================= Modal modification de profil mobile======================================== -->
        <v-dialog v-model="dialogEditProfil" max-width="650" persistent>
          <v-card elevation="24" class="border-radius">
            <v-card-text style="background:#FAFAFA">
              <div class="wizard-tab-content">
                <div role="tabpanel" id="modifProfilMobile" aria-hidden="true" aria-labelledby="step-modifProfilMobile"
                  class="wizard-tab-container">
                  <div>
                    <div class="loan-group loan-group-0">
                      <div class="fields">
                        <div class="field-title font-weight-bold">{{ $t('espace_perso.profil_info_form.info_title') }}
                        </div>
                        <div class="row">
                          <div class="col-sm-4">
                            <div class="field-group field-default mb-4 mb-sm-0">
                              <label for="StepperModifNom" class="field-label">{{
                                $t('espace_perso.profil_info_form.nom_label') }}</label>
                              <input v-model="userInfos.nom"
                                :placeholder="$t('espace_perso.profil_info_form.nom_placeholder')" id="StepperModifNom"
                                name="Step8" class="field-input">
                            </div>
                          </div>
                          <div class="col-sm-4">
                            <div class="field-group field-default mb-4 mb-sm-0">
                              <label for="StepperModifPrenom" class="field-label">{{
                                $t('espace_perso.profil_info_form.prenom_label') }}</label>
                              <input v-model="userInfos.prenom"
                                :placeholder="$t('espace_perso.profil_info_form.prenom_placeholder')"
                                id="StepperModifPrenom" name="Step8" class="field-input">
                            </div>
                          </div>
                          <div class="col-sm-4">
                            <div class="field-group field-default mb-4 mb-sm-0">
                              <label for="StepperModifType" class="field-label">{{
                                $t('espace_perso.profil_info_form.type_piece_label') }}</label>
                              <select v-model="userInfos.piece_identite" id="StepperModifType" name="Step8"
                                class="field-select">
                                <option v-for="item in itemsType" :key="item" :value="item">{{ item }}</option>
                              </select>
                            </div>
                          </div>
                          <div class="col-sm-4">
                            <div class="field-group field-default mb-4 mb-sm-0">
                              <label for="StepperModifNumero" class="field-label">{{
                                $t('espace_perso.profil_info_form.numero_piece_label') }}</label>
                              <input v-model="userInfos.numero_piece"
                                :placeholder="$t('espace_perso.profil_info_form.numero_piece_placeholder')"
                                id="StepperModifNumero" name="Step8" class="field-input">
                            </div>
                          </div>
                          <div class="col-sm-4">
                            <div class="field-group field-default mb-4 mb-sm-0">
                              <label for="StepperModifStatut" class="field-label">{{
                                $t('espace_perso.profil_info_form.statut_marital_label') }}</label>
                              <select v-model="userInfos.statut_marital" id="StepperModifStatut" name="Step8"
                                class="field-select">
                                <option v-for="item in itemsStatutMarital" :key="item" :value="item">{{ item }}</option>
                              </select>
                            </div>
                          </div>
                          <div class="col-sm-4">
                            <div class="field-group field-default mb-4 mb-sm-0">
                              <label for="StepperModifProfession" class="field-label">{{
                                $t('espace_perso.profil_info_form.profession_label') }}</label>
                              <input v-model="userInfos.profession"
                                :placeholder="$t('espace_perso.profil_info_form.profession_placeholder')"
                                id="StepperModifProfession" name="Step8" class="field-input">
                            </div>
                          </div>
                          <div class="col-sm-4">
                            <div class="field-group field-default mb-4 mb-sm-0">
                              <label for="StepperModifMail" class="field-label">{{
                                $t('espace_perso.profil_info_form.email_label') }}</label>
                              <input v-model="userInfos.email"
                                :placeholder="$t('espace_perso.profil_info_form.email_placeholder')"
                                id="StepperModifMail" name="Step8" class="field-input">
                            </div>
                          </div>
                          <div class="col-sm-4">
                            <div class="field-group field-default mb-4 mb-sm-0">
                              <label for="StepperModifSexe" class="field-label">{{
                                $t('espace_perso.profil_info_form.sexe_label') }}</label>
                              <select v-model="userInfos.sexe" id="StepperModifSexe" name="Step8" class="field-select">
                                <option v-for="item in itemsSexe" :key="item" :value="item">{{ item }}</option>
                              </select>
                            </div>
                          </div>
                          <div class="col-sm-4">
                            <div class="field-group field-default mb-4 mb-sm-0">
                              <label for="StepperModifTel" class="field-label">{{
                                $t('espace_perso.profil_info_form.telephone_port_label') }}</label>
                              <input v-model="userInfos.telephone_port"
                                :placeholder="$t('espace_perso.profil_info_form.telephone_port_placeholder')"
                                id="StepperModifTel" name="Step8" class="field-input">
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="wizard-card-footer clearfix">
                <div class="wizard-footer-left">
                  <button @click="dialogEditProfil = false" type="button" class="wizard-btn">
                    <span class="fas fa-arrow-left"></span>
                    {{ $t('espace_perso.profil_info_form.bouton_fermer_label') }}
                  </button>
                </div>
                <div class="wizard-footer-right">
                  <button @click="userUpdate()" type="button" class="wizard-btn">
                    {{ $t('espace_perso.profil_info_form.bouton_save_label') }}
                  </button>
                </div>
              </div>
            </v-card-text>
          </v-card>
        </v-dialog>
        <!-- ===========Fin modif profil mobile====== -->

        <!-- =========================== Modal dialog for assistance Mobile ========================= -->
        <v-dialog v-model="assistanceDialog" max-width="1000" persistent>
          <v-card elevation="24" class="border-radius">
            <v-card-text style="background:#FAFAFA">
              <div class="wizard-tab-content">
                <div role="tabpanel" id="assistance" aria-hidden="true" aria-labelledby="step-assistance"
                  class="wizard-tab-container">
                  <div>
                    <div class="loan-group loan-group-0">
                      <div class="fields">
                        <div class="field-title font-weight-bold">Assistance</div>
                        <div class="row">
                          <div class="col-sm-4">
                            <div class="field-group field-default mb-4 mb-sm-0">
                              <label for="heureAssisMobile" class="field-label">Horaire de rappel*</label>
                              <select v-model="horaire" id="heureAssisMobile" name="Step8" class="field-select">
                                <option v-for="itm in itema" :key="itm" :value="itm">{{ itm }}</option>
                              </select>
                            </div>
                          </div>
                          <div class="col-sm-4">
                            <div class="field-group field-default mb-4 mb-sm-0">
                              <label for="canalAssisMobile" class="field-label">Canal de rappel*</label>
                              <select v-model="canal" id="canalAssisMobile" name="Step8" class="field-select">
                                <option v-for="itm in rappel" :key="itm" :value="itm">{{ itm }}</option>
                              </select>
                            </div>
                          </div>
                          <div class="col-sm-4">
                            <div class="field-group field-default mb-4 mb-sm-0">
                              <label for="nomAssisMobile" class="field-label">Nom</label>
                              <input v-model="name" placeholder="Votre nom" id="nomAssisMobile" name="infosAssis"
                                class="field-input" />
                            </div>
                          </div>
                          <div class="col-sm-4">
                            <div class="field-group field-default mb-4 mb-sm-0">
                              <label for="numAssisMobile" class="field-label">
                                Téléphone
                                <!---->
                              </label>
                              <div class="input-group value-loan">
                                <input placeholder="Numéro de téléphone" @keypress="onlyNumber" v-model="tel"
                                  id="numAssisMobile" name="infosAssis" class="field-input" />
                              </div>
                            </div>
                          </div>
                          <div class="col-sm-4">
                            <div class="field-group field-default mb-4 mb-sm-0">
                              <label for="ObjectAssisMobile" class="field-label">
                                Objet
                                <!---->
                              </label>
                              <div class="input-group value-loan">
                                <input placeholder="Objet" v-model="objetRappel" id="ObjectAssisMobile"
                                  name="infosAssis" class="field-input" />
                              </div>
                            </div>
                          </div>
                          <div class="col-sm-4">
                            <div class="field-group field-default mb-4 mb-sm-0">
                              <label for="RemarqueAssisMobile" class="field-label">
                                Remarque(s)
                                <!---->
                              </label>
                              <div class="input-group value-loan">
                                <textarea rows="4" cols="50" placeholder="Saisir remarque(s)" v-model="remarques"
                                  id="RemarqueAssisMobile" name="infosAssis" class="field-input"></textarea>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="wizard-card-footer clearfix">
                <div class="wizard-footer-left">
                  <button @click="assistanceDialog = false" type="button" class="wizard-btn">
                    <span class="fas fa-arrow-left"></span>
                    Fermer
                  </button>
                </div>
                <div class="wizard-footer-right">
                  <button @click="AddAssistance()" type="button" class="wizard-btn">
                    Valider
                  </button>
                </div>
              </div>
            </v-card-text>
          </v-card>
        </v-dialog>

        <!--    ==========================Modal for devis mobile ============================================ -->
        <v-dialog v-model="ModalListeDevis" persistent max-width="800px" v-if="isMobile()">
          <v-card elevation="24" class="border-radius">
            <v-card-text style="background:#FAFAFA">
              <div class="wizard-tab-content">
                <div role="tabpanel" id="mes_devis_mobile" aria-hidden="true" aria-labelledby="step-mes_devis_mobile"
                  class="wizard-tab-container">
                  <div>
                    <div class="loan-group loan-group-0">
                      <div class="fields">
                        <div class="field-title">{{ $t('espace_perso.devis_list.devis_title') }}</div>
                        <div class="row">
                          <div class="col-sm-6">
                            <div class="field-group field-default mb-4 mb-sm-0">
                              <label for="StepperRecherche" class="field-label">{{
                                $t('espace_perso.devis_list.recherche_label') }}</label>
                              <input v-model="search" :placeholder="$t('espace_perso.devis_list.recherche_placeholder')"
                                id="StepperRecherche" name="Step8" class="field-input">
                            </div>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-sm-12">
                            <v-data-table :headers="$t('espace_perso.devis_list.newHeader')" :items="userDevis"
                              :search="search" class="small stripped border mt-2" style="z-index: 10000">
                              <template slot="items" slot-scope="props">
                                <td>
                                  <a href="javascript: void(0)" @click="getItemDetail(props.item)">
                                    {{ DateFormater(props.item.dateSouscription) }}
                                  </a>
                                </td>

                                <td>
                                  <a href="javascript: void(0)" @click="getItemDetail(props.item)">{{ props.item.numeroDevis }}</a>
                                  <br>
                                  <a href="javascript: void(0)">
                                <td v-if="ShowBtnOneDevis(props.item) && props.item.is_devis_flotte != true">
                                  <v-btn class="text-white" small round @click="payInsurance(props.item)"
                                    style="background:#ffa409;">
                                    {{ $t('espace_perso.devis_list.payer_label') }}
                                  </v-btn>
                                </td>
                                </a>
                                </td>
                              </template>

                              <template v-slot:no-results>
                                <v-alert :value="true" color="error" icon="warning">{{
                                  $t('espace_perso.devis_list.found_or_not_label[0]') }} "{{
                                    search }}" {{ $t('espace_perso.devis_list.found_or_not_label[1]') }}
                                </v-alert>
                              </template>
                            </v-data-table>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="wizard-card-footer clearfix">
                <div class="wizard-footer-left">
                  <button @click="ModalListeDevis = false" type="button" class="wizard-btn">
                    <span class="fas fa-arrow-left"></span>
                    {{ $t('espace_perso.devis_list.bouton_fermer_label') }}
                  </button>
                </div>
                <div class="wizard-footer-right">

                </div>
              </div>
            </v-card-text>
          </v-card>
        </v-dialog>

        <!-- ----------------------- Modal dialog for document Mobile ----------------------------------------- -->
        <v-dialog v-model="ModalMesDocuments" max-width="700">
          <v-card tile>
            <v-toolbar card dark style="background: #ffa409">
              <v-toolbar-title class="policeLato "><i class="material-icons" aria-hidden="true" data-nosnippet>&#xe2c8;</i>Mes documents
              </v-toolbar-title>
              <v-spacer></v-spacer>
              <v-btn icon dark flat @click="ModalMesDocuments = false" class="float-lg-right">
                <v-icon>&#xe5cd;</v-icon>
              </v-btn>
            </v-toolbar>
            <v-card-text>
              <v-container grid-list-md>
                <v-layout wrap>
                  <v-flex xs6 sm6 md6 class="text-lg-center">
                    <span class="font-weight-bold">
                      <i class="material-icons  vflex" aria-hidden="true" data-nosnippet
                        style="color: #ffa409; font-size:50px; justify-content:center">&#xe2c8;</i>
                      <br>
                      <v-btn style="margin-left:-40px;" @click="ModalMesDocumentsAdd = true" flat>Carte d'identité ({{
                        userContrat.count }})</v-btn>
                    </span>
                  </v-flex>

                  <v-flex xs6 sm6 md6 class="text-lg-center">
                    <span class="font-weight-bold">
                      <i class="material-icons  vflex" aria-hidden="true" data-nosnippet
                        style="color: #ffa409; font-size:50px;  margin-left:60px;">&#xe2c8;</i>
                      <br>
                      <v-btn style="margin-left:20px;" @click="ModalMesDocumentsAdd = true" flat>passeport ({{
                        userContrat.count }})</v-btn>
                    </span>
                  </v-flex>

                  <v-flex xs6 sm6 md6 class="text-lg-center">
                    <span class="font-weight-bold">
                      <i class="material-icons vflex" aria-hidden="true" data-nosnippet style="color: #ffa409; font-size:50px;">&#xe2c8;</i>
                      <br>
                      <v-btn style="margin-left:-40px;" @click="ModalMesDocumentsAdd = true" flat>carte grise ({{
                        userContrat.count }})</v-btn>
                    </span>
                  </v-flex>

                  <v-flex xs6 sm6 md6 class="text-lg-center">
                    <span class="font-weight-bold">
                      <i class="material-icons  vflex" aria-hidden="true" data-nosnippet
                        style="color: #ffa409; font-size:50px;  margin-left:60px;">&#xe2c8;</i>
                      <br>
                      <v-btn style="margin-left:20px;" @click="ModalMesDocumentsAdd = true" flat>permis ({{
                        userContrat.count }})</v-btn>
                    </span>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card-text>
          </v-card>
        </v-dialog>

        <!-- ==========================modal for contenu devis mobile============================================== -->
        <v-dialog v-model="detailsDevisDialog" persistent max-width="600px" v-if="isMobile()">
          <v-card elevation="24" class="border-radius">
            <v-card-text style="background:#FAFAFA">
              <div class="wizard-tab-content">
                <div role="tabpanel" id="detailDevis_mobile" aria-hidden="true"
                  aria-labelledby="step-detailDevis_mobile" class="wizard-tab-container">
                  <div>
                    <div class="loan-group loan-group-0">
                      <div class="fields">
                        <div class="field-title">{{ $t('espace_perso.detail_devis.detail_devis_title') }}</div>
                        <div class="row">
                          <div class="col-sm-12">
                            <v-container class="border-radius scroll">
                              <v-layout wrap v-if="detailsDevisDialog == true">
                                <div class="col-sm-6 " style="margin-top:20px;" id="info">
                                  <div class="col border p-2 pl-5" style="background:#fff;border-radius: 10px;">
                                    <span class="font-weight-black">{{
                                      $t('espace_perso.detail_devis.numero_devis_label') }}
                                      :</span>
                                    <span> {{ devisDetails.numeroDevis }}</span>
                                  </div>

                                  <div class="col border p-2 pl-5 mt-2" style="background:#fff;border-radius: 10px;">
                                    <span class="font-weight-black">{{ $t('espace_perso.detail_devis.branche_label') }}
                                      :</span>
                                    <span>{{ devisDetails.brancheid.branche }}</span>
                                  </div>

                                  <div class="col border p-2 pl-5 mt-2" style="background:#fff;border-radius: 10px;">
                                    <span class="font-weight-black">{{ $t('espace_perso.detail_devis.date_effet_label')
                                      }}
                                      :
                                    </span>
                                    <span> {{ DateFormater(devisDetails.dateEffet) }}</span>
                                  </div>

                                  <div class="col border p-2 pl-5 mt-2" style="background:#fff;border-radius: 10px;">
                                    <span class="font-weight-black">{{
                                      $t('espace_perso.detail_devis.date_echeance_label')
                                      }}
                                      : </span>
                                    <span> {{ DateFormater(devisDetails.dateEcheance) }}</span>
                                  </div>

                                  <div class="col border p-2 pl-5 mt-2" style="background:#fff;border-radius: 10px;">
                                    <span class="font-weight-black">{{ $t('espace_perso.detail_devis.assureur_label') }}
                                      :</span>
                                    <img :src="devisDetails.partenaireid.logo" width="50" alt="partenaire-logo" class="ml-1">
                                  </div>

                                  <div class="col border p-2 pl-5 mt-2" style="background:#fff;border-radius: 10px;">
                                    <span class="font-weight-black">{{ $t('espace_perso.detail_devis.prime_ttc_label')
                                      }}
                                      :</span>
                                    <span> {{ devisDetails.prime_ttc.toLocaleString() }} FCFA</span>
                                  </div>

                                  <!-- Facture (CFW-16) — meme bloc que sur le detail desktop. -->
                                  <div class="col border p-2 pl-5 mt-2" style="background:#fff;border-radius: 10px;">
                                    <span class="font-weight-black">{{
                                      $t('espace_perso.detail_devis.numero_facture_label') }}
                                      :</span>
                                    <span> {{ devisDetails.numeroFacture ||
                                      $t('espace_perso.detail_devis.facture_non_editee_label') }}</span>
                                    <div class="mt-2">
                                      <v-btn small round class="text-white" style="background:#ffa409;"
                                        :loading="factureEnCours" :disabled="factureEnCours"
                                        @click="DownloadFactureDevis(devisDetails)">
                                        {{ factureEnCours ? $t('espace_perso.detail_devis.facture_en_cours_label')
                                          : $t('espace_perso.detail_devis.telecharger_facture_label') }}
                                      </v-btn>
                                    </div>
                                  </div>

                                  <div class="col border p-2 pl-5 mt-2" style="background:#fff;border-radius: 10px;">
                                    <ul class="list-boutons"
                                      style="display:flex; flex-direction:row;margin-left:-10px;">
                                      <li style="margin-left:3px;">
                                        <v-tooltip v-model="show" top>
                                          <template v-slot:activator="{ on }">
                                            <v-btn icon v-on="on" @click="DownloadDevis(devisDetails)">
                                              <v-icon color="grey">&#xe2c4;</v-icon>
                                            </v-btn>
                                          </template>
                                          <span>{{ $t('espace_perso.detail_devis.telecharger_label') }}</span>
                                        </v-tooltip>
                                      </li>

                                      <li style="margin-left:3px;">
                                        <v-tooltip v-model="show" top>
                                          <template v-slot:activator="{ on }">
                                            <v-btn icon v-on="on" @click="SendDevisByMail(devisDetails)">
                                              <v-icon color="grey">&#xe0be;</v-icon>
                                            </v-btn>
                                          </template>
                                          <span>{{ $t('espace_perso.detail_devis.envoie_mail_label') }}</span>
                                        </v-tooltip>
                                      </li>

                                      <li style="margin-left:3px;">
                                        <v-tooltip v-model="show" top>
                                          <template v-slot:activator="{ on }">
                                            <v-btn icon v-on="on">
                                              <v-icon color="red">&#xe872;</v-icon>
                                            </v-btn>
                                          </template>
                                          <span>{{ $t('espace_perso.detail_devis.supprimer_devis_label') }}</span>
                                        </v-tooltip>
                                      </li>
                                    </ul>
                                  </div>
                                </div>
                              </v-layout>
                            </v-container>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="wizard-card-footer clearfix">
                <div class="wizard-footer-left">
                  <button @click="detailsDevisDialog = false" type="button" class="wizard-btn">
                    <span class="fas fa-arrow-left"></span>
                    {{ $t('espace_perso.detail_devis.bouton_fermer_label') }}
                  </button>
                </div>
                <div class="wizard-footer-right">

                </div>
              </div>
            </v-card-text>
          </v-card>
        </v-dialog>

        <v-dialog v-model="VNeuf" persistent max-width="600px">
          <v-card elevation="24" class="border-radius">
            <v-card-text style="background:#FAFAFA">
              <div class="wizard-tab-content">
                <div role="tabpanel" id="valeurNeuf" aria-hidden="true" aria-labelledby="step-valeurNeuf"
                  class="wizard-tab-container">
                  <div>
                    <div class="loan-group loan-group-0">
                      <div class="fields">
                        <div class="field-title font-weight-bold">Valeur à neuf&nbsp;:</div>
                        <div class="row">
                          <div class="col-sm-12">
                            <div class="field-group field-default">
                              <label for="valeur_venale" class="field-label">
                                Valeur à neuf
                                <!---->
                              </label>
                              <div class="input-group value-loan">
                                <input type="number" v-model="valeur" placeholder="Valeur à neuf" id="valeur_venale"
                                  name="valeurNeuf" class="field-input">
                                <div class="input-group-append">
                                  <div class="input-group-text">FCFA</div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="wizard-card-footer clearfix">
                <div class="wizard-footer-left">
                  <button @click="CloseModalVNeuf()" type="button" class="wizard-btn">
                    <span class="fas fa-arrow-left"></span>
                    Retour
                  </button>
                </div>
                <div class="wizard-footer-right">
                  <button @click="CheckValeurNeufMobile()" type="button" class="wizard-btn">
                    Valider
                  </button>
                </div>
                <!---->
              </div>
            </v-card-text>
          </v-card>
        </v-dialog>

        <!-- ==========================Dialog for detail contrat============================================== -->
        <v-dialog v-model="DetailContratMobilDialog" persistent max-width="600px" v-if="isMobile()">
          <v-card elevation="24" class="border-radius">
            <v-card-text style="background:#FAFAFA">
              <div class="wizard-tab-content">
                <div role="tabpanel" id="detailContrat_mobile" aria-hidden="true"
                  aria-labelledby="step-detailContrat_mobile" class="wizard-tab-container">
                  <div>
                    <div class="loan-group loan-group-0">
                      <div class="fields">
                        <div class="field-title">{{ $t('espace_perso.detail_contrat.detail_devis_title') }}</div>
                        <div class="row">
                          <div class="col-sm-12">
                            <v-container class="border-radius scroll">
                              <v-layout wrap v-if="DetailContratMobilDialog == true">
                                <div class="col-sm-6 " style="margin-top:20px;" id="info">
                                  <div class="col border p-2 pl-5" style="background:#fff;border-radius: 10px;">
                                    <span class="font-weight-black">{{
                                      $t('espace_perso.detail_contrat.numero_devis_label') }}
                                      :
                                    </span>
                                    <span> {{ contratDetails.numero_police }}</span>
                                  </div>

                                  <div class="col border p-2 pl-5 mt-2" style="background:#fff;border-radius: 10px;">
                                    <span class="font-weight-black">{{ $t('espace_perso.detail_contrat.branche_label')
                                    }}
                                      :</span>
                                    <span> {{ contratDetails.brancheid.branche }}</span>
                                  </div>

                                  <div class="col border p-2 pl-5 mt-2" style="background:#fff;border-radius: 10px;">
                                    <span class="font-weight-black">{{
                                      $t('espace_perso.detail_contrat.date_effet_label')
                                    }}
                                      :
                                    </span>
                                    <span> {{ DateFormater(contratDetails.dateEffet) }}</span>
                                  </div>

                                  <div class="col border p-2 pl-5 mt-2" style="background:#fff;border-radius: 10px;">
                                    <span class="font-weight-black">{{
                                      $t('espace_perso.detail_contrat.date_echeance_label')
                                      }}
                                      : </span>
                                    <span> {{ DateFormater(contratDetails.dateEcheance) }}</span>
                                  </div>

                                  <div class="col border p-2 pl-5 mt-2" style="background:#fff;border-radius: 10px;">
                                    <span class="font-weight-black">{{ $t('espace_perso.detail_contrat.assureur_label')
                                    }}
                                      :
                                    </span>
                                    <img :src="contratDetails.partenaireid.logo" width="50" alt="partenaire-logo" class="ml-1">
                                  </div>

                                  <div class="col border p-2 pl-5 mt-2" style="background:#fff;border-radius: 10px;">
                                    <span class="font-weight-black">{{
                                      $t('espace_perso.detail_contrat.prime_nette_label')
                                    }}
                                      :
                                    </span>
                                    <span> {{ contratDetails.prime_nette.toLocaleString() }} FCFA</span>
                                  </div>

                                  <div class="col border p-2 pl-5 mt-2" style="background:#fff;border-radius: 10px;">
                                    <span class="font-weight-black">{{ $t('espace_perso.detail_contrat.prime_ttc_label')
                                      }}
                                      :
                                    </span>
                                    <span> {{ contratDetails.prime_ttc.toLocaleString() }} FCFA</span>
                                  </div>

                                  <div class="col border p-2 pl-5 mt-2" style="background:#fff;border-radius: 10px;">
                                    <ul class="list-boutons"
                                      style="display:flex; flex-direction:row;margin-left:-10px;">
                                      <li style="margin-left:3px;">
                                        <v-tooltip v-model="show" top>
                                          <template v-slot:activator="{ on }">

                                            <v-btn icon v-on="on" v-if="contratDetails.brancheid.branche == 'Voyage'"
                                              @click="downloadVoyageFileContrat(contratDetails.lien_contrat)">
                                              <v-icon color="grey">&#xe2c4;</v-icon>
                                            </v-btn>

                                            <v-btn icon v-on="on" v-else @click="DownloadAttestation(contratDetails)">
                                              <v-icon color="grey">&#xe2c4;</v-icon>
                                            </v-btn>
                                          </template>
                                          <span>{{ $t('espace_perso.detail_contrat.telecharger_label') }}</span>
                                        </v-tooltip>
                                      </li>

                                      <li style="margin-left:3px;">
                                        <v-tooltip v-model="show" top>
                                          <template v-slot:activator="{ on }">
                                            <v-btn icon v-on="on" @click="SendContratByEmail(contratDetails)">
                                              <v-icon color="grey">&#xe0be;</v-icon>
                                            </v-btn>
                                          </template>
                                          <span>{{ $t('espace_perso.detail_contrat.envoie_mail_label') }}</span>
                                        </v-tooltip>
                                      </li>

                                      <li style="margin-left:3px;">
                                        <v-tooltip v-model="show" top>
                                          <template v-slot:activator="{ on }">
                                            <v-btn icon v-on="on">
                                              <v-icon color="red">&#xe872;</v-icon>
                                            </v-btn>
                                          </template>
                                          <span>{{ $t('espace_perso.detail_contrat.supprimer_devis_label') }}</span>
                                        </v-tooltip>
                                      </li>

                                      <li style="margin-left:3px;" v-if="ShowBtnPaymentContratMobile()">
                                        <v-btn icon @click="modalPaymentContratMobile()">
                                          <img src="../../assets/img/devis/renew.png" width="30" alt="renew-icon">
                                        </v-btn>

                                      </li>
                                    </ul>
                                  </div>
                                </div>

                                <!-- =========================================================================================================  -->
                                <div class="col-sm-12" style="border-radius: 10px;"
                                  v-if="recurent_pay_history.length > 0">
                                  <span class="mt-4 ml-3 ">
                                    <span class="highlight"> {{
                                      $t('espace_perso.detail_contrat.histoire_paiement_label')
                                    }}
                                    </span>
                                    <span class="ml-2" style="color:red">
                                      {{ contratDetails.numero_police.toLocaleString()
                                      }}</span>
                                  </span>
                                  <v-data-table :headers="$t('espace_perso.detail_contrat.paymentHistoryHeader')"
                                    :items="recurent_pay_history" class="border-radius elevation-24 mt-2">
                                    <template slot="items" slot-scope="props">
                                      <td> {{ DateFormater(props.item.createdAt) }}</td>
                                      <td> {{ props.item.numero }}</td>
                                      <td> {{ props.item.contratid.prime_nette.toLocaleString() }} Fcfa </td>
                                      <td> {{ props.item.contratid.details[0].duree }}</td>
                                      <td> {{ props.item.contratid.details[0].capital.toLocaleString() }} Fcfa </td>
                                      <td> {{ props.item.contratid.details[0].Rente.toLocaleString() }} Fcfa </td>
                                    </template>
                                  </v-data-table>

                                </div>

                                <div class="col-sm-12 mt-2 pt-2" style="border-radius: 10px;"
                                  v-if="get_type(contratDetails.details[0]) != 'undefined'">
                                  <div v-if="get_type(contratDetails.details[0].questionnaire_medical) != 'undefined'">
                                    <v-flex xs12 v-for="(c, index) in contratDetails.details" :key="index">
                                      <v-expansion-panels>
                                        <v-expansion-panel>
                                          <v-expansion-panel-content>

                                            <v-expansion-panel-header slot="header" class="policeLato">
                                              Questionnaire médical pour {{ c.nom.toUpperCase() }} -
                                              {{ c.prenom.toUpperCase() }}
                                            </v-expansion-panel-header>

                                            <v-flex class="row policeLato ma-2 border pb-3"
                                              v-for="(q, index) in c.questionnaire_medical" :key="index">

                                              <v-flex xs12 style="color:red" pl-1 class="h5">
                                                Question numéro
                                                <span class="font-weight-bold">
                                                  {{ q.numero }}
                                                </span>
                                              </v-flex>

                                              <v-flex xs12 v-for="(ch, index) in q.champs" :key="index"
                                                class="pt-3   pl-3">
                                                <v-flex class="row">
                                                  <v-flex xs12 pl-2>
                                                    <span class="font-weight-bold">
                                                      {{ ch.question }}
                                                    </span>
                                                  </v-flex>

                                                  <v-flex xs12 mt-1 v-if="ch.type_reponse == 'string' && q.numero == 1">
                                                    <div class="ml-2">
                                                      {{ c.nom.toUpperCase() }} - {{ c.prenom.toUpperCase() }}
                                                    </div>
                                                  </v-flex>

                                                  <v-flex xs12 mt-1 v-if="ch.type_reponse == 'string' && q.numero != 1">
                                                    <textarea v-model="ch.reponse" class="border" cols="35" rows="4">
                                                </textarea>
                                                  </v-flex>

                                                  <v-flex xs12 mt-1 v-if="ch.type_reponse == 'radio'">
                                                    <v-radio-group full-width v-model="ch.reponse" class="ml-1">
                                                      <v-radio color="#ffa409" label="Oui" value="oui"></v-radio>
                                                      <v-radio color="#ffa409" label="Non" value="non"></v-radio>
                                                    </v-radio-group>
                                                  </v-flex>

                                                  <v-flex xs12 mt-1 v-if="ch.type_reponse == 'number'">
                                                    <input v-model="ch.reponse" type="number"
                                                      placeholder="Votre réponse ici" class="border pa-2 col-sm-12">
                                                  </v-flex>

                                                  <v-flex xs12 mt-1 v-if="ch.type_reponse == 'date'">
                                                    <input v-model="ch.reponse" type="date"
                                                      placeholder="Votre réponse ici" class="border pa-2 col-sm-12">
                                                  </v-flex>

                                                </v-flex>
                                              </v-flex>

                                            </v-flex>
                                          </v-expansion-panel-content>
                                        </v-expansion-panel>
                                      </v-expansion-panels>

                                    </v-flex>

                                    <v-btn small flat class="info" @click="SaveMedicalQuestion(contratDetails)">
                                      Enregistrer le questionnaire
                                      <span style="color:black;font-weight:bold">(1)</span>
                                    </v-btn>

                                    <v-btn small flat class="success" @click="submitMedicalQuestion(contratDetails)">
                                      Soumettre le questionnaire
                                      <span style="color:black;font-weight:bold">(2)</span>
                                    </v-btn>

                                    <div class="row">
                                      <div class="col-12">
                                        <small style="color:red;"> <i>1 : Sauvegarder l'état d'avancement du
                                            questionnaire</i></small>
                                      </div>
                                      <div class="col-12">
                                        <small style="color:red;"> <i>2 : Une fois le remplissage terminé, soumettre
                                          </i>
                                        </small>
                                      </div>
                                    </div>
                                  </div>
                                </div>

                                <!-- ===================================================================================================================== -->
                                <div class="col-sm-12 mt-2 pt-2" style="border-radius: 10px;"
                                  v-if="get_type(contratDetails.details[0]) != 'undefined'">
                                  <div
                                    v-if="get_type(contratDetails.details[0].contractor) != 'undefined' && get_type(contratDetails.details[0].contractor.Questionnaire) != 'undefined'">
                                    <v-flex xs12>
                                      <v-expansion-panels>
                                        <v-expansion-panel>
                                          <v-expansion-panel-content>

                                            <v-expansion-panel-header slot="header" class="policeLato">
                                              Questionnaire médical
                                            </v-expansion-panel-header>

                                            <v-flex class="row policeLato ma-2 border rounded pb-3"
                                              v-for="(q, index) in contratDetails.details[0].contractor.Questionnaire"
                                              :key="index">

                                              <v-flex class="font-weight-bold" xs12 style="color:red;font-size:14px;"
                                                pl-1>
                                                {{ q.block_title }}
                                              </v-flex>

                                              <v-flex xs12 pl-2>
                                                <span class="font-weight-bold"> {{ q.configurations.numero }} </span>
                                              </v-flex>

                                              <v-flex xs12 v-for="(ch, index) in q.configurations" :key="index"
                                                class="pt-3 pl-3">

                                                <v-flex class="row" v-for="(c, index) in ch.champs" :key="index">
                                                  <v-flex xs12 mt-1 v-if="c.type_reponse == 'text'">
                                                    <span for="" class="font-weight-bold" style="font-size:11px;">
                                                      {{ c.question }}
                                                    </span>
                                                    <input v-model="c.reponse" type="text"
                                                      placeholder="Votre réponse ici" class="border pa-2 col-sm-12">
                                                  </v-flex>

                                                  <v-flex xs12 mt-1 v-if="c.type_reponse == 'radio'">
                                                    {{ c.question }}
                                                    <v-radio-group full-width v-model="c.reponse" class="ml-1">
                                                      <v-radio color="#ffa409" label="Oui" value="oui"></v-radio>
                                                      <v-radio color="#ffa409" label="Non" value="non"></v-radio>
                                                    </v-radio-group>
                                                  </v-flex>

                                                  <v-flex xs12 mt-1 v-if="c.type_reponse == 'number'">
                                                    {{ c.question }}
                                                    <input v-model="c.reponse" type="number"
                                                      placeholder="Votre réponse ici" class="border pa-2 col-sm-12">
                                                  </v-flex>

                                                  <v-flex xs12 mt-1 v-if="c.type_reponse == 'date'">
                                                    {{ c.question }}
                                                    <input v-model="c.reponse" type="date"
                                                      placeholder="Votre réponse ici" class="border pa-2 col-sm-12">
                                                  </v-flex>

                                                </v-flex>
                                              </v-flex>

                                            </v-flex>
                                          </v-expansion-panel-content>
                                        </v-expansion-panel>
                                      </v-expansion-panels>

                                    </v-flex>
                                    <v-btn small flat class="info" style="width:80%"
                                      @click="SaveIndividuelAccidentQM(contratDetails)">
                                      Enregistrer QM
                                      <span style="color:black;font-weight:bold">(1)</span>
                                    </v-btn>

                                    <v-btn small flat class="success" style="width:80%"
                                      @click="GenerateIndividuelAccidentQM(contratDetails)">
                                      Soumettre le QM
                                      <span style="color:black;font-weight:bold">(2)</span>
                                    </v-btn>

                                    <div class="row">
                                      <div class="col-12">
                                        <small style="color:red;"> <i>1 : Sauvegarder l'état d'avancement du
                                            questionnaire</i></small>
                                      </div>
                                      <div class="col-12">
                                        <small style="color:red;"> <i>2 : Une fois le remplissage terminé, soumettre
                                          </i>
                                        </small>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <!-- ===================================================================================================================== -->
                              </v-layout>
                            </v-container>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="wizard-card-footer clearfix">
                <div class="wizard-footer-left">
                  <button @click="DetailContratMobilDialog = false; recurent_pay_history = []" type="button"
                    class="wizard-btn">
                    <span class="fas fa-arrow-left"></span>
                    {{ $t('espace_perso.detail_devis.bouton_fermer_label') }}
                  </button>
                </div>
                <div class="wizard-footer-right">

                </div>
              </div>
            </v-card-text>
          </v-card>
        </v-dialog>

        <!-- modal for contrat mobile -->
        <v-dialog v-model="ListeContratMobilDialog" persistent max-width="800px" v-if="isMobile()">
          <v-card elevation="24" class="border-radius">
            <v-card-text style="background:#FAFAFA">
              <div class="wizard-tab-content">
                <div role="tabpanel" id="mes_contrat_mobile" aria-hidden="true"
                  aria-labelledby="step-mes_contrat_mobile" class="wizard-tab-container">
                  <div>
                    <div class="loan-group loan-group-0">
                      <div class="fields">
                        <div class="field-title">{{ $t('espace_perso.contrat_list.contrat_title') }}</div>
                        <div class="row">
                          <div class="col-sm-6">
                            <div class="field-group field-default mb-4 mb-sm-0">
                              <label for="StepperRechercheMobile" class="field-label">{{
                                $t('espace_perso.contrat_list.recherche_label') }}</label>
                              <input v-model="search"
                                :placeholder="$t('espace_perso.contrat_list.recherche_placeholder')"
                                id="StepperRechercheMobile" name="Step8" class="field-input">
                            </div>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-sm-12">
                            <v-data-table :headers="$t('espace_perso.contrat_list.newHeader2')" :items="userContrat"
                              :search="search" class="small stripped border mt-2" style="z-index: 10000">
                              <template slot="items" slot-scope="props">
                                <td
                                  :style="{ backgroundColor: (ShowBtnPaymentContrat(props.item) ? '#eccccc' : 'transparent') }">
                                  <a href="javascript: void(0)" @click="getItemDetail2(props.item)">{{
                                    DateFormater(props.item.dateSouscription)
                                    }}</a>
                                </td>
                                <td
                                  :style="{ backgroundColor: (ShowBtnPaymentContrat(props.item) ? '#eccccc' : 'transparent') }">
                                  <a href="javascript: void(0)" @click="getItemDetail2(props.item)">{{ props.item.numero_police }}</a>
                                </td>
                              </template>

                              <template v-slot:no-results>
                                <v-alert :value="true" color="error" icon="warning">
                                  {{ $t('espace_perso.contrat_list.found_or_not_label[0]') }} "{{ search }}"
                                  {{ $t('espace_perso.contrat_list.found_or_not_label[1]') }}
                                </v-alert>
                              </template>
                            </v-data-table>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="wizard-card-footer clearfix">
                <div class="wizard-footer-left">
                  <button @click="ListeContratMobilDialog = false" type="button" class="wizard-btn">
                    <span class="fas fa-arrow-left"></span>
                    {{ $t('espace_perso.contrat_list.bouton_fermer_label') }}
                  </button>
                </div>
                <div class="wizard-footer-right">

                </div>
              </div>
            </v-card-text>
          </v-card>
        </v-dialog>
        <!-- modal for contenu contrat mobile -->

        <!------------------------------------ Modal dialog for documents mobile list ------------------------------------------------------>
        <v-dialog v-model="ModalMesDocumentsAdd" max-width="800" persistent>
          <v-card elevation="24" class="border-radius">
            <v-card-text style="background:#FAFAFA">
              <div class="wizard-card-footer clearfix">
                <div class="wizard-footer-left">
                </div>
                <div class="wizard-footer-right">
                  <button @click="AddDocForm = true, ModalMesDocumentsAdd = false" type="button" class="wizard-btn">
                    {{ $t('espace_perso.document_form.bouton_add_document') }}
                  </button>
                </div>
              </div>
              <div class="wizard-tab-content">
                <div role="tabpanel" id="mesDocument" aria-hidden="true" aria-labelledby="step-mesDocument"
                  class="wizard-tab-container">
                  <div>
                    <div class="loan-group loan-group-0">
                      <div class="fields">
                        <div class="field-title font-weight-bold">{{ $t('espace_perso.document_form.document_title') }}
                        </div>
                        <div class="row">
                          <div class="col-sm-12">
                            <div class="col-sm-12 mt-2">
                              <v-data-table :headers="$t('espace_perso.document_form.headerMesDocMobile')"
                                :items="userDocument" class="table table-reponsive small"
                                style="box-shadow: 9px 12px 18px rgb(0 0 0 / 10%);z-index:10000">
                                <template slot="items" slot-scope="props">
                                  <td class="text-xs-left">{{ props.item.type_document }}</td>
                                  <td class="text-xs-left">
                                    <a :href="props.item.lien_document" target="_blank">{{
                                      $t('espace_perso.document_form.download_file_label') }}</a>
                                  </td>
                                  <td class="text-xs-left">{{ DateFormater(props.item.date_upload) }}
                                  </td>
                                </template>
                              </v-data-table>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="wizard-card-footer clearfix">
                <div class="wizard-footer-left">
                  <button @click="ModalMesDocumentsAdd = false" type="button" class="wizard-btn">
                    <span class="fas fa-arrow-left"></span>
                    {{ $t('espace_perso.document_form.bouton_fermer_label') }}
                  </button>
                </div>
                <div class="wizard-footer-right">
                </div>
              </div>
            </v-card-text>
          </v-card>
        </v-dialog>
        <!-- -------------------fin Modal dialog for contenu document---------------------------------------------------------->

        <!-- ============= Formulaire d'ajout d'un nouveau document par le user version Mobile ======================== -->
        <v-dialog v-model="AddDocForm" max-width="600" persistent>
          <v-card elevation="24" class="border-radius">
            <v-card-text style="background:#FAFAFA">
              <div class="wizard-tab-content">
                <div role="tabpanel" id="ajoutDocument" aria-hidden="true" aria-labelledby="step-ajoutDocument"
                  class="wizard-tab-container">
                  <div>
                    <div class="loan-group loan-group-0">
                      <div class="fields">
                        <div class="field-title font-weight-bold">
                          {{ $t('espace_perso.document_form.add_document_label') }}
                        </div>
                        <div class="row">
                          <div class="col-sm-12">
                            <div class="field-group field-default mb-4 mb-sm-0">
                              <label for="Stepper24" class="field-label">{{
                                $t('espace_perso.document_form.type_piece_label') }}</label>
                              <select v-model="type_de_document" id="Stepper24" name="Step8" class="field-select">
                                <option v-for="itm in itemsTypeDocument" :key="itm" :value="itm.value">{{ itm.value }}
                                </option>
                              </select>
                            </div>
                          </div>
                        </div>
                        <div class="mt-3 row">
                          <span style="color: red">(*) {{ $t('espace_perso.document_form.alert_text_document') }}</span>
                        </div>
                        <div class="mt-3 row">
                          <p v-if="selectedFiles !== null" class="col-sm-11 border" style="border-radius:10px;">
                            {{ $t('espace_perso.document_form.nom_fichier') }} : {{ selectedFiles }}
                          </p>

                          <label for="file" class="toBordered">
                            <i class="fas fa-plus newFileIcon p-2"></i>
                          </label>
                          <input id="file" class="input-file" @change="ShowSelectedFile" type="file" ref="document">
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="wizard-card-footer clearfix">
                <div class="wizard-footer-left">
                  <button @click="AddDocForm = false" type="button" class="wizard-btn">
                    <span class="fas fa-arrow-left"></span>
                    {{ $t('espace_perso.document_form.bouton_fermer_label') }}
                  </button>
                </div>
                <div class="wizard-footer-right">
                  <button @click="AddDocument()" type="button" class="wizard-btn">
                    {{ $t('espace_perso.document_form.bouton_valider_label') }}
                  </button>
                </div>
              </div>
            </v-card-text>
          </v-card>
        </v-dialog>

        <!--======================= Modal modification de mot de passe======================= -->
        <v-dialog v-model="resetPasswordModal" max-width="500" persistent>
          <v-card elevation="24" class="border-radius">
            <v-card-text style="background:#FAFAFA">
              <div class="wizard-tab-content">
                <div role="tabpanel" id="passWordModif" aria-hidden="true" aria-labelledby="step-passWordModif"
                  class="wizard-tab-container">
                  <div>
                    <div class="loan-group loan-group-0">
                      <div class="fields">
                        <div class="field-title font-weight-bold">
                          {{ $t('espace_perso.modif_password_form.modif_password_title') }}</div>
                        <div class="row">
                          <div class="col-sm-12">
                            <div class="field-group field-default mb-4 mb-sm-0">
                              <label for="StepperMail" class="field-label">{{
                                $t('espace_perso.modif_password_form.email_label') }}</label>
                              <input v-model="password_new"
                                :placeholder="$t('espace_perso.modif_password_form.email_placeholder')" id="StepperMail"
                                name="Step8" class="field-input">
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="wizard-card-footer clearfix">
                <div class="wizard-footer-left">
                  <button @click="resetPasswordModal = false" type="button" class="wizard-btn">
                    <span class="fas fa-arrow-left"></span>
                    {{ $t('espace_perso.modif_password_form.bouton_fermer_label') }}
                  </button>
                </div>
                <div class="wizard-footer-right">
                  <button @click="userUpdatePassword()" type="button" class="wizard-btn">
                    {{ $t('espace_perso.modif_password_form.bouton_valider_label') }}
                  </button>
                </div>
              </div>
            </v-card-text>
          </v-card>
        </v-dialog>
        <!--======================= Fin modif mot de passe ============================== -->

        <!-- ======================== modal payment new contrat ======================================== -->
        <v-dialog v-model="dialogPaymentContrat" persistent max-width="800px">
          <v-card elevation="24" class="border-radius">
            <v-card-text style="background:#FAFAFA">
              <div class="wizard-tab-content">
                <div role="tabpanel" id="choixAvance_desktop" aria-hidden="true"
                  aria-labelledby="step-choixAvance_desktop" class="wizard-tab-container">
                  <div>
                    <div class="loan-group loan-group-0">
                      <div class="fields">
                        <div class="field-title font-weight-bold">Renouveler mon contrat</div>
                        <div class="row">
                          <div class="col-sm-4">
                            <div class="field-group field-default mb-4 mb-sm-0">
                              <label for="Stepper28" class="field-label">Durée</label>
                              <input @keypress="onlyNumber" v-model="duree" placeholder="Durée de la garantie"
                                id="Stepper28" name="Step8" class="field-input" @keyup="dateDiffForRenew"
                                @change="numberMonth()">
                            </div>
                          </div>
                          <div class="col-sm-4">
                            <div class="field-group field-default mb-4 mb-sm-0">
                              <label for="Stepper28" class="field-label">Date d'effet</label>
                              <input v-model="dateEffet" placeholder="Date d'échéance" id="Stepper28" name="Step8"
                                class="field-input" readonly>
                            </div>
                          </div>
                          <div class="col-sm-4">
                            <div class="field-group field-default mb-4 mb-sm-0">
                              <label for="Stepper28" class="field-label">Date d'échéance</label>
                              <input v-model="dateEcheance" placeholder="Date d'échéance" id="Stepper28" name="Step8"
                                class="field-input" readonly>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="fields" v-if="categorie !== '2_roues'">
                        <div class="field-title mb-0">
                          Liste des packs&nbsp;:
                        </div>
                        <p class="field-sub-title mb-5">Sélectionnez bien vos packs</p>
                        <div class="field-group row field-bank">
                          <div class="btn-choice col-sm-6">
                            <input type="radio" v-model="garanties" :value='packStandart.garanties'
                              id="pack_standard_mobile" name="Step09_mobile" class="field-input"
                              @change="showGaranties()">
                            <label for="pack_standard_mobile" class="field-label">
                              <h3 class="mt-3 text-center">Pack Standard</h3>
                            </label>
                          </div>
                          <div class="btn-choice col-sm-6">
                            <input type="radio" v-model="garanties" :value='packIntermediaire.garanties'
                              id="pack_inter_mobile" name="Step09_mobile" class="field-input" @change="showGaranties()">
                            <label for="pack_inter_mobile" class="field-label">
                              <h3 class="mt-3 text-center">Pack Intermédiaire</h3>
                            </label>
                          </div>
                          <div class="btn-choice col-sm-6">
                            <input type="radio" v-model="garanties" :value='packAvance.garanties'
                              id="pack_avance_mobile" name="Step09_mobile" class="field-input"
                              @change="showGaranties()">
                            <label for="pack_avance_mobile" class="field-label">
                              <h3 class="mt-3 text-center">Pack Avancé</h3>
                            </label>
                          </div>
                          <div class="btn-choice col-sm-6" v-if="annee <= 5">
                            <input type="radio" v-model="garanties" :value="packFull" id="pack_full_mobile"
                              name="Step09_mobile" class="field-input" @change="showGaranties()">
                            <label for="pack_full_mobile" class="field-label">
                              <h3 class="mt-3 text-center">Pack Full</h3>
                            </label>
                          </div>
                        </div>
                      </div>
                      <div class="fields">
                        <div class="row">
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="wizard-tab-content" v-show="text_packStandart" v-if="categorie !== '2_roues'">
                <div role="tabpanel" id="text_pack_Standart" aria-hidden="true"
                  aria-labelledby="step-text_pack_Standart" class="wizard-tab-container">
                  <div>
                    <div class="fields">
                      <div class="field-title mb-0">
                        Pack Standard
                      </div>
                      <p class="field-sub-title mb-5">Ce pack comprend les garanties suivantes :
                        <br> <span class="font-weight-bold">RESPONSABILITE CIVILE, PERSONNES TRANSPORTÉES, DÉFENSE ET
                          RECOURS</span> <br>
                        <span>Option Personnes Transportées : <span class="font-weight-bold"
                            style="color:#ffa409">Option
                            1</span></span>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div class="wizard-tab-content" v-show="text_packInter" v-if="categorie !== '2_roues'">
                <div role="tabpanel" id="text_pack_Inter" aria-hidden="true" aria-labelledby="step-text_pack_Inter"
                  class="wizard-tab-container">
                  <div>
                    <div class="fields">
                      <div class="field-title mb-0">
                        Pack Intermédiaire
                      </div>
                      <p class="field-sub-title mb-5">Ce pack comprend les garanties suivantes :
                        <br> <span class="font-weight-bold">RESPONSABILITE CIVILE, PERSONNES TRANSPORTÉES, DÉFENSE ET
                          RECOURS, BRIS DE GLACES</span> <br>
                        <span>Option Personnes Transportées : <span class="font-weight-bold"
                            style="color:#ffa409">Option
                            1</span></span>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div class="wizard-tab-content" v-show="text_packAvance" v-if="categorie !== '2_roues'">
                <div role="tabpanel" id="text_pack_Avance" aria-hidden="true" aria-labelledby="step-text_pack_Avance"
                  class="wizard-tab-container">
                  <div>
                    <div class="fields">
                      <div class="field-title mb-0">
                        Pack Avancé
                      </div>
                      <p class="field-sub-title mb-5">Ce pack comprend les garanties suivantes :
                        <br> <span class="font-weight-bold">RESPONSABILITE CIVILE, PERSONNES TRANSPORTÉES, DÉFENSE ET
                          RECOURS, BRIS DE GLACES, VOL, INCENDIE, AVANCE SUR RECOURS</span> <br>
                        <span>Option Personnes Transportées : <span class="font-weight-bold"
                            style="color:#ffa409">Option
                            1</span></span> <br>
                        <span>Choix Capital Avance sur Recours : <span class="font-weight-bold"
                            style="color:#ffa409">500
                            000 FCFA</span></span>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div class="wizard-tab-content" v-show="offre_full">
                <div role="tabpanel" id="pack_full_liste" aria-hidden="true" aria-labelledby="step-pack_full_liste"
                  class="wizard-tab-container">
                  <div>
                    <div class="fields">
                      <div class="field-title font-weight-bold mb-0">
                        Choix des packs Full&nbsp;:
                      </div>
                      <p class="field-sub-title mb-5">Sélectionnez bien vos packs</p>
                      <div class="field-group row field-bank">
                        <div class="btn-choice col-sm-6">
                          <input type="radio" v-model="garanties" :value="packFull.packFullToutRisques.garanties"
                            id="pack_full_choix_1" name="pack_full" class="field-input" @change="showGarantiesPackFull">
                          <label for="pack_full_choix_1" class="field-label">
                            <h3 class="mt-3 text-center">
                              <span class="tool"
                                data-tip="Ce pack : RESPONSABILITE CIVILE, PERSONNES TRANSPORTÉES, DÉFENSE ET RECOURS, VOL, INCENDIE, AVANCE SUR RECOURS, TIERCE COMPLÈTE"
                                tabindex="1">Pack Full - Tous risques</span>
                            </h3>
                          </label>
                        </div>
                        <div class="btn-choice col-sm-6">
                          <input type="radio" v-model="garanties" :value="packFull.packFullCollision.garanties"
                            id="pack_full_choix_2" name="pack_full" class="field-input" @change="showGarantiesPackFull">
                          <label for="pack_full_choix_2" class="field-label">
                            <h3 class="mt-3 text-center">
                              <span class="tool"
                                data-tip="Ce pack : RESPONSABILITE CIVILE, PERSONNES TRANSPORTÉES, DÉFENSE ET RECOURS, VOL, INCENDIE, AVANCE SUR RECOURS, TIERCE COLLISION"
                                tabindex="1">Pack Full - Collision</span>
                            </h3>
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="wizard-tab-content" v-show="text_packFull_1">
                <div role="tabpanel" id="text_pack_full_1" aria-hidden="true" aria-labelledby="step-text_pack_full_1"
                  class="wizard-tab-container">
                  <div>
                    <div class="fields">
                      <div class="field-title mb-0">
                        Pack Full - Tous risques
                      </div>
                      <p class="field-sub-title mb-5">Ce pack comprend les garanties suivantes :
                        <br> <span class="font-weight-bold">RESPONSABILITE CIVILE, PERSONNES TRANSPORTÉES, DÉFENSE ET
                          RECOURS, VOL, INCENDIE, AVANCE SUR RECOURS, TIERCE COMPLÈTE</span> <br>
                        <span>Option Personnes Transportées : <span class="font-weight-bold"
                            style="color:#ffa409">Option
                            1</span></span> <br>
                        <span>Choix Capital Avance sur Recours : <span class="font-weight-bold"
                            style="color:#ffa409">500
                            000 FCFA</span></span>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div class="wizard-tab-content" v-show="text_packFull_2">
                <div role="tabpanel" id="text_pack_full_2" aria-hidden="true" aria-labelledby="step-text_pack_full_2"
                  class="wizard-tab-container">
                  <div>
                    <div class="fields">
                      <div class="field-title mb-0">
                        Pack Full - Collision
                      </div>
                      <p class="field-sub-title mb-5">Ce pack comprend les garanties suivantes :
                        <br> <span class="font-weight-bold">RESPONSABILITE CIVILE, PERSONNES TRANSPORTÉES, DÉFENSE ET
                          RECOURS, VOL, INCENDIE, AVANCE SUR RECOURS, TIERCE COLLISION</span> <br>
                        <span>Option Personnes Transportées : <span class="font-weight-bold"
                            style="color:#ffa409">Option
                            1</span></span> <br>
                        <span>Choix Capital Avance sur Recours : <span class="font-weight-bold"
                            style="color:#ffa409">500
                            000 FCFA</span></span>
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              <div class="wizard-card-footer clearfix mb-5">
                <div class="wizard-footer-left">
                  <button @click="dialogPaymentContrat = false" type="button" class="wizard-btn">
                    <span class="fas fa-arrow-left"></span>
                    Retour
                  </button>
                </div>
                <div class="wizard-footer-right">
                  <button @click="reNewContratMobile()" type="button" class="wizard-btn">
                    Renouveler
                  </button>
                </div>
              </div>
            </v-card-text>
          </v-card>
        </v-dialog>

        <!--Modal dialog for Mes point-->
        <v-fab-transition>
          <v-dialog v-model="dialogMesPointsMobil" persistent>
            <v-card class="border-radius">
              <v-toolbar card dark style="background: #ffa409; font-size:10px!important">
                <v-toolbar-title class="policeLato"><i class="material-icons" aria-hidden="true" data-nosnippet>&#xe089;</i>{{
                  $t('espace_perso.point_assuraf.vos_points[0]') }} <span class="font-weight-bold">{{
                    $t('espace_perso.point_assuraf.vos_points[1]') }}</span></v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn icon dark flat @click="dialogMesPointsMobil = false" class="float-lg-right">
                  <v-icon>&#xe5cd;</v-icon>
                </v-btn>
              </v-toolbar>

              <v-card-text>
                <v-container class="grey lighten-3 border-radius">
                  <div class="row text-lg-center pl-5">
                    <v-flex xs7 class="text-lg-center ml-5">
                      <span class="policeLato font-weight-bold ml-5">
                        <p class="h2 font-weight-bold" v-if="UserPoints > 1"> {{ UserPoints }} points</p>
                        <p class="h2 font-weight-bold" v-if="UserPoints == 1"> {{ UserPoints }} point</p>
                      </span>
                    </v-flex>
                  </div>
                </v-container>
              </v-card-text>
            </v-card>
          </v-dialog>
        </v-fab-transition>
        <!--Fin Modal dialog for Mes points Mobil-->
      </v-layout>
    </div>

    <!-- =================Modal spinner genreartion du fichier PDF pour telechargement============== -->
    <div v-if="dialogLoading" class="loading-state">
        <div class="loading"></div>
        <span class="ml-3 loading-text">{{ $t('paiement.sante.popup_file_generator.title') }}</span>
    </div>

    <!-- <div class="text-xs-center">
      <v-dialog v-model="dialogLoading" hide-overlay persistent width="300">
        <v-card color="orange" dark>
          <v-card-text>
            {{ $t('paiement.sante.popup_file_generator.title') }}
            <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
          </v-card-text>
        </v-card>
      </v-dialog>
    </div> -->

    <v-dialog v-model="dialogQm_validation" persistent width="600">
      <v-card class="">
        <v-toolbar card dark style="background: red; font-size:10px!important">
          <v-toolbar-title class="policeLato">
            {{ $t('espace_perso.medical_question.title') }}
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon dark flat @click="dialogQm_validation = false" class="float-lg-right">
            <v-icon>&#xe5cd;</v-icon>
          </v-btn>
        </v-toolbar>

        <v-card-text>
          {{ $t('espace_perso.medical_question.content[0]') }}
          <v-container class="grey lighten-3 border-radius">
            <div class="row">
              <v-flex xs12 class=" ">
                <ul v-for="(v, i) in errors_tab" :key="i">
                  <li> {{ $t('espace_perso.medical_question.content[1]') }} : <span style="color:red"> {{ v.person }}
                    </span>
                  </li>
                  <li> {{ $t('espace_perso.medical_question.content[2]') }} : <span style="color:red"> {{ v.numero }}
                    </span>
                  </li>
                  <li> {{ $t('espace_perso.medical_question.content[3]') }} : <span style="color:red"> {{ v.question }}
                    </span>
                  </li>
                </ul>
              </v-flex>
            </div>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!--======================= Modal modification de numéro de téléphone ======================= -->
    <v-dialog v-model="accountValidationDialog" max-width="500" persistent>
      <v-card elevation="24" class="border-radius">
        <v-card-text style="background:#FAFAFA">
          <div class="wizard-tab-content">
            <div role="tabpanel" id="passWordModif" aria-hidden="true" aria-labelledby="step-passWordModif"
              class="wizard-tab-container">
              <div>
                <div class="loan-group loan-group-0">
                  <div class="fields">
                    <div class="field-title font-weight-bold">
                      {{ $t('espace_perso.modif_numero_form.modif_numero_title') }}
                    </div>
                    <div class="row">
                      <div class="col-sm-12">
                        <div class="field-group field-default mb-4 mb-sm-0">
                          <label for="StepperNumero" class="field-label">{{
                            $t('espace_perso.modif_numero_form.numero_label') }}</label>
                          <input v-model="newphoneNumber"
                            :placeholder="$t('espace_perso.modif_numero_form.numero_placeholder')" id="StepperNumero"
                            name="Step8" class="field-input">
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="wizard-card-footer clearfix">
            <div class="wizard-footer-left">
              <button @click="accountValidationDialog = false" type="button" class="wizard-btn">
                <span class="fas fa-arrow-left"></span>
                {{ $t('espace_perso.modif_numero_form.bouton_fermer_label') }}
              </button>
            </div>
            <div class="wizard-footer-right">
              <button @click="resend_new_code()" type="button" class="wizard-btn">
                {{ $t('espace_perso.modif_numero_form.bouton_valider_label') }}
              </button>
            </div>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
    <!--======================= Fin modification de numéro de téléphone ============================== -->

    <!--======================= Modal Code de validation ======================= -->
    <v-dialog v-model="codesender" max-width="500" persistent>
      <v-card elevation="24" class="border-radius">
        <v-card-text style="background:#FAFAFA">
          <div class="wizard-tab-content">
            <div role="tabpanel" id="passWordModif" aria-hidden="true" aria-labelledby="step-passWordModif"
              class="wizard-tab-container">
              <div>
                <div class="loan-group loan-group-0">
                  <div class="fields">
                    <div class="field-title font-weight-bold">
                      {{ $t('espace_perso.code_validation_form.modif_code_title') }}
                    </div>
                    <div class="row">
                      <div class="col-sm-12">
                        <div class="field-group field-default mb-4 mb-sm-0">
                          <label for="StepperCode" class="field-label">{{
                            $t('espace_perso.code_validation_form.code_label')
                            }}</label>
                          <input v-model="account_validation_code"
                            :placeholder="$t('espace_perso.code_validation_form.code_placeholder')" id="StepperCode"
                            name="Step8" class="field-input">
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="wizard-card-footer clearfix">
            <div class="wizard-footer-left">
              <button @click="codesender = false" type="button" class="wizard-btn">
                <span class="fas fa-arrow-left"></span>
                {{ $t('espace_perso.code_validation_form.bouton_fermer_label') }}
              </button>
            </div>
            <div class="wizard-footer-right">
              <button @click="user_validation()" type="button" class="wizard-btn">
                {{ $t('espace_perso.code_validation_form.bouton_valider_label') }}
              </button>
            </div>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>

        <!--    ========================== Modal for Demande de Remise Desktop============================================ -->
        <v-dialog width="900" v-model="getDiscountRequestModal" persistent v-if="isDesktop()">
          <v-card elevation="24" class="border-radius">
            <v-card-text style="background:#FAFAFA">
              <div class="wizard-tab-content">
                <div role="tabpanel" id="ListeDemandeRemiseDesktop" aria-hidden="true"
                  aria-labelledby="step-ListeDemandeRemiseDesktop" class="wizard-tab-container">
                  <div>
                    <div class="loan-group loan-group-0">
                      <div class="fields">
                        <div class="field-title font-weight-bold">{{
                                $t('espace_perso.demande_remise.demandes_remise_label') }}
                        </div>
                        <div class="row">
                          <div class="col-sm-6">
                            <!-- A ne pas supprimer-->
                          </div>
                          <div class="col-sm-6">
                            <div class="field-group field-default mb-4 mb-sm-0">
                              <label for="searchDemandeRemiseDesktop" class="field-label">{{
                                $t('espace_perso.contrat_list.recherche_label') }}</label>
                              <input v-model="search"
                                :placeholder="$t('espace_perso.contrat_list.recherche_placeholder')"
                                id="searchDemandeRemiseDesktop" name="Step8" class="field-input">
                            </div>
                          </div>
                        </div>
                        <div class="row" style="z-index:10000">
                          <v-data-table class="mt-3 fb-table-elem ml-3"
                            :headers="$t('devis.devis_auto.headerDiscount')" :items="discountData"
                            :search="search" expand
                            style="box-shadow: 9px 12px 18px rgb(0 0 0 / 10%);width: 100%">
                            <template slot="items" slot-scope="props">
                              
                              <tr>
                                 <td class="text-xs-left">
                                  <div class="datatable-cell-wrapper">{{ DateFormater(props.item.createdAt) }} </div>
                                </td>
                                <td class="text-xs-left">
                                
                                  <div class="datatable-cell-wrapper">{{ props.item.engagement }} {{
                                                        $t('devis.devis_auto.mois') }}
                                  </div>
                                </td>
                                <td class="text-xs-left">
                                  <div class="datatable-cell-wrapper">{{ props.item.nbreVehicle }}</div>
                                </td>

                                 <td class="text-xs-left">
                                  <div class="datatable-cell-wrapper">{{ props.item.taux }} %</div>
                                </td>

                                <td class="text-xs-left" v-if="props.item.tauxAjuste != null">
                                  <div class="datatable-cell-wrapper">
                                      {{ props.item.tauxAjuste }}
                                  </div>
                                </td>
                                 <td class="text-xs-left" v-else>
                                  <div class="datatable-cell-wrapper">
                                      .
                                  </div>
                                </td>

                                <td class="text-xs-left">
                                  <div class="datatable-cell-wrapper">
                                    <span v-if="props.item.statut == 'En attente'" class="font-weight-bold" style="color:#ffa409">
                                       <!-- {{ props.item.statut }} -->
                                       {{$t('espace_perso.demande_remise.attente_label') }}
                                    </span>

                                    <span v-if="props.item.statut == 'Refusée' || props.item.statut == 'Refus�e'" class="font-weight-bold" style="color:red">
                                       <!-- {{ props.item.statut }} -->
                                       {{$t('espace_perso.demande_remise.refuse_label') }}
                                    </span>

                                    <span v-if="props.item.statut == 'Acceptée' || props.item.statut == 'Accept�e'" class="font-weight-bold" style="color:green">
                                       <!-- {{ props.item.statut }} -->
                                       {{$t('espace_perso.demande_remise.accepte_label') }}
                                    </span>

                                     <span v-if="props.item.statut == 'Ajustée' || props.item.statut == 'Ajust�e'" class="font-weight-bold" style="color:grey">
                                       <!-- {{ props.item.statut }} -->
                                       {{$t('espace_perso.demande_remise.ajuste_label') }}
                                    </span>
                                  
                                  </div>
                                </td>
                                <td class="text-xs-left justify-content-start row">
                                  <div class="datatable-cell-wrapper">
                                    <span class="tool_button" data-tip="Voir détails demande !" tabindex="1">
                                      <v-btn icon @click="DetailsDiscountRequestVue(props.item)">
                                        <v-icon color="#ffa409">&#xe8f4;</v-icon>
                                      </v-btn>
                                    </span>
                                  </div>
                                </td>
                              </tr>
                            </template>
                          </v-data-table>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="wizard-card-footer clearfix">
                <div class="wizard-footer-left">
                  <button @click="getDiscountRequestModal = false" type="button" class="wizard-btn">
                    <span class="fas fa-arrow-left"></span>
                    {{ $t('espace_perso.contrat_list.bouton_fermer_label') }}
                  </button>
                </div>
                <div class="wizard-footer-right">
                </div>
              </div>
            </v-card-text>
          </v-card>
        </v-dialog>

         <!--    ========================== Modal for Demande de Remise Mobile============================================ -->
        <v-dialog v-model="getDiscountRequestModal" persistent v-if="isMobile()">
          <v-card elevation="24" class="border-radius">
            <v-card-text style="background:#FAFAFA">
              <div class="wizard-tab-content">
                <div role="tabpanel" id="ListeDemandeRemiseDesktop" aria-hidden="true"
                  aria-labelledby="step-ListeDemandeRemiseDesktop" class="wizard-tab-container">
                  <div>
                    <div class="loan-group loan-group-0">
                      <div class="fields">
                        <div class="field-title font-weight-bold">{{
                                $t('espace_perso.demande_remise.demandes_remise_label') }}
                        </div>
                        <div class="row">
                          <div class="col-sm-6">
                            <!-- A ne pas supprimer-->
                          </div>
                          <div class="col-sm-6">
                            <div class="field-group field-default mb-4 mb-sm-0">
                              <label for="searchDemandeRemiseDesktop" class="field-label">{{
                                $t('espace_perso.contrat_list.recherche_label') }}</label>
                              <input v-model="searchDiscountRequestDesktop"
                                :placeholder="$t('espace_perso.contrat_list.recherche_placeholder')"
                                id="searchDemandeRemiseDesktop" name="Step8" class="field-input">
                            </div>
                          </div>
                        </div>
                        <div class="row" style="z-index:10000">
                          <v-data-table class="mt-3 fb-table-elem ml-3"
                            :headers="$t('devis.devis_auto.headerDiscountMobile')" :items="discountData"
                            :search="searchDiscountRequestDesktop" expand
                            style="box-shadow: 9px 12px 18px rgb(0 0 0 / 10%);width: 100%">
                            <template slot="items" slot-scope="props">
                              <tr>
                                 <td  @click="DetailsDiscountRequestVue(props.item)"class="text-xs-left">
                                  <div class="datatable-cell-wrapper">{{ DateFormater(props.item.createdAt) }} </div>
                                </td>
                                <td @click="DetailsDiscountRequestVue(props.item)" class="text-xs-left">
                                  <div class="datatable-cell-wrapper">{{ props.item.engagement }} {{
                                                        $t('devis.devis_auto.mois') }}</div>
                                </td>

                                <td @click="DetailsDiscountRequestVue(props.item)" class="text-xs-left">
                                  <div class="datatable-cell-wrapper">
                                    <span v-if="props.item.statut == 'En attente'" class="font-weight-bold" style="color:#ffa409">
                                       {{$t('espace_perso.demande_remise.attente_label') }}
                                    </span>

                                    <span v-if="props.item.statut == 'Refusée' || props.item.statut == 'Refus�e'" class="font-weight-bold" style="color:red">
                                       {{$t('espace_perso.demande_remise.refuse_label') }}
                                    </span>

                                    <span v-if="props.item.statut == 'Acceptée' || props.item.statut == 'Accept�e'" class="font-weight-bold" style="color:green">
                                       {{$t('espace_perso.demande_remise.accepte_label') }}
                                    </span>

                                     <span v-if="props.item.statut == 'Ajustée' || props.item.statut == 'Ajust�e'" class="font-weight-bold" style="color:grey">
                                       {{$t('espace_perso.demande_remise.ajuste_label') }}
                                    </span>
                                  
                                  </div>
                                </td>
                              </tr>
                            </template>
                          </v-data-table>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="wizard-card-footer clearfix">
                <div class="wizard-footer-left">
                  <button @click="getDiscountRequestModal = false" type="button" class="wizard-btn">
                    <span class="fas fa-arrow-left"></span>
                    {{ $t('espace_perso.contrat_list.bouton_fermer_label') }}
                  </button>
                </div>
                <div class="wizard-footer-right">
                </div>
              </div>
            </v-card-text>
          </v-card>
        </v-dialog>

    <!--    ==========================Détails Demande de Remise ============================================ -->
        <v-dialog width="900" v-model="showDetailDiscountRequest" persistent>
          <v-card elevation="24" class="border-radius">
            <v-card-text style="background:#FAFAFA">
              <div class="wizard-tab-content">
                <div role="tabpanel" id="ListeDemandeRemiseDesktop" aria-hidden="true"
                  aria-labelledby="step-ListeDemandeRemiseDesktop" class="wizard-tab-container">
                  <div>
                    <div class="loan-group loan-group-0">
                      <div class="fields">
                        <div class="field-title font-weight-bold">{{ $t('espace_perso.demande_remise.details_demande_remise') }}
                        </div>
                        <div class="ml-2 mr-2 row" style="z-index:10000">
                         <ul style="width:100%" v-if="DiscountRequestDetails!= null">
                            <li>{{ $t('espace_perso.demande_remise.Date_demande_label') }} :<span class="font-weight-bold float-right">{{ DateFormater(DiscountRequestDetails.createdAt)}}</span></li>
                            <li>{{ $t('espace_perso.demande_remise.engagement_label') }} :<span class="font-weight-bold float-right">{{DiscountRequestDetails.engagement}} {{
                                                        $t('devis.devis_auto.mois') }}</span></li>
                            <li>{{ $t('espace_perso.demande_remise.taux_souhaite') }} :<span class="font-weight-bold float-right">{{DiscountRequestDetails.taux}} %</span></li>
                            <li v-if="DiscountRequestDetails.tauxAjuste != null">{{ $t('espace_perso.demande_remise.taux_accorde') }} :<span class="font-weight-bold float-right">{{DiscountRequestDetails.tauxAjuste}} %</span></li>
                            <li>{{ $t('espace_perso.demande_remise.ttc_avant_remise') }} :<span class="font-weight-bold float-right">{{DiscountRequestDetails.ttcBeforeDiscount.toLocaleString()}} FCFA</span></li>
                            <li v-if="DiscountRequestDetails.statut == 'Ajustée' || DiscountRequestDetails.statut == 'Ajust�e'">{{ $t('espace_perso.demande_remise.ttc_apres_remise') }} :<span class="font-weight-bold float-right">{{DiscountRequestDetails.ttcAfterDiscount.toLocaleString()}} FCFA</span></li>
                            <li>{{ $t('espace_perso.demande_remise.numero_devis_label') }} :<span class="font-weight-bold float-right">{{DiscountRequestDetails.numero_devis}}</span></li>
                            <li>{{ $t('espace_perso.demande_remise.date_effet_label') }} :<span class="font-weight-bold float-right">{{DateFormater(DiscountRequestDetails.devisid.dateEffet)}}</span></li>
                            <li>{{ $t('espace_perso.demande_remise.nbre_vehicule_label') }} :<span class="font-weight-bold float-right">{{DiscountRequestDetails.nbreVehicle}}</span></li>
                            <li>{{ $t('espace_perso.demande_remise.status_label') }} :
                              <span v-if="DiscountRequestDetails.statut == 'En attente'" class="font-weight-bold float-right" style="color:#ffa409">{{$t('espace_perso.demande_remise.attente_label') }}</span>
                              <span v-if="DiscountRequestDetails.statut == 'Acceptée' || DiscountRequestDetails.statut == 'Accept�e'" class="font-weight-bold float-right" style="color:green">{{$t('espace_perso.demande_remise.accepte_label') }}</span>
                              <span v-if="DiscountRequestDetails.statut == 'Refusée' || DiscountRequestDetails.statut == 'Refus�e'" class="font-weight-bold float-right" style="color:red">{{$t('espace_perso.demande_remise.refuse_label') }}</span>
                              <span v-if="DiscountRequestDetails.statut == 'Ajustée' || DiscountRequestDetails.statut == 'Ajust�e'" class="font-weight-bold float-right" style="color:grey">{{$t('espace_perso.demande_remise.ajuste_label') }}
                            </span></li>
                            <li>{{ $t('espace_perso.demande_remise.motif_demande') }} :<span class="font-weight-bold float-right">{{DiscountRequestDetails.motifDemand}}</span></li>
                         </ul>
                         
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="wizard-card-footer clearfix">
                <div class="wizard-footer-left">
                  <button @click="showDetailDiscountRequest = false; getDiscountRequestModal = true" type="button" class="wizard-btn">
                    <span class="fas fa-arrow-left"></span>
                    {{ $t('espace_perso.contrat_list.bouton_fermer_label') }}
                  </button>
                </div>
                <div class="wizard-footer-right">
                </div>
              </div>
            </v-card-text>
          </v-card>
        </v-dialog>

    <AddParrainageComponent :add_dialog="add_dialog" :user_parrainages="user_parrainages" :coupon_parrainage="coupon_parrainage" :lien_parrain="lien_parrain" @parrainage-add="callback" />



    <!--======================= Fin Code de validation ============================== -->
  </div>
</template>

<script>
import lib from '../../libs/index'

import Api from "./../../services/Api";
import store from "./../../store/store";
import { mapGetters } from "vuex";
import dayjs from "dayjs";
import PushInDataLayer from "../../services/TagManager";
import AddParrainageComponent from './parrainage.component.vue'
export default {
  name: "dashboard",
  components: {
    AddParrainageComponent
  },
  data() {
    return {
      // Verrou de double-clic sur le telechargement de facture (CFW-16).
      factureEnCours: false,
      searchDiscountRequestDesktop: "",
      DiscountRequestDetails : null,
      showDetailDiscountRequest : false,
      getDiscountRequestModal : false,
      discountData : null,
      lien_parrain: 'le n\'est pas lien pas disponible ',
      coupon_parrainage: null,
      add_dialog: false,
      phone_number: '',
      user_parrainages: [],
      nb_parrainer: 0,
      modal_liste_parrainages: false,
      accountValidationDialog: false,
      account_validation_code: null,
      acceptedCondition: null,
      resend_code_ctlr: false,
      second_counter: 30,
      validation_attemp: 0,
      indication: false,
      timerInterval: null,
      newphoneNumber: null,
      codesender: false,
      primary_partner: null,
      affiliated_partner: null,
      current_partner: null,
      nombre: 0,
      nbreContratExpir: [],
      itemsType: ["passeport", "Carte CI"],
      itemsStatutMarital: ["marié", "veuf", "divorcé", "célibataire"],
      itemsSexe: ["homme", "femme"],
      alert: false,
      money: {
        thousands: " ",
        precision: false,
        masked: false,
      },
      capital_AvRec: null,
      optionPersoTrans: null,
      valeur: null,
      VNeuf: false,
      annee: null,
      offre_full: false,
      PackFull_Choix: null,
      text_packStandart: false,
      text_packInter: false,
      text_packAvance: false,
      text_packFull_1: false,
      text_packFull_2: false,
      categorie: null,
      ListAuto: [],
      duree: null,
      dateEffet: new Date().toISOString().substr(0, 10),
      dateEcheance: null,
      garanties: [],
      packStandart: {
        garanties: [
          "RESPONSABILITE CIVILE",
          "PERSONNES TRANSPORTEES",
          "DEFENSE ET RECOURS",
        ],
      },
      packIntermediaire: {
        garanties: [
          "RESPONSABILITE CIVILE",
          "PERSONNES TRANSPORTEES",
          "DEFENSE ET RECOURS",
          "BRIS DE GLACES",
        ],
      },
      packAvance: {
        garanties: [
          "RESPONSABILITE CIVILE",
          "PERSONNES TRANSPORTEES",
          "DEFENSE ET RECOURS",
          "BRIS DE GLACES",
          "VOL",
          "INCENDIE",
          "AVANCE SUR RECOURS",
        ],
      },
      packFull: {
        packFullToutRisques: {
          garanties: [
            "RESPONSABILITE CIVILE",
            "PERSONNES TRANSPORTEES",
            "DEFENSE ET RECOURS",
            "BRIS DE GLACES",
            "VOL",
            "INCENDIE",
            "AVANCE SUR RECOURS",
            "TIERCE COMPLETE",
          ],
        },
        packFullCollision: {
          garanties: [
            "RESPONSABILITE CIVILE",
            "PERSONNES TRANSPORTEES",
            "DEFENSE ET RECOURS",
            "BRIS DE GLACES",
            "VOL",
            "INCENDIE",
            "AVANCE SUR RECOURS",
            "TIERCE COLLISION",
          ],
        },
      },
      listeAssureurs: [],
      assureurs: [],
      dialogPaymentContrat: false,
      paymentContrat: null,
      dialogQm_validation: false,
      menu_qm: false,
      recurent_pay_history: [],
      description: "Assuraf – Espace Personnel",
      show: false,
      drawer: true,
      date: null, //new Date().toISOString().substr(0, 10),
      drawer2: false,
      loggedUser: null,
      userInfos: {},
      dialogEditProfil: false,
      type_de_document: null,
      resetPasswordModal: false,
      dialogeStat: false,
      dialogLoading: false,
      AddDocForm: false,
      dialogeStatus: false,
      ModalMesDocuments: false,
      ModalMesDocumentsAdd: false,
      DetailsDevis: false, // model pour le popup details devis
      DevisForDetails: {},
      ContratForDetails: {},
      dialogMesPoints: false,
      dialogMesPointsMobil: false,
      ModalListeDevis: false,
      UserPoints: null,
      ModalListeContrat: false,
      DetailsContrat: false,
      ModalDashboard: false,
      selectedFiles: null,
      detailsDevisDialog: false,
      ListeContratMobilDialog: false,
      DetailContratMobilDialog: false,
      assistanceDialog: false,
      userContrat: [],
      userDocument: [],
      userDevis: [],
      nbDevis: null,
      DateFormated: null,
      dialogListDevis: null,
      ServerRep: null,
      ToastTabSucess: {
        theme: "toasted-primary",
        position: "top-center",
        duration: 5000,
        fitToScreen: true,
        type: "success",
        className: "custom-success-class",
      }, // Customized options for success toast
      ToastTabError: {
        theme: "toasted-primary",
        position: "top-center",
        duration: 5000,
        fitToScreen: true,
        type: "error",
      }, // Customized options for error toast
      menu: false,
      nom: "",
      password_new: null,
      password_confirmation: null,
      prenom: "",
      file: null,
      itemsTypeDocument: [
        {
          text: "Passeport",
          value: "passeport",
        },
        {
          text: "Carte CI",
          value: "carte identité",
        },
        {
          text: "Carte grise",
          value: "carte grise",
        },
        {
          text: "PV Constat",
          value: "PV Constat",
        },
        {
          text: "Permis de conduire",
          value: "permis de conduire",
        },
      ],

      itema: ["Le plus tôt possible", "Dans la matinée", "Dans la journée"],
      rappel: ["Whatsapp", "Appel", "Email"],

      valid: false,
      name: "",
      remarques: null,
      objetRappel: null,
      canal: null,
      horaire: null,
      tel: "",
      email: "",
      select: null,
      checkbox: true,
      dialog: false,
      modal: false,
      search: "",
      searchContratDesktop: "",
      devisDetails: {},
      contratDetails: {},
      right: null,
      errors_tab: null,
      userSinistre: [],
    };
  },
  metaInfo() {
    return {
      meta: [
        {
          charset: "utf-8",
        },
        {
          name: "keywords",
          content: "espace personnel",
        },
        {
          hid: "description",
          name: "description",
          content: this.description,
        },
      ],
    };
  },
  watch: {
    ServerRep() {
      if (this.ServerRep == 200) {
        this.dialogEditProfil = false;
        this.dialog = false;
        this.$toasted.show(
          "Vous serez déconnecté et un lien vous sera envoyé par mail pour mettre a jour votre mots de passe !",
          this.ToastTabSucess
        );
        setTimeout(() => ((this.dialog = false), this.logout()), 3000);
      } else {
        this.$toasted.show(
          "Le lien de modification n'a pas pu être envoyé!",
          this.ToastTabError
        );
      }
    },
    drawer() {
      if (this.drawer == false) {
        this.drawer2 = true;
      }
    },
  },
  methods: {
    checkOrganisationAccess(){
      console.log('::::::::: userInfos', this.userInfos)
      // if(this.userInfos.sexe != 'entreprise'){
      //   return
      // }
    },
    checkEspaceAccess(){
      console.log('access espace perso')
    },
    DetailsDiscountRequestVue(item) {
      console.log(':::: details demande de remise', item)
      this.DiscountRequestDetails = item
      this.showDetailDiscountRequest = true
      this.getDiscountRequestModal = false
      //this.GetReccuentPayByContrat(item);
      // this.ModalListeContrat = false;
      // this.ContratForDetails = item;
      // this.DetailsContrat = true;
    },
    view_MyDiscountRequest() {
      if(this.discountData.length > 0) {
        this.getDiscountRequestModal = true;
      }else {
        this.$toasted.show("Vous n'avez pas encore de demande de remise!", this.ToastTabError)
      }
    },
    async getDiscountRequest(){
      console.log(':::::: id user', store.state.user._id)
        Api().post("demande_remise/get_by_userid", { _id: store.state.user._id }).then((resp) => {
          console.log(':::::: liste demande de remise', resp.data)
          //if (resp.data) {
            this.discountData = resp.data
          // } else {
          //   this.discountData = []
          // }
        })
    },
    async copyToClipboard() {
      try {
        await navigator.clipboard.writeText(this.userInfos.code_parrain);
        //alert(" Code copié ✅ ")
        this.$toasted.show("Code parrainage copié ! ", this.ToastTabSucess)
      } catch (err) {
        console.error("Erreur de copie :", err);
      }
    },
    callback: function (args, add_dialog) {
      if (args.data !== null) {
        this.mes_parrainages()
      } else {
        this.add_dialog = add_dialog
      }
    },

    mes_parrainages() {
      Api()
        .get("parrainages/getbyuser/" + store.state.user._id)
        .then((response) => {
          this.nb_parrainer = response.data.length || 0
          this.user_parrainages = response.data
        }).catch(error => {
          this.user_parrainages = []
          this.nb_parrainer = 0
        })
    },
    get_my_coupon() {
      Api()
        .post("parrainages/getmycoupon", { _id: store.state.user._id })
        .then((response) => {
          if (response.data.code == 0) {
            this.coupon_parrainage = response.data.coupon
          }
        }).catch(error => {
          console.log('error => ', error)
        })
    },
    logout() {
      this.$store.state.isUserLoggedIn = false
      Api().get('user/logout/' + this.$store.state.user._id)
        .then(resp => {
          if (resp) {
            this.$store.dispatch('setToken', {});
            this.$store.dispatch('setUser', {});
            this.$store.dispatch('setDevis', null);
            this.$store.dispatch('setDevisPayement', null);
            this.$store.dispatch('setDevisPayementDiffere', null);
            localStorage.setItem('isLogged', false);
            localStorage.removeItem('canal');
            localStorage.removeItem('numdevis');
            localStorage.removeItem('amount')
            localStorage.removeItem('adressliv')
            localStorage.removeItem('Callback')
            localStorage.removeItem("passenger-birthady-age")
            localStorage.removeItem('loic')
            localStorage.removeItem('papa')
            localStorage.removeItem('UserArray')
            localStorage.removeItem('PaymentlinkId')

            localStorage.removeItem('InercomName');
            localStorage.removeItem('InercomEmail');
            localStorage.removeItem('InercomPhone');
            localStorage.removeItem('seturlapi');
            this.$router.go(this.$router.push('/'))
          } else {
            this.$store.dispatch('setToken', {});
            this.$store.dispatch('setUser', {});
            this.$store.dispatch('setDevis', null);
            this.$store.dispatch('setDevisPayement', null);
            this.$store.dispatch('setDevisPayementDiffere', null);

            localStorage.setItem('isLogged', false);
            localStorage.removeItem('canal');
            localStorage.removeItem('numdevis');
            localStorage.removeItem('amount')
            localStorage.removeItem('adressliv')
            localStorage.removeItem('Callback')
            localStorage.removeItem("passenger-birthady-age")
            localStorage.removeItem('loic')
            localStorage.removeItem('papa')
            localStorage.removeItem('UserArray')
            localStorage.removeItem('PaymentlinkId')

            localStorage.removeItem('InercomName');
            localStorage.removeItem('InercomEmail');
            localStorage.removeItem('InercomPhone');
            localStorage.removeItem('seturlapi');

            //this.$router.push('/')
            this.$router.go(this.$router.push('/'))
          }

        })
        .catch(err => {
          this.$store.dispatch('setToken', {});
          this.$store.dispatch('setUser', {});
          this.$store.dispatch('setDevis', null);
          this.$store.dispatch('setDevisPayement', null);
          this.$store.dispatch('setDevisPayementDiffere', null);
          this.$store.dispatch('setuser_quote_count', null);
          this.$store.dispatch('setuser_contract_count', null);

          localStorage.setItem('isLogged', false);
          localStorage.removeItem('canal');
          localStorage.removeItem('numdevis');
          localStorage.removeItem('amount')
          localStorage.removeItem('adressliv')
          localStorage.removeItem('Callback')
          localStorage.removeItem("passenger-birthady-age")
          localStorage.removeItem('loic')
          localStorage.removeItem('papa')
          localStorage.removeItem('UserArray')
          localStorage.removeItem('PaymentlinkId')

          localStorage.removeItem('InercomName');
          localStorage.removeItem('InercomEmail');
          localStorage.removeItem('InercomPhone');
          localStorage.removeItem('seturlapi');

          localStorage.removeItem('item_list_name')
          localStorage.removeItem('UserDevisCount')
          localStorage.removeItem('userContratCount')
          localStorage.removeItem('EcommercePushed')
          this.$router.go(this.$router.push('/'))
          //this.$router.push('/')
        })
    },
    loadPopUpForPhoneUpdate() {
      this.accountValidationDialog = true
    },

    fetchEventsList() {
      this.second_counter = this.second_counter - 1;
      if (this.second_counter == 0) {
        this.resend_code_ctlr = true
        this.indication = false
        clearInterval(this.timerInterval);
      }
    },

    async user_validation() {
      if (this.account_validation_code) {
        const data = {
          telephone_port: this.newphoneNumber,
          validation_code: this.account_validation_code,
        }

        Api().post('user/phoneupdate/validation', data)
          .then(async result => {
            if (result.data.n == 1 && result.data.nModified == 1) {
              this.$toasted.show("Votre numéro a été modifié avec succès ! ", this.ToastTabSucess)
              this.codesender = false
            }
          }).catch((err) => {
            this.$toasted.show("Erreur de connexion", this.ToastTabError)
          });
      } else {
        this.$toasted.show("Le code de validation est obligatoire ", this.ToastTabError)
      }

    },

    resend_new_code() {
      if (this.newphoneNumber != null && this.newphoneNumber != '') {
        const user = {
          userid: this.$store.state.user._id,
          telephone_port: this.newphoneNumber
        }
        Api().post('user/phoneupdate/newcode', user)
          .then((result) => {
            if (result.data.n == 1 && result.data.nModified == 1) {
              this.accountValidationDialog = false
              this.codesender = true
            } else if (result.data.msg) {
              this.$toasted.show(result.data.msg, this.ToastTabSucess)
            }
          }).catch((err) => {
            this.$toasted.show("Erreur de connexion serveur", this.ToastTabError)
          });
      } else {
        this.$toasted.show("Le numéro est obligatoire ", this.ToastTabError)
      }

    },

    allowCard() {
      try {
        if (this.current_partner.namePartner == "ASSURAF SN") {
          return true
        } else {
          return false
        }
      } catch (error) {
        console.log("Error")
      }
    },

    SwitchUser() {
      //this.dialogLoading = true
      const swith_data = {
        codep: this.current_partner.code_partenaire,
        //societe : this.current_partner.namePartner,
        email: this.$store.state.user.email,
        telephone: this.$store.state.user.telephone_port
      }
      Api().post('user/switch', swith_data)
        .then((resp) => {
          if (resp.data) {
            this.$store.dispatch('setUser', resp.data);
            //this.allowCard()
            this.GetAllUserDocument();
            this.getuserContrat();
            this.onMyDevis();
            this.getUserPoint();
            this.showAlertIcon();
            this.getListePartenaire()
            window.location.reload()
          } else {
            this.$toasted.show("Echec de l'opération !", this.ToastTabError);
          }
        });
    },

    goToSinistre() {
      this.$router.push("/sinistre");
    },

    ListingSinistre() {
      Api().get('sinistre/user/' + store.state.user._id)
          .then(response => {
            this.userSinistre = response.data.sinistres
            console.log('::::: user sinistre ::::::', this.userSinistre)
          });
    },

    disabledBeforeToday(date) {
      const today = new Date();
      return date > today;
    },

    get_type(val) {
      return typeof val;
    },

    /*==== Save the QM state ====*/
    SaveIndividuelAccidentQM(item) {
      Api()
        .post("/individuelaccident/mq/save", item)
        .then((result) => {
          this.$toasted.show(result.data.msg, this.ToastTabSucess);
          this.DetailContratMobilDialog = false;
        })
        .catch((err) => {
          this.$toasted.show("Erreur de connexion", this.ToastTabError);
        });
    },

    /*=== Generate QM PDF for Individuel Accident===*/
    GenerateIndividuelAccidentQM(item) {
      this.dialogLoading = true;
      Api()
        .post("/individuelaccident/generate/medical/questions", item)
        .then((resp) => {
          if (resp.data) {
            let url = resp.data.lien;
            let WinOpener = null
            this.dialogLoading = false, WinOpener = window.open(), WinOpener.location = url
          } else {
            this.$toasted.show("Echec de l'opération !", this.ToastTabError);
          }
        });
    },

    CheckValeurNeuf: function () {
      let trouver = 0;
      for (let index = 0; index < this.garanties.length; index++) {
        if (
          this.garanties[index] == "TIERCE COMPLETE" ||
          this.garanties[index] == "TIERCE COLLISION"
        ) {
          trouver = 1;
        }
      }

      if ((trouver == 1 && !this.valeur) || this.valeur == 0) {
        this.$toasted.show(
          "Veuiller saisir la valeur à neuf du véhicule ! ",
          this.ToastTabError
        );
      } else if (trouver == 1 && this.valeur && this.valeur != 0) {
        if (
          this.ContratForDetails.details[0].vehicules[0].valeur_venale <=
          this.valeur
        ) {
          this.VNeuf = false;
        } else {
          this.$toasted.show(
            "La valeur à neuf et la actuelle du véhicule ne sont pas cohérentes !",
            this.ToastTabError
          );
        }
      }
    },

    CheckValeurNeufMobile: function () {
      let trouver = 0;
      for (let index = 0; index < this.garanties.length; index++) {
        if (
          this.garanties[index] == "TIERCE COMPLETE" ||
          this.garanties[index] == "TIERCE COLLISION"
        ) {
          trouver = 1;
        }
      }

      if ((trouver == 1 && !this.valeur) || this.valeur == 0) {
        this.$toasted.show(
          "Veuiller saisir la valeur à neuf du véhicule ! ",
          this.ToastTabError
        );
      } else if (trouver == 1 && this.valeur && this.valeur != 0) {
        if (
          this.contratDetails.details[0].vehicules[0].valeur_venale <=
          this.valeur
        ) {
          this.VNeuf = false;
        } else {
          this.$toasted.show(
            "La valeur à neuf et la actuelle du véhicule ne sont pas cohérentes !",
            this.ToastTabError
          );
        }
      }
    },

    CloseModalVNeuf: function () {
      let trouver = 0;
      for (let index = 0; index < this.garanties.length; index++) {
        if (this.garanties[index] == "TIERCE COMPLETE") {
          trouver = 1;
        }
      }

      if ((trouver == 1 && !this.valeur) || this.valeur == 0) {
        if (this.garanties == this.packFull.packFullToutRisques.garanties) {
          this.garanties = [];
          this.text_packFull_1 = false;
        }
        if (this.garanties == this.packFull.packFullCollision.garanties) {
          this.garanties = [];
          this.text_packFull_2 = false;
        }
        this.garanties.pop();
        this.VNeuf = false;
      }
    },

    pushDetailVehicule() {
      if (
        this.garanties == this.packIntermediaire.garanties ||
        this.garanties == this.packStandart.garanties ||
        this.garanties == this.packAvance.garanties
      ) {
        const Oneauto = {
          categorie: this.ContratForDetails.details[0].vehicules[0].categorie,
          tonnage: this.ContratForDetails.details[0].vehicules[0].tonnage,
          optionUtilitaire:
            this.ContratForDetails.details[0].vehicules[0].optionUtilitaire,
          volumetrie2_roues:
            this.ContratForDetails.details[0].vehicules[0].volumetrie2_roues,
          optionPersoTrans:
            this.ContratForDetails.details[0].vehicules[0].optionPersoTrans,
          carburation:
            this.ContratForDetails.details[0].vehicules[0].carburation,
          type_vitre: this.ContratForDetails.details[0].vehicules[0].type_vitre,
          marque: this.ContratForDetails.details[0].vehicules[0].marque,
          carosserie: this.ContratForDetails.details[0].vehicules[0].carosserie,
          model: this.ContratForDetails.details[0].vehicules[0].model,
          force: this.ContratForDetails.details[0].vehicules[0].force,
          dateCircule:
            this.ContratForDetails.details[0].vehicules[0].dateCircule,
          age: this.ContratForDetails.details[0].vehicules[0].age,
          annee_mois: this.ContratForDetails.details[0].vehicules[0].annee_mois,
          nbplace: this.ContratForDetails.details[0].vehicules[0].nbplace,
          valeur: this.ContratForDetails.details[0].vehicules[0].valeur,
          valeur_venale:
            this.ContratForDetails.details[0].vehicules[0].valeur_venale,
          immatriculation:
            this.ContratForDetails.details[0].vehicules[0].immatriculation,
          flotte_mono:
            this.ContratForDetails.details[0].vehicules[0].flotte_mono,
          option_Individuel_Accident:
            this.ContratForDetails.details[0].vehicules[0]
              .option_Individuel_Accident,
          garanties: this.garanties,
        };

        this.ListAuto.push(Oneauto);
      } else {
        const Oneauto = {
          categorie: this.ContratForDetails.details[0].vehicules[0].categorie,
          tonnage: this.ContratForDetails.details[0].vehicules[0].tonnage,
          optionUtilitaire:
            this.ContratForDetails.details[0].vehicules[0].optionUtilitaire,
          volumetrie2_roues:
            this.ContratForDetails.details[0].vehicules[0].volumetrie2_roues,
          optionPersoTrans:
            this.ContratForDetails.details[0].vehicules[0].optionPersoTrans,
          carburation:
            this.ContratForDetails.details[0].vehicules[0].carburation,
          type_vitre: this.ContratForDetails.details[0].vehicules[0].type_vitre,
          marque: this.ContratForDetails.details[0].vehicules[0].marque,
          carosserie: this.ContratForDetails.details[0].vehicules[0].carosserie,
          model: this.ContratForDetails.details[0].vehicules[0].model,
          force: this.ContratForDetails.details[0].vehicules[0].force,
          dateCircule:
            this.ContratForDetails.details[0].vehicules[0].dateCircule,
          age: this.ContratForDetails.details[0].vehicules[0].age,
          annee_mois: this.ContratForDetails.details[0].vehicules[0].annee_mois,
          nbplace: this.ContratForDetails.details[0].vehicules[0].nbplace,
          valeur: this.ContratForDetails.details[0].vehicules[0].valeur,
          valeur_venale:
            this.ContratForDetails.details[0].vehicules[0].valeur_venale,
          immatriculation:
            this.ContratForDetails.details[0].vehicules[0].immatriculation,
          flotte_mono:
            this.ContratForDetails.details[0].vehicules[0].flotte_mono,
          option_Individuel_Accident:
            this.ContratForDetails.details[0].vehicules[0]
              .option_Individuel_Accident,
          garanties: this.ContratForDetails.details[0].vehicules[0].garanties,
        };
        this.ListAuto.push(Oneauto);
      }
    },

    pushDetailVehiculeMobile() {
      if (
        this.garanties == this.packIntermediaire.garanties ||
        this.garanties == this.packStandart.garanties ||
        this.garanties == this.packAvance.garanties
      ) {
        const Oneauto = {
          categorie: this.contratDetails.details[0].vehicules[0].categorie,
          tonnage: this.contratDetails.details[0].vehicules[0].tonnage,
          optionUtilitaire:
            this.contratDetails.details[0].vehicules[0].optionUtilitaire,
          volumetrie2_roues:
            this.contratDetails.details[0].vehicules[0].volumetrie2_roues,
          optionPersoTrans:
            this.contratDetails.details[0].vehicules[0].optionPersoTrans,
          carburation: this.contratDetails.details[0].vehicules[0].carburation,
          type_vitre: this.contratDetails.details[0].vehicules[0].type_vitre,
          marque: this.contratDetails.details[0].vehicules[0].marque,
          carosserie: this.contratDetails.details[0].vehicules[0].carosserie,
          model: this.contratDetails.details[0].vehicules[0].model,
          force: this.contratDetails.details[0].vehicules[0].force,
          dateCircule: this.contratDetails.details[0].vehicules[0].dateCircule,
          age: this.contratDetails.details[0].vehicules[0].age,
          annee_mois: this.contratDetails.details[0].vehicules[0].annee_mois,
          nbplace: this.contratDetails.details[0].vehicules[0].nbplace,
          valeur: this.contratDetails.details[0].vehicules[0].valeur,
          valeur_venale:
            this.contratDetails.details[0].vehicules[0].valeur_venale,
          immatriculation:
            this.contratDetails.details[0].vehicules[0].immatriculation,
          flotte_mono: this.contratDetails.details[0].vehicules[0].flotte_mono,
          option_Individuel_Accident:
            this.contratDetails.details[0].vehicules[0]
              .option_Individuel_Accident,
          garanties: this.garanties,
        };

        this.ListAuto.push(Oneauto);
      } else {
        const Oneauto = {
          categorie: this.contratDetails.details[0].vehicules[0].categorie,
          tonnage: this.contratDetails.details[0].vehicules[0].tonnage,
          optionUtilitaire:
            this.contratDetails.details[0].vehicules[0].optionUtilitaire,
          volumetrie2_roues:
            this.contratDetails.details[0].vehicules[0].volumetrie2_roues,
          optionPersoTrans:
            this.contratDetails.details[0].vehicules[0].optionPersoTrans,
          carburation: this.contratDetails.details[0].vehicules[0].carburation,
          type_vitre: this.contratDetails.details[0].vehicules[0].type_vitre,
          marque: this.contratDetails.details[0].vehicules[0].marque,
          carosserie: this.contratDetails.details[0].vehicules[0].carosserie,
          model: this.contratDetails.details[0].vehicules[0].model,
          force: this.contratDetails.details[0].vehicules[0].force,
          dateCircule: this.contratDetails.details[0].vehicules[0].dateCircule,
          age: this.contratDetails.details[0].vehicules[0].age,
          annee_mois: this.contratDetails.details[0].vehicules[0].annee_mois,
          nbplace: this.contratDetails.details[0].vehicules[0].nbplace,
          valeur: this.contratDetails.details[0].vehicules[0].valeur,
          valeur_venale:
            this.contratDetails.details[0].vehicules[0].valeur_venale,
          immatriculation:
            this.contratDetails.details[0].vehicules[0].immatriculation,
          flotte_mono: this.contratDetails.details[0].vehicules[0].flotte_mono,
          option_Individuel_Accident:
            this.contratDetails.details[0].vehicules[0]
              .option_Individuel_Accident,
          garanties: this.ContratForDetails.details[0].vehicules[0].garanties,
        };
        this.ListAuto.push(Oneauto);
      }
    },

    showGaranties() {
      if (this.garanties == this.packStandart.garanties) {
        this.optionPersoTrans = "option 1";
        this.text_packStandart = true;
        this.text_packInter = false;
        this.text_packAvance = false;
        this.offre_pack_full = false;
        this.text_packFull_1 = false;
        this.text_packFull_2 = false;
        this.text_packFull_3 = false;
        this.offre_full = false;
      } else if (this.garanties == this.packIntermediaire.garanties) {
        this.optionPersoTrans = "option 1";
        this.text_packStandart = false;
        this.text_packInter = true;
        this.text_packAvance = false;
        this.offre_pack_full = false;
        this.text_packFull_1 = false;
        this.text_packFull_2 = false;
        this.text_packFull_3 = false;
        this.offre_full = false;
      } else if (this.garanties == this.packAvance.garanties) {
        this.optionPersoTrans = "option 1";
        this.capital_AvRec = "500000";
        this.text_packStandart = false;
        this.text_packInter = false;
        this.text_packAvance = true;
        this.offre_pack_full = false;
        this.text_packFull_1 = false;
        this.text_packFull_2 = false;
        this.text_packFull_3 = false;
        this.offre_full = false;
      } else if (this.garanties == this.packFull) {
        this.text_packStandart = false;
        this.text_packInter = false;
        this.text_packAvance = false;
        this.offre_full = true;
      }
    },

    ValeurNeufModalFunction() {
      let trouver = 0;
      for (let index = 0; index < this.garanties.length; index++) {
        if (this.garanties[index] == "TIERCE COMPLETE") {
          trouver = 1;
        } else if (this.garanties[index] == "TIERCE COLLISION") {
          trouver = 2;
        }
      }
      if (trouver == 1 || trouver == 2) {
        this.VNeuf = true;
      } else {
        this.valeur = this.neant;
      }
    },

    showGarantiesPackFull() {
      if (this.garanties == this.packFull.packFullToutRisques.garanties) {
        this.optionPersoTrans = "option 1";
        this.capital_AvRec = "500000";
        this.ValeurNeufModalFunction();

        this.text_packFull_1 = true;
        this.text_packFull_2 = false;
        this.text_packFull_3 = false;
      } else if (this.garanties == this.packFull.packFullCollision.garanties) {
        this.optionPersoTrans = "option 1";
        this.capital_AvRec = "500000";
        this.ValeurNeufModalFunction();
        this.text_packFull_1 = false;
        this.text_packFull_2 = true;
        this.text_packFull_3 = false;
      }
    },

    ajoutGaranties() {
      const Oneauto = {
        categorie: this.ContratForDetails.details[0].vehicules[0].categorie,
        tonnage: this.ContratForDetails.details[0].vehicules[0].tonnage,
        optionUtilitaire:
          this.ContratForDetails.details[0].vehicules[0].optionUtilitaire,
        volumetrie2_roues:
          this.ContratForDetails.details[0].vehicules[0].volumetrie2_roues,
        optionPersoTrans:
          this.ContratForDetails.details[0].vehicules[0].optionPersoTrans,
        carburation: this.ContratForDetails.details[0].vehicules[0].carburation,
        type_vitre: this.ContratForDetails.details[0].vehicules[0].type_vitre,
        marque: this.ContratForDetails.details[0].vehicules[0].marque,
        carosserie: this.ContratForDetails.details[0].vehicules[0].carosserie,
        model: this.ContratForDetails.details[0].vehicules[0].model,
        force: this.ContratForDetails.details[0].vehicules[0].force,
        dateCircule: this.ContratForDetails.details[0].vehicules[0].dateCircule,
        age: this.ContratForDetails.details[0].vehicules[0].age,
        annee_mois: this.ContratForDetails.details[0].vehicules[0].annee_mois,
        nbplace: this.ContratForDetails.details[0].vehicules[0].nbplace,
        valeur: this.ContratForDetails.details[0].vehicules[0].valeur,
        valeur_venale:
          this.ContratForDetails.details[0].vehicules[0].valeur_venale,
        immatriculation:
          this.ContratForDetails.details[0].vehicules[0].immatriculation,
        flotte_mono: this.ContratForDetails.details[0].vehicules[0].flotte_mono,
        option_Individuel_Accident:
          this.ContratForDetails.details[0].vehicules[0]
            .option_Individuel_Accident,
        garanties: this.garanties,
      };

      //this.ListAuto.push(Oneauto);
    },

    getDevis() {
      Api()
        .get("devis/")
        .then((response) => {
          this.$store.dispatch("setDevisPayement", response.data);
          this.$router.push("/payement");
        });
    },

    /*=================Verification de la session de l'utilisateur et envoie des donnees==============*/
    reNewContrat: function () {
      if (this.dateEffet && this.duree) {
        const OneautoToSave = {
          userid: store.state.user._id,
          dateEffet: this.dateEffet,
          createur: store.state.user._id,
          dateEcheance: this.dateEcheance,
          dateSouscription: dayjs(new Date()).format("YYYY-MM-DD"),
          branche: "Automobile",
          duree: this.duree,
          vehicule: this.ListAuto,
          assureurs: [this.ContratForDetails.partenaireid.societe],

          proprietaire: {
            prenom: this.$store.state.user.prenom,
            nom: this.$store.state.user.nom,
          },
        };
        this.pushDetailVehicule();
        Api()
          .post("devis/add", OneautoToSave)
          .then((result) => {
            if (result.data.message) {
              let GtmVal = {
                branche: "automobile",
                entry_point: localStorage.getItem("quoteCreationEntryPoint"),
                insurer_number: this.assureurs.length,
                event: "quote_creation",
              };

              PushInDataLayer(GtmVal);

              Api()
                .get("devis/" + result.data.result.devis[0]._id)
                .then((response) => {
                  if (
                    this.garanties == this.packIntermediaire.garanties ||
                    this.garanties == this.packStandart.garanties ||
                    this.garanties == this.packAvance.garanties
                  ) {
                    response.data.devis.vehicules[0].garanties = this.garanties;
                  }
                  this.$store.dispatch("setDevisPayement", response.data);
                  this.$router.push("/payement");
                });
            }
          });
      } else {
        this.$toasted.show(
          "Durée et date d'échéance obligatoires !",
          this.ToastTabError
        );
      }
    },

    /*=================Verification de la session de l'utilisateur et envoie des donnees==============*/
    reNewContratMobile: function () {
      if (this.dateEffet && this.duree) {
        const OneautoToSave = {
          userid: store.state.user._id,
          dateEffet: this.dateEffet,
          createur: store.state.user._id,
          dateEcheance: this.dateEcheance,
          dateSouscription: dayjs(new Date()).format("YYYY-MM-DD"),
          branche: "Automobile",
          duree: this.duree,
          vehicule: this.ListAuto,
          assureurs: [this.contratDetails.partenaireid.societe],

          proprietaire: {
            prenom: this.$store.state.user.prenom,
            nom: this.$store.state.user.nom,
          },
        };
        this.pushDetailVehiculeMobile();
        Api()
          .post("devis/add", OneautoToSave)
          .then((result) => {
            if (result.data.message) {
              let GtmVal = {
                branche: "automobile",
                entry_point: localStorage.getItem("quoteCreationEntryPoint"),
                insurer_number: this.assureurs.length,
                event: "quote_creation",
              };

              PushInDataLayer(GtmVal);

              Api()
                .get("devis/" + result.data.result.devis[0]._id)
                .then((response) => {
                  if (
                    this.garanties == this.packIntermediaire.garanties ||
                    this.garanties == this.packStandart.garanties ||
                    this.garanties == this.packAvance.garanties
                  ) {
                    response.data.devis.vehicules[0].garanties = this.garanties;
                  }
                  this.$store.dispatch("setDevisPayement", response.data);
                  this.$router.push("/payement");
                });
            }
          });
      } else {
        this.$toasted.show(
          "Durée et date d'échéance obligatoires !",
          this.ToastTabError
        );
      }
    },

    /*=================Recuperation des partenaires assureurs==============*/
    getListePartenaire: function () {
      Api()
        .get("/partenaire/partners/auto")
        .then((response) => {
          this.listeAssureurs = response.data.partenaires;
        });
    },

    dateDiff: function () {
      if (
        this.paymentContrat.dateEffet === "" &&
        this.paymentContrat.duree === ""
      )
        this.paymentContrat.dateEcheance = "";
      let inter = dayjs(this.paymentContrat.dateEffet)
        .add(this.paymentContrat.duree, "month")
        .format("YYYY-MM-DD");
      this.paymentContrat.dateEcheance = dayjs(inter)
        .add(-1, "day")
        .format("YYYY-MM-DD");
    },

    dateDiffForRenew: function () {
      if (this.dateEffet === "" && this.duree === "") this.dateEcheance = "";
      let inter = dayjs(this.dateEffet)
        .add(this.duree, "month")
        .format("YYYY-MM-DD");
      this.dateEcheance = dayjs(inter).add(-1, "day").format("YYYY-MM-DD");
    },

    zeroControl() {
      if (this.duree <= 0) {
        this.duree = null;
      }
    },

    numberMonth() {
      this.zeroControl();
      if (this.duree <= 12) {
        return true;
      } else {
        this.duree = null;
        return false;
      }
    },

    /*==Submit the full filled medical Questionnary==*/
    submitMedicalQuestion(item) {
      this.errors_tab = this.assure_care_qm_validator(item.details);
      if (this.errors_tab.length <= 0) {
        this.dialogLoading = true;
        Api()
          .post("/assurcare/build/qm", item)
          .then((result) => {
            let url = result.data.lien;
            this.dialogLoading = false, window.open(url)
          })
          .catch((err) => { });
      } else {
        this.dialogQm_validation = true;
      }
    },

    /*== Save medical questionnary state==*/
    SaveMedicalQuestion(item) {
      let myboject = {
        contratid: item._id,
        details: item.details,
      };

      Api()
        .post("/contrat/update/details", myboject)
        .then((result) => {
          this.$toasted.show(result.data.msg, this.ToastTabSucess);
        })
        .catch((err) => {
          this.$toasted.show("Http Error", this.ToastTabError);
        });
    },

    /*
     * Get all payment history for a contract @param : idC
     */
    GetReccuentPayByContrat(item) {
      let checher = item.numero_police.substr(0, 2);
      if (checher == "EP") {
        Api()
          .post("/recurrentpay/get/by/contratid", { id: item._id })
          .then((result) => {
            this.recurent_pay_history = result.data.payment;
          })
          .catch((err) => { });
      }
    },

    /*====================*/
    Intent_update_profil() {
      PushInDataLayer({
        user_id: store.state.user._id,
        event: "intent_update_profile",
      });
      this.dialog = false;
      this.dialogEditProfil = true;
    },

    /*==========================*/
    ViewMyProfil() {
      PushInDataLayer({
        user_id: store.state.user._id,
        event: "view_profile",
      });
      this.dialog = true;
    },

    goToPortefeuille() {
      this.$router.push({ name: 'portefeuille' })
    },

    /*=============================*/
    view_MyDevis_item_list() {
      let items = [];
      for (let v of this.userDevis) {
        if (this.ShowBtnOneDevis(v) == true) {
          items.push({
            item_name: "Assurance " + v.brancheid.branche.toLowerCase(),
            item_id: v.numeroDevis,
            price: Math.round(v.prime_ttc / 655.957),
            item_brand: v.partenaireid.societe,
            item_category: v.brancheid.branche,
            item_list_name: "Profil Mes devis",
            index: items.length,
            quantity: "1",
          });
        }
      }

      if (items.length >= 1) {
        PushInDataLayer({
          ecommerce: {
            items: items,
          },
          event: "view_item_list",
        });
      }

      PushInDataLayer({
        event: "view_quote_list",
        user_id: store.state.user._id,
        number_of_quote: this.userDevis.length,
      });

      this.ModalListeDevis = true;
    },

    view_MyContract() {
      PushInDataLayer({
        user_id: store.state.user._id,
        number_of_contractsx: this.userContrat.length,
        event: "view_contracts",
      });
      this.ModalListeContrat = true;
      this.ListeContratMobilDialog = true;
    },

    view_my_parrainages() {
      // this.get_my_coupon();
      this.lien_parrain = lib.urlweb + 'p/' + this.userInfos.code_parrain
      this.add_dialog = true;
    },
    /***
     *Fonction permettant de payer un
     *un devis datant de moins de 24h
     *params @item
     ***/
    payInsurance(item) {

      localStorage.setItem("item_list_name", "Profil Mes devis");
      Api()
        .get("devis/" + item._id)
        .then((response) => {
          this.$store.dispatch("setDevisPayement", response.data);
          this.$router.push("/payement");
        });
    },

    payInsuranceCurrent(item) {
      localStorage.setItem("item_list_name", "Profil Mes devis");
      let br = item.brancheid.branche;

      if (br != "Santé") {
        Api()
          .post("/recurrentpay/get/by/contratid", { id: item._id })
          .then((response) => {
            if (response.data.payment.length > 0) {
              Api()
                .get("/contrat/" + item._id)
                .then((result) => {
                  let counter = response.data.payment.length + 1;
                  result.data.contrats.numero_police =
                    result.data.contrats.numero_police + "/" + counter;
                  localStorage.setItem(
                    "ReccurentPayItem",
                    JSON.stringify(result.data.contrats)
                  );
                  this.$store.dispatch(
                    "setDevisPayement",
                    result.data.contrats
                  );
                  this.$router.push("/reccurent/pay");
                })
                .catch((err) => { });
            } else {
              let newIncremnt = item.numero_police + "/01";
              item.numero_police = newIncremnt;
              localStorage.setItem("ReccurentPayItem", JSON.stringify(item));
              this.$store.dispatch("setDevisPayement", item);
              this.$router.push("/reccurent/pay");
            }
          });
      } else {
        alert("Bientôt disponible ...");
      }
    },

    /***Check if The devis is dated of less than 24h to show payment button***/
    ShowBtnOneContrat(item) {
      if (item.numero_police.substr(0, 2) == "EP") {
        return true;
      } else {
        return false;
      }
    },

    ShowBtnPaymentContrat(item) {
      const _MS_EN_DAY = 1000 * 60 * 60 * 24;
      const date = new Date();
      const echeance = new Date(item.dateEcheance);
      const diffDays = Math.ceil(Math.abs(date - echeance) / _MS_EN_DAY);

      if (diffDays < 30 && item.brancheid.branche == "Automobile") {
        this.alert = true;
        return true;
      } else if (diffDays < -10 && item.brancheid.branche == "Automobile") {
        return false;
        this.alert = false;
      }
      return false;
      this.alert = false;
    },

    ShowBtnPaymentContratMobile() {
      const _MS_EN_DAY = 1000 * 60 * 60 * 24;
      const date = new Date();
      const echeance = new Date(this.contratDetails.dateEcheance);
      const diffDays = Math.ceil(Math.abs(date - echeance) / _MS_EN_DAY);

      if (
        diffDays < 30 &&
        this.contratDetails.brancheid.branche == "Automobile"
      ) {
        return true;
        this.alert = true;
      } else if (
        diffDays < -10 &&
        this.contratDetails.brancheid.branche == "Automobile"
      ) {
        return false;
        this.alert = false;
      }
      return false;
      this.alert = false;
    },

    showAlertIcon() {
      Api()
        .get("contrat/user/" + store.state.user._id)
        .then((response) => {
          this.userContrat = response.data.contrats;
          for (let v of this.userContrat) {
            const _MS_EN_DAY = 1000 * 60 * 60 * 24;
            const date = new Date();
            const echeance = new Date(v.dateEcheance);
            const diffDays = Math.ceil(Math.abs(date - echeance) / _MS_EN_DAY);

            if (diffDays < 30 && v.brancheid.branche == "Automobile") {
              this.alert = true;
              this.nbreContratExpir.push(diffDays);
              let nombre = 0;
              for (let v of this.nbreContratExpir) {
                if (v < 30) {
                  nombre++;
                }
              }
              this.nombre = nombre;
            } else if (diffDays < -10 && v.brancheid.branche == "Automobile") {
              this.alert = false;
            } else {
              this.alert = false;
            }
          }
        });
    },

    async modalPaymentContrat(item) {
      try {
        const { data } = await Api().post('contrat/getlien/renew', { _id: item._id });
        if (data.lien) {
          window.location.replace(data.lien);
        } else {
          this.$toasted.show("Lien introuvable", this.ToastTabError);
        }
      } catch (error) {
        this.$toasted.show("Une erreur est survenue", this.ToastTabError);
      }
    },

    modalPaymentContratMobile() {
      this.paymentContrat;
      this.dateEffet = dayjs(this.contratDetails.dateEcheance)
        .add(+1, "day")
        .format("YYYY-MM-DD");
      this.dialogPaymentContrat = true;
    },

    /***Check if The devis is dated of less than 24h to show payment button***/
    ShowBtnOneDevis(item) {
      // for show btn payment
      if (item.payment) {
        return false
      }
      if (item.dateEffet) {
        let inter_date_spliter = item.dateEffet.split("T");
        let inter_date = inter_date_spliter[0];
        let duree = dayjs(new Date(inter_date + "T23:59:00.00Z")).diff(
          new Date(),
          "minute"
        );
        if (duree > 0 || item.numeroDevis.substr(0, 2) == "EP") {
          return true;
        } else {
          return false;
        }
      }
    },

    /*=============Filtre sans le + sur le input telephone a la modification de son profil ===========*/
    onlyNumber($event) {
      let NumOnly = $event.NumOnly ? $event.NumOnly : $event.which;
      if ((NumOnly < 48 || NumOnly > 57) && NumOnly !== 46) {
        $event.preventDefault();
      }
    },

    Redirection(page) {
      switch (page) {
        case "assurclub":
          this.$router.go(
            this.$router.push({
              name: "assurclub",
            })
          );
          break;
        case "sinistre":
          this.$router.go(
            this.$router.push({
              name: "sinistre",
            })
          );
          break;
        case "historique":
          this.$router.go(
            this.$router.push({
              name: "historique_sinistre",
            })
          );
          break;

        default:
          break;
      }
    },

    //  function allow user to update his profil informations
    userUpdate: function () {
      if (this.date) {
        this.userInfos.datenaissance = this.date;
      }
      if (this.userInfos.nom && this.userInfos.prenom) {
        if (this.userInfos.piece_identite && this.userInfos.numero_piece) {
          if (this.userInfos.telephone_port) {
            if (this.userInfos.adresse && this.userInfos.email) {
              if ((this.userInfos.datenaissance && !this.date) || (this.userInfos.datenaissance && this.date)) {
                this.userInfos.datenaissance = this.date;
                delete this.userInfos.role
                Api().post("user/" + store.state.user._id, this.userInfos)
                  .then((response) => {
                    if (response.data) {
                      PushInDataLayer({ event: "update_profile", user_id: store.state.user._id, });
                      this.$store.dispatch("setUser", response.data);
                      this.$toasted.show("Vos informations ont été mis à jour !", this.ToastTabSucess);
                      this.dialogEditProfil = false;
                    }
                  });
              } else {
                this.$toasted.show(
                  "Veuillez remplir tous les champs",
                  this.ToastTabError
                );
              }
            } else {
              this.$toasted.show(
                "Veuillez remplir tous les champs",
                this.ToastTabError
              );
            }
          } else {
            this.$toasted.show(
              "Veuillez remplir tous les champs",
              this.ToastTabError
            );
          }
        } else {
          this.$toasted.show(
            "Veuillez remplir tous les champs",
            this.ToastTabError
          );
        }
      } else {
        this.$toasted.show(
          "Veuillez remplir tous les champs",
          this.ToastTabError
        );
      }
    },

    AddDocument() {
      if (this.type_de_document && this.$refs.document.files[0]) {
        let file = this.$refs.document.files[0];
        let formData = new FormData();
        const FileInput = this.$refs.document;

        formData.append("document", file);
        formData.append("userid", store.state.user._id);
        formData.append("type_document", this.type_de_document);
        Api()
          .post("userdocument/add/", formData, {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          })
          .then((response) => {
            this.GetAllUserDocument();
            if (response.data.msgsucc) {
              this.$toasted.show(response.data.msgsucc, this.ToastTabSucess);
              FileInput.type = "text";
              FileInput.type = "file";
              this.type_de_document = "";
              this.selectedFiles = "";
            } else if (response.data.msgerr) {
              this.$toasted.show(response.data.msgsucc, this.ToastTabSucess);
            }
          });
      } else {
        this.$toasted.show(
          "Le type de fichier et le fichier sont obligatoire !",
          this.ToastTabError
        );
      }
    },

    ShowSelectedFile() {
      if (this.$refs.document.files[0]) {
        this.selectedFiles = this.$refs.document.files[0].name;
      }
    },

    // Send User contrat's by email
    SendContratByEmail(item) {
      Api()
        .post("contrat/bymail/" + item._id)
        .then((response) => {
          if (response.data.info == "ok") {
            this.$toasted.show("Opération effectuée !", this.ToastTabSucess);
          } else if (response.data.info == "nok") {
            this.$toasted.show("Echec de l'opération !", this.ToastTabError);
          }
        });
    },

    // Get all user document
    GetAllUserDocument() {
      Api()
        .get("userdocument/getall/" + store.state.user._id)
        .then((response) => {
          this.userDocument = response.data.documentLink;
        });
    },

    //Date object formater to String
    DateFormater: function (TheDate) {
      if (TheDate) {
        return dayjs(TheDate).format("DD-MM-YYYY");
      }
    },

    /* Retourne true ou false si nous sommes sur un mobile */
    isMobile: function () {
      if (screen.width <= 768) {
        return true;
      } else {
        return false;
      }
    },

    // Retelechargement de l'attestation provisoire depuis l'API
    DownloadAttestation(item) {
      if (item.lien_contrat) {
        this.DetailContratMobilDialog = false;
        let url = item.lien_contrat;
        this.dialogLoading = true;
        let WinOpener = null
        setTimeout(() => (this.dialogLoading = false, WinOpener = window.open(), WinOpener.location = url), 1000)
      } else {
        Api().get("contrat/attestation/download/" + item._id).then((resp) => {
          if (resp.data) {
            this.DetailContratMobilDialog = false;
            let url = resp.data.lien;
            this.dialogLoading = true;
            let WinOpener = null
            setTimeout(() => (this.dialogLoading = false, WinOpener = window.open(), WinOpener.location = url), 1000)
          } else {
            this.$toasted.show("Echec de l'opération !", this.ToastTabError);
          }
        })
      }

    },
    DownloadAttestationV2(item) {
     const attestationLink = this.getAttestationLink(item);
      if (attestationLink) {
        this.DetailContratMobilDialog = false;
        this.dialogLoading = true;
        let WinOpener = null
        setTimeout(() => (this.dialogLoading = false, WinOpener = window.open(), WinOpener.location = attestationLink), 1000)
      } else {
        Api().get("contrat/attestation/download/" + item._id).then((resp) => {
          if (resp.data) {
            this.DetailContratMobilDialog = false;
            let url = resp.data.lien;
            this.dialogLoading = true;
            let WinOpener = null
            setTimeout(() => (this.dialogLoading = false, WinOpener = window.open(), WinOpener.location = url), 1000)
          } else {
            this.$toasted.show("Echec de l'opération !", this.ToastTabError);
          }
        })
      }

    },

    // Retelechargement de devis depuis l'API
    /**
     * Telecharge la facture d'un devis (CFW-16).
     *
     * L'API renvoie le PDF dans le corps de la reponse, pas un lien : le
     * conteneur qui l'heberge est ephemere. Le numero de facture est attribue
     * a cette premiere edition et revient dans `X-Numero-Facture` ; on
     * l'affiche aussitot sans relire le devis.
     */
    async DownloadFactureDevis(item) {
      // Le rendu du PDF prend plusieurs secondes : sans ce verrou, un second
      // clic lancerait une seconde generation et un second telechargement.
      if (this.factureEnCours) return
      this.factureEnCours = true

      try {
        const reponse = await Api().get('devis/' + item._id + '/facture', { responseType: 'blob' })
        const numero = reponse.headers['x-numero-facture'] || item.numeroFacture

        // `$set` : la cle est absente des devis jamais factures, et Vue 2 ne
        // rendrait pas reactive une propriete ajoutee apres coup.
        if (numero) this.$set(item, 'numeroFacture', numero)

        const blob = new Blob([reponse.data], { type: 'application/pdf' })
        const url = window.URL.createObjectURL(blob)
        const lien = document.createElement('a')
        lien.href = url
        lien.download = (numero || 'facture') + '.pdf'
        document.body.appendChild(lien)
        lien.click()
        document.body.removeChild(lien)
        window.URL.revokeObjectURL(url)
      } catch (erreur) {
        this.$toasted.show(await this.MessageErreurFacture(erreur), this.ToastTabError)
      } finally {
        this.factureEnCours = false
      }
    },

    /**
     * Extrait le motif du refus renvoye par l'API.
     *
     * La requete etant en `responseType: 'blob'`, le corps d'erreur — du JSON —
     * arrive lui aussi en Blob : sans cette relecture l'utilisateur verrait
     * « [object Blob] » a la place du message.
     */
    async MessageErreurFacture(erreur) {
      const reponse = erreur && erreur.response
      const generique = this.$t('espace_perso.detail_devis.facture_erreur_label')
      if (!reponse) return generique

      try {
        const corps = JSON.parse(await reponse.data.text())
        if (corps && corps.message && corps.message !== 'RUAD') return corps.message
      } catch (e) {
        // Corps illisible : on retombe sur le message generique.
      }
      return generique
    },

    DownloadDevis(item) {
      let Gtmval = {
        branche: item.brancheid.branche.toLowerCase(),
        insurer_name: item.partenaireid.societe,
        price: item.prime_ttc,
        event: "download_quote",
      };
      PushInDataLayer(Gtmval);
       this.dialogLoading = true;
      Api()
        .get("devis/download/" + item._id)
        .then((resp) => {
          if (resp.data) {
            let url = resp.data.lien;
            let WinOpener = null
            this.dialogLoading = false, WinOpener = window.open(), WinOpener.location = url
          } else {
            this.$toasted.show("Echec de l'opération !", this.ToastTabError);
          }
        });
    },

    downloadVoyageFileContrat(item) {
      window.open(item);
    },
    getAttestationLink(contrat) {
     if (!contrat || !Array.isArray(contrat.details)) return null;
      const obj = contrat.details.find(
        d => d && d.attestation_digitale && d.attestation_digitale.linkAttestation
      );
      if (obj && obj.attestation_digitale && obj.attestation_digitale.linkAttestation) {
        const attestationLink = obj.attestation_digitale.linkAttestation;
        this.attestationLink = attestationLink;
        return attestationLink;
      }
    },
    // Télécharger le contrat provisoire 
    downloadContratProvisoire(contrat) {
      if (contrat.brancheid.branche == 'Voyage' && contrat.lien_contrat != null && contrat.police_assureur != null) {
        this.downloadVoyageFileContrat(contrat.lien_contrat);
      } else {
        this.DownloadAttestation(contrat);
      }
    },

    // Télécharger l'attestation provisoire
    downloadTalon(link) {
      if (link) {
        window.open(link, '_blank');
      } else {
        console.warn('Aucun lien attestation digitale trouvé.');
      }  
    },

    /*== fonction permettamnt de Manager la vue en detail  d'un devis ==*/
    /*== @param :item => le devis qu'on souhaite voir en detail ========*/
    DetailsDevisVue(item) {
      this.ModalListeDevis = false;
      this.DevisForDetails = item;
      this.DetailsDevis = true;
    },

    /*== fonction permettamnt de Manager la vue en detail  d'un contrat ==*/
    /*== @param :item => le contrat qu'on souhaite voir en detail ========*/
    DetailsContratVue(item) {
      this.GetReccuentPayByContrat(item);
      this.ModalListeContrat = false;
      this.ContratForDetails = item;
      this.DetailsContrat = true;
    },

    /*valider formulaire */
    submit() {
      this.$refs.form.validate();
    },

    clear() {
      this.$refs.form.reset();
    },

    /* Retourne true ou false si nous sommes sur un PC */
    isDesktop: function () {
      if (screen.width > 768) {
        return true;
      } else {
        return false;
      }
    },

    //  The function which allow user to update his profil picture
    UpdateUserPicture: function () {
      let file = this.$refs.file.files[0];

      if (!file.length) return;
      this.createImage(file[0]);
      let formData = new FormData();
      formData.append("photo", file);
      formData.append("user", store.state.user._id);
      Api()
        .post("user/updatepicture/", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then((response) => {
          this.ServerRep = response.data; //.result.ok
        });
    },

    // Function to read the input picture from the user
    createImage(file) {
      const reader = new FileReader();
      const vm = this;
      reader.onload = (e) => {
        vm.image = e.target.result;
      };
      reader.readAsDataURL(file);
    },

    // Update user password
    userUpdatePassword: function () {
      if (this.password_new) {
        const params = {
          email: this.password_new,
        };
        Api()
          .post("user/resetpassword", params)
          .then((response) => {
            this.ServerRep = response.status;
            setTimeout(() => (this.logout()), 4000)

          });
      } else {
        this.$toasted.show(
          "Votre adresse email est obligatoire ",
          this.ToastTabError
        );
      }
    },

    //Send user's devis by email
    SendDevisByMail: function (devis) {
      let Gtmval = {
        branche: devis.brancheid.branche.toLowerCase(),
        insurer_name: devis.partenaireid.societe,
        price: devis.prime_ttc,
        event: "quote_by_mail",
      };
      PushInDataLayer(Gtmval);

      Api()
        .get("devis/mydevisbyemail/" + devis._id)
        .then((response) => {
          if (response.data.info == "ok") {
            this.$toasted.show(
              "Votre devis vous a été envoyé par mail !",
              this.ToastTabSucess
            );
          } else if (response.data.info == "nok") {
            this.$toasted.show(
              "L'envoi du devis par mail a échoué !",
              this.ToastTabError
            );
          }
        });
    },

    Contract_generator: function (contrat) {
      this.modalNumPolice = false;
      this.modalNumPoliceAttest = false;

      switch (contrat.brancheid.branche) {
        case "Automobile":
          let data = {
            idContrat: contrat.id,
            numpolice: this.NumPolice,
            numTalon: this.NumTalon,
          };
           this.modalgeneration = true;
          Api()
            .post("contrat/definitif/auto", data)
            .then((response) => {
              this.NumPolice = null;
              let url = response.data.lien;
              this.modalgeneration = false, window.open(url)
            });
          break;
        case "Habitation":
          this.modalgeneration = true;
          Api()
            .get("contrat/definitif/mrh/" + contrat.id)
            .then((response) => {
              let url = response.data.lien;
              this.modalgeneration = false, window.open(url)
            });
          break;
        case "Voyage":
          this.modalgeneration = true;
          let Traveldata = {
            idContrat: contrat.id,
            numpolice: this.NumPolice,
            numTalon: this.NumTalon,
          };
          Api()
            .post("contrat/definitif/voyage", Traveldata)
            .then((response) => {
              let url = response.data.lien;
              this.modalgeneration = false, window.open(url)
              
            });
          break;
      }
    },

    removeImage: function () { },

    //Get all user devis
    onMyDevis: function () {
      Api()
        .get("devis/mydevis/" + store.state.user._id)
        .then((response) => {
          this.userDevis = response.data.devis;
          this.nbDevis = response.data.count;

          // if (response.data.devis.length != 0) {
          //   this.userDevis = response.data.devis.filter(
          //     (devis) => devis.payment == false
          //   );
          // }
          // this.nbDevis = this.userDevis.length;
        });
    },

    //get user contrats
    getuserContrat() {
      Api()
        .get("contrat/user/" + store.state.user._id)
        .then((response) => {
          this.userContrat = response.data.contrats;
        });
    },

    //Get Devis details
    getItemDetail(detail) {
      this.ModalListeDevis = false;
      this.devisDetails = detail;
      this.detailsDevisDialog = true;
    },

    //Get Contart details
    getItemDetail2(details) {
      this.GetReccuentPayByContrat(details);
      this.ListeContratMobilDialog = false;
      this.contratDetails = details;
      this.DetailContratMobilDialog = true;
    },

    assistanceDialogManip() {
      this.name =
        store.state.user.prenom.toUpperCase() +
        "-" +
        store.state.user.nom.toUpperCase();
      this.tel = store.state.user.telephone_port;
      this.assistanceDialog = true;
    },

    // Demande assistances
    AddAssistance() {
      if (
        this.horaire &&
        this.canal &&
        this.name &&
        this.tel &&
        this.objetRappel &&
        this.remarques
      ) {
        const assist = {
          horaire: this.horaire,
          canal: this.canal,
          name: this.name,
          tel: this.tel,
          objetRappel: this.objetRappel,
          remarques: this.remarques,
          userid: store.state.user._id,
        };

        Api()
          .post("assistances/create", assist)
          .then((resp) => {
            if (resp.data.info == "ok") {
              this.$toasted.show(resp.data.msg, this.ToastTabSucess);
              this.assistanceDialog = false;
              this.horaire = "";
              this.canal = "";
              this.name = "";
              this.tel = "";
              this.objetRappel = "";
              this.remarques = "";
            } else if (resp.data.info == "nok") {
              this.$toasted.show(resp.data.msg, this.ToastTabError);
            }
          });
      } else {
        this.$toasted.show(
          "Tous les champs sont obligatoires !",
          this.ToastTabError
        );
      }
    },

    //Get user points Assuraf
    getUserPoint() {
      Api()
        .get("mespoint/mespoints/" + store.state.user._id)
        .then((rep) => {
          if (rep.data.mespoints) {
            this.UserPoints = rep.data.mespoints;
          }
        });

    },

    assure_care_qm_validator(persons) {
      let errors_tab = [];
      for (let p of persons) {
        for (let q of p.questionnaire_medical) {
          for (let index = 0; index < q.champs.length; index++) {
            if (q.numero > 1) {
              if (
                q.champs[0].reponse.toUpperCase() == "OUI" ||
                q.champs[0].reponse.toUpperCase() == ""
              ) {
                for (let c of q.champs) {
                  if (c.reponse == "") {
                    if (this.chackValue(c, p, errors_tab, q.numero) <= 0) {
                      errors_tab.push({
                        person: p.nom + "-" + p.prenom,
                        numero: q.numero,
                        question: c.question,
                      });
                    }
                  }
                }
              }
            }
          }
        }
      }
      return errors_tab;
    },

    /*== Check object value in an array ==*/
    chackValue(val, p, myarray, numero) {
      let found = 0;
      for (let v of myarray) {
        let valNom = p.nom + "-" + p.prenom;
        if (
          valNom == v.person &&
          v.numero == numero &&
          v.question == val.question
        ) {
          found++;
        }
      }

      return found;
    },

    getCurrentPartner(codep) {
      console.log(':::::: code partenaire ::::::::', codep)
      let searcher = null
      // for (let part of this.$store.state.user.affiliated_partner) {
      //   if (codep == part.code_partenaire) {
      //     searcher = part
      //   }
      // }
      return searcher
    }
  },

  computed: {
    ...mapGetters(["username"]),
  },

  mounted() {
    window.scrollTo(0, 0);
    this.ListingSinistre()
    if (this.$store.state.isUserLoggedIn && this.$store.state.user != null && this.$store.state.user != {}) {
      //this.current_partner = this.getCurrentPartner(this.$store.state.user.code_partenaire)

      this.userInfos = this.$store.state.user;
      this.primary_partner = this.$store.state.user.primary_partner
      this.affiliated_partner = this.$store.state.user.affiliated_partner
      this.get_my_coupon();
      this.GetAllUserDocument();
      this.getuserContrat();
      this.onMyDevis();
      this.getUserPoint();
      this.showAlertIcon();
      this.getListePartenaire();
      this.mes_parrainages();
      this.getDiscountRequest();

    } else {
      this.$router.push("/");
    }
  },
};
</script>

<!--suppress CssUnusedSymbol -->

<style scoped>
@import "../../assets/css/espacePerso.css";

.datatable-cell-wrapper {
  width: inherit;
  position: relative;
  padding: 0px 0px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.modern-btn {
  text-transform: none !important;
  letter-spacing: .2px !important;
  padding: 10px 18px !important;
  transition: box-shadow .2s ease, transform .06s ease !important;
}
.modern-btn:hover {
  box-shadow: 0 6px 16px rgba(0,0,0,.12) !important;
}
.modern-btn:active {
  transform: translateY(1px) !important;
}

.paralax-cover-image {
  background-image: url("../../assets/img/assurance/espace_perso.jpg");
  position: relative;
  background-size: contain !important;
  background-position: 50%;
  min-height: 230px;
  width: 100%;
  margin: 0 0 0;
  display: flex;
  /*padding: 20px;*/
  align-items: center;
  display: -webkit-box;
  display: -moz-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  -webkit-align-items: center;
  -moz-align-items: center;
  -ms-align-items: center;
}

.paralax-cover-image p {
  color: rgb(255, 255, 255);
  font-size: 20px;
  font-weight: 300;
}

.paralax-cover-image .paralax-cover-image-text,
.paralax-cover-image h2 {
  color: #fff;
  font-size: 2em;
  line-height: 1.25;
  z-index: 1;
  margin-bottom: 0;
  max-width: 610px;
  text-align: center;
  margin-left: 8.5%;
}

.paralax-cover-image.has-background-dim:before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.5);
}

.paralax-cover-image {
  background-attachment: fixed;
  background-position: 50% 40px;
}

.paralax-cover-image_mobile {
  background-image: url("../../assets/img/assurance/espace_perso_mobile.jpg");
  position: relative;
  background-size: contain;
  background-position: 50%;
  min-height: 150px;
  width: 100%;
  margin: 0 0 0;
  display: flex;
  /*padding: 20px;*/
  align-items: center;
  display: -webkit-box;
  display: -moz-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  -webkit-align-items: center;
  -moz-align-items: center;
  -ms-align-items: center;
}

.paralax-cover-image_mobile p {
  color: rgb(255, 255, 255);
  font-size: 20px;
  font-weight: 300;
  padding-bottom: 20px;
}

.paralax-cover-image_mobile .paralax-cover-image-text_mobile,
.paralax-cover-image_mobile h2 {
  color: #fff;
  font-size: 2em;
  line-height: 1.25;
  z-index: 1;
  margin-bottom: 0;
  max-width: 610px;
  text-align: center;
  margin-left: 8.5%;
}

.paralax-cover-image_mobile.has-background-dim_mobile:before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.5);
}

.paralax-cover-image_mobile {
  /* background-attachment: fixed; */
  background-position: 100% 40px;
}

/*== start of code for tooltips ==*/
.tool {
  cursor: help;
  position: relative;
}

/*== common styles for both parts of tool tip ==*/
.tool::before,
.tool::after {
  left: 50%;
  opacity: 0;
  position: absolute;
  z-index: -100;
}

.tool:hover::before,
.tool:focus::before,
.tool:hover::after,
.tool:focus::after {
  opacity: 1;
  transform: scale(1) translateY(0);
  z-index: 100;
}

/*== pointer tip ==*/
.tool::before {
  border-style: solid;
  border-width: 1em 0.75em 0 0.75em;
  border-color: #565c61 transparent transparent transparent;
  bottom: 120%;
  content: "";
  margin-left: -0.5em;
  transition: all 0.65s cubic-bezier(0.84, -0.18, 0.31, 1.26),
    opacity 0.65s 0.5s;
  transform: scale(0.6) translateY(-90%);
}

.tool:hover::before,
.tool:focus::before {
  transition: all 0.65s cubic-bezier(0.84, -0.18, 0.31, 1.26) 0.2s;
}

/*== speech bubble ==*/
.tool::after {
  background: #565c61;
  border-radius: 0.25em;
  bottom: 176%;
  color: #edeff0;
  font-size: 15px;
  content: attr(data-tip);
  margin-left: -8.75em;
  padding: 1em;
  transition: all 0.65s cubic-bezier(0.84, -0.18, 0.31, 1.26) 0.2s;
  transform: scale(0.6) translateY(50%);
  width: 17.5em;
}

.tool:hover::after,
.tool:focus::after {
  transition: all 0.65s cubic-bezier(0.84, -0.18, 0.31, 1.26);
}

@media (max-width: 760px) {
  .tool::after {
    font-size: 0.75em;
    margin-left: -5em;
    width: 10em;
  }
}

/*== start of code for tooltips ==*/
.tool_button {
  cursor: help;
  position: relative;
}

/*== common styles for both parts of tool tip ==*/
.tool_button::before,
.tool_button::after {
  left: 50%;
  opacity: 0;
  position: absolute;
  z-index: -100;
}

.tool_button:hover::before,
.tool_button:focus::before,
.tool_button:hover::after,
.tool_button:focus::after {
  opacity: 1;
  transform: scale(1) translateY(0);
  z-index: 10000;
}

/*== pointer tip ==*/
.tool_button::before {
  border-style: solid;
  border-width: 1em 0.75em 0 0.75em;
  border-color: #565c61 transparent transparent transparent;
  bottom: 120%;
  content: "";
  margin-left: -0.5em;
  transition: all 0.65s cubic-bezier(0.84, -0.18, 0.31, 1.26),
    opacity 0.65s 0.5s;
  transform: scale(0.6) translateY(-90%);
}

.tool_button:hover::before,
.tool_button:focus::before {
  transition: all 0.65s cubic-bezier(0.84, -0.18, 0.31, 1.26) 0.2s;
}

/*== speech bubble ==*/
.tool_button::after {
  background: #565c61;
  border-radius: 0.25em;
  bottom: 176%;
  color: #edeff0;
  font-size: 15px;
  content: attr(data-tip);
  margin-left: -8.75em;
  padding: 1em;
  transition: all 0.65s cubic-bezier(0.84, -0.18, 0.31, 1.26) 0.2s;
  transform: scale(0.6) translateY(50%);
  width: 11.5em;
}

.tool_button:hover::after,
.tool_button:focus::after {
  transition: all 0.65s cubic-bezier(0.84, -0.18, 0.31, 1.26);
}

@media (max-width: 760px) {
  .tool_button::after {
    font-size: 0.75em;
    margin-left: -5em;
    width: 10em;
  }
}















/* 
.copy--status--bubble .check-circle {
  background: #333;
  border-radius: 100%;
  height: 2rem;
  width: 2rem;
  display: -webkit-box;
  display: flex;
  -webkit-box-pack: center;
          justify-content: center;
  -webkit-box-align: center;
          align-items: center;
  margin-right: 1rem;
}
.status--fade--in {
  -webkit-transform: translateX(0rem);
          transform: translateX(0rem);
  opacity: 1;
} */
.btn {
  background: transparent;
  border: none;
  border-radius: 100%;
  cursor: pointer;
  position: relative;
  margin-left: -20px !important;
}

.btn:hover::after {
  content: "Copier le code";
  color: #000;
  background: #ffa409;
  padding: 0.5rem;
  border-radius: 0.5rem;
  position: absolute;
  left: 10%;
  top: -60%;
}

.img-icone:hover img {
  filter: brightness(0) invert(1);
}

.loading-state {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.8);
  z-index: 9999;
  display: flex;
  justify-content: center;
  align-items: center;
  
}
.loading {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  border: 5px solid #ddd;
  border-top-color: #ffa409;
  animation: loading 1s linear infinite;
}
@keyframes loading {
  to {
    transform: rotate(360deg);
  }
}
.loading-text{
    color: rgb(255, 255, 255);
    font-weight: bold;
}





























 .tabs {
	 left: 50%;
	 transform: translateX(-50%);
	 position: relative;
	 background: white;
	 padding: 30px;
	 /* padding-bottom: 80px; */
	 /* width: 70%; */
	 height: auto;
	 /* box-shadow: 0 14px 28px rgba(0, 0, 0, 0.25), 0 10px 10px rgba(0, 0, 0, 0.22); */
	 border-radius: 5px;
	 min-width: 240px;
}
 .tabs input[name="tab-control"] {
	 display: none;
}

/* .tabs .content section:hover {
  color: #fff;
} */
 .tabs .content section h2, .tabs ul li label {
	 /* font-family: "Montserrat"; */
	 font-weight: bold;
	 font-size: 16px;
	 color: #ffa409;
}
 .tabs ul {
	 list-style-type: none;
	 padding-left: 0;
	 display: flex;
	 flex-direction: row;
	 margin-bottom: 10px;
	 justify-content: space-between;
	 align-items: flex-end;
	 flex-wrap: wrap;
}
 .tabs ul li {
	 box-sizing: border-box;
	 flex: 1;
	 width: 25%;
	 padding: 0 10px;
	 text-align: center;
}
 .tabs ul li label {
	 transition: all 0.3s ease-in-out;
	 color: #929daf;
	 padding: 5px auto;
	 overflow: hidden;
	 text-overflow: ellipsis;
	 display: block;
	 cursor: pointer;
	 transition: all 0.2s ease-in-out;
	 white-space: nowrap;
	 -webkit-touch-callout: none;
}
 .tabs ul li label br {
	 display: none;
}
 .tabs ul li label svg {
	 fill: #929daf;
	 height: 1.2em;
	 vertical-align: bottom;
	 margin-right: 0.2em;
	 transition: all 0.2s ease-in-out;
}
 .tabs ul li label:hover, .tabs ul li label:focus, .tabs ul li label:active {
	 outline: 0;
	 color: #bec5cf;
}
 .tabs ul li label:hover svg, .tabs ul li label:focus svg, .tabs ul li label:active svg {
	 fill: #bec5cf;
}
 .tabs .slider {
	 position: relative;
	 width: 25%;
	 transition: all 0.33s cubic-bezier(0.38, 0.8, 0.32, 1.07);
}
 .tabs .slider .indicator {
	 position: relative;
	 width: 50px;
	 max-width: 100%;
	 margin: 0 auto;
	 height: 3px;
	 background: #ffa409;
	 border-radius: 1px;
}
 .tabs .content {
	 margin-top: 30px;
}


 .tabs .content section {
	 display: none;
	 animation-name: content;
	 animation-direction: normal;
	 animation-duration: 0.3s;
	 animation-timing-function: ease-in-out;
	 animation-iteration-count: 1;
	 line-height: 1.4;
}
 .tabs .content section h2 {
	 color: #ffa409;
	 /* display: none; */
}
 .tabs .content section h2::after {
	 content: "";
	 position: relative;
	 display: block;
	 width: 30px;
	 height: 3px;
	 background: #ffa409;
	 margin-top: 5px;
	 left: 1px;
   color:#fff
}

.tabs .content section h4::after {
	 content: "";
	 position: relative;
	 display: block;
	 width: 30px;
	 height: 3px;
	 background: #fff;
	 margin-top: 5px;
	 left: 1px;
}
 .tabs input[name="tab-control"]:nth-of-type(1):checked ~ ul > li:nth-child(1) > label {
	 cursor: default;
	 color: #ffa409;
}
 .tabs input[name="tab-control"]:nth-of-type(1):checked ~ ul > li:nth-child(1) > label svg {
	 fill: #ffa409;
}
 @media (max-width: 600px) {
	 .tabs input[name="tab-control"]:nth-of-type(1):checked ~ ul > li:nth-child(1) > label {
		 background: rgba(0, 0, 0, 0.08);
	}
}
 .tabs input[name="tab-control"]:nth-of-type(1):checked ~ .slider {
	 transform: translateX(0%);
}
 .tabs input[name="tab-control"]:nth-of-type(1):checked ~ .content > section:nth-child(1) {
	 display: block;
}
 .tabs input[name="tab-control"]:nth-of-type(2):checked ~ ul > li:nth-child(2) > label {
	 cursor: default;
	 color: #ffa409;
}
 .tabs input[name="tab-control"]:nth-of-type(2):checked ~ ul > li:nth-child(2) > label svg {
	 fill: #ffa409;
}
 @media (max-width: 600px) {
	 .tabs input[name="tab-control"]:nth-of-type(2):checked ~ ul > li:nth-child(2) > label {
		 background: rgba(0, 0, 0, 0.08);
	}
}
 .tabs input[name="tab-control"]:nth-of-type(2):checked ~ .slider {
	 transform: translateX(100%);
}
 .tabs input[name="tab-control"]:nth-of-type(2):checked ~ .content > section:nth-child(2) {
	 display: block;
}
 .tabs input[name="tab-control"]:nth-of-type(3):checked ~ ul > li:nth-child(3) > label {
	 cursor: default;
	 color: #ffa409;
}
 .tabs input[name="tab-control"]:nth-of-type(3):checked ~ ul > li:nth-child(3) > label svg {
	 fill: #ffa409;
}
 @media (max-width: 600px) {
	 .tabs input[name="tab-control"]:nth-of-type(3):checked ~ ul > li:nth-child(3) > label {
		 background: rgba(0, 0, 0, 0.08);
	}
}
 .tabs input[name="tab-control"]:nth-of-type(3):checked ~ .slider {
	 transform: translateX(200%);
}
 .tabs input[name="tab-control"]:nth-of-type(3):checked ~ .content > section:nth-child(3) {
	 display: block;
}
 .tabs input[name="tab-control"]:nth-of-type(4):checked ~ ul > li:nth-child(4) > label {
	 cursor: default;
	 color: #ffa409;
}
 .tabs input[name="tab-control"]:nth-of-type(4):checked ~ ul > li:nth-child(4) > label svg {
	 fill: #ffa409;
}
 @media (max-width: 600px) {
	 .tabs input[name="tab-control"]:nth-of-type(4):checked ~ ul > li:nth-child(4) > label {
		 background: rgba(0, 0, 0, 0.08);
	}
}
 .tabs input[name="tab-control"]:nth-of-type(4):checked ~ .slider {
	 transform: translateX(300%);
}
 .tabs input[name="tab-control"]:nth-of-type(4):checked ~ .content > section:nth-child(4) {
	 display: block;
}
 @keyframes content {
	 from {
		 opacity: 0;
		 transform: translateY(5%);
	}
	 to {
		 opacity: 1;
		 transform: translateY(0%);
	}
}
 @media (max-width: 1000px) {
	 .tabs ul li label {
		 white-space: initial;
	}
	 .tabs ul li label br {
		 display: initial;
	}
	 .tabs ul li label svg {
		 height: 1.5em;
	}
}
 @media (max-width: 600px) {
	 .tabs ul li label {
		 padding: 5px;
		 border-radius: 5px;
	}
	 .tabs ul li label span {
		 display: none;
	}
	 .tabs .slider {
		 display: none;
	}
	 .tabs .content {
		 margin-top: 20px;
	}
	 .tabs .content section h2 {
		 display: block;
	}
}
 
</style>